// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from './client';
import type {
  TriggerErrorSentryDebugExceptionGetData,
  TriggerErrorSentryDebugExceptionGetResponses,
  LogErrorSentryDebugLogErrorGetData,
  LogErrorSentryDebugLogErrorGetResponses,
  HealthCheckHealthGetData,
  HealthCheckHealthGetResponses,
  LoginAuthLoginGetData,
  LoginAuthLoginGetResponses,
  AuthCallbackAuthCallbackGetData,
  AuthCallbackAuthCallbackGetResponses,
  AuthCallbackAuthCallbackGetErrors,
  LogoutAuthLogoutGetData,
  LogoutAuthLogoutGetResponses,
  GetCurrentCtxInfoAuthMeGetData,
  GetCurrentCtxInfoAuthMeGetResponses,
  GetCurrentCtxInfoAuthMeGetErrors,
  GetWidgetTokenAuthWidgetTokenGetData,
  GetWidgetTokenAuthWidgetTokenGetResponses,
  SwitchOrganizationAuthSwitchOrganizationPostData,
  SwitchOrganizationAuthSwitchOrganizationPostResponses,
  SwitchOrganizationAuthSwitchOrganizationPostErrors,
  GetUserOrganizationsAuthOrganizationsGetData,
  GetUserOrganizationsAuthOrganizationsGetResponses,
  GetActiveAttestationsSigningAttestationsActiveGetData,
  GetActiveAttestationsSigningAttestationsActiveGetResponses,
  GetEsignatureCredentialStatusSigningCredentialGetData,
  GetEsignatureCredentialStatusSigningCredentialGetResponses,
  SetEsignatureCredentialSigningCredentialPutData,
  SetEsignatureCredentialSigningCredentialPutResponses,
  SetEsignatureCredentialSigningCredentialPutErrors,
  ChangeEsignatureCredentialSigningCredentialChangePostData,
  ChangeEsignatureCredentialSigningCredentialChangePostResponses,
  ChangeEsignatureCredentialSigningCredentialChangePostErrors,
  RequestEsignatureCredentialResetSigningCredentialResetRequestPostData,
  RequestEsignatureCredentialResetSigningCredentialResetRequestPostResponses,
  CompleteEsignatureCredentialResetSigningCredentialResetPostData,
  CompleteEsignatureCredentialResetSigningCredentialResetPostResponses,
  CompleteEsignatureCredentialResetSigningCredentialResetPostErrors,
  GetIntakesForAuthManagementAuthorizationGetData,
  GetIntakesForAuthManagementAuthorizationGetResponses,
  GetIntakesForAuthManagementAuthorizationGetErrors,
  ListPermissionsRbacPermissionsGetData,
  ListPermissionsRbacPermissionsGetResponses,
  ListPermissionsRbacPermissionsGetErrors,
  CreatePermissionRbacPermissionsPostData,
  CreatePermissionRbacPermissionsPostResponses,
  CreatePermissionRbacPermissionsPostErrors,
  GetPermissionRbacPermissionsPermissionIdGetData,
  GetPermissionRbacPermissionsPermissionIdGetResponses,
  GetPermissionRbacPermissionsPermissionIdGetErrors,
  UpdatePermissionRbacPermissionsPermissionIdPatchData,
  UpdatePermissionRbacPermissionsPermissionIdPatchResponses,
  UpdatePermissionRbacPermissionsPermissionIdPatchErrors,
  ListRolesRbacRolesGetData,
  ListRolesRbacRolesGetResponses,
  ListRolesRbacRolesGetErrors,
  CreateRoleRbacRolesPostData,
  CreateRoleRbacRolesPostResponses,
  CreateRoleRbacRolesPostErrors,
  DeleteRoleRbacRolesRoleIdDeleteData,
  DeleteRoleRbacRolesRoleIdDeleteResponses,
  DeleteRoleRbacRolesRoleIdDeleteErrors,
  GetRoleRbacRolesRoleIdGetData,
  GetRoleRbacRolesRoleIdGetResponses,
  GetRoleRbacRolesRoleIdGetErrors,
  UpdateRoleRbacRolesRoleIdPatchData,
  UpdateRoleRbacRolesRoleIdPatchResponses,
  UpdateRoleRbacRolesRoleIdPatchErrors,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetData,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetResponses,
  ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetErrors,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostData,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostResponses,
  AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostErrors,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteData,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteResponses,
  RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteErrors,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostData,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostResponses,
  CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostErrors,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostData,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostResponses,
  CreateClinicAssignmentRbacRoleAssignmentsClinicPostErrors,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutData,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutResponses,
  BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutErrors,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetData,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetResponses,
  GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetErrors,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetData,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetResponses,
  ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetErrors,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutData,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutResponses,
  BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutErrors,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutData,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutResponses,
  BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutErrors,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetData,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetResponses,
  ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetErrors,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteData,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteResponses,
  DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteErrors,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetData,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetResponses,
  GetAssignmentRbacRoleAssignmentsAssignmentIdGetErrors,
  ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetData,
  ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetResponses,
  ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetErrors,
  ListWorkosFeatureFlagsRbacFeatureFlagsGetData,
  ListWorkosFeatureFlagsRbacFeatureFlagsGetResponses,
  GetUsersUsersGetData,
  GetUsersUsersGetResponses,
  GetUsersUsersGetErrors,
  CreateUserUsersPostData,
  CreateUserUsersPostResponses,
  CreateUserUsersPostErrors,
  GetAgencyMembersUsersAgencyMembersGetData,
  GetAgencyMembersUsersAgencyMembersGetResponses,
  GetAgencyMembersUsersAgencyMembersGetErrors,
  GetUsersByPermissionUsersByPermissionGetData,
  GetUsersByPermissionUsersByPermissionGetResponses,
  GetUsersByPermissionUsersByPermissionGetErrors,
  ListOrgMembersUsersOrgMembersGetData,
  ListOrgMembersUsersOrgMembersGetResponses,
  InviteUserUsersInvitePostData,
  InviteUserUsersInvitePostResponses,
  InviteUserUsersInvitePostErrors,
  ResendInviteUsersResendInvitePostData,
  ResendInviteUsersResendInvitePostResponses,
  ResendInviteUsersResendInvitePostErrors,
  UpdateUserRolesUsersUserIdRolesPutData,
  UpdateUserRolesUsersUserIdRolesPutResponses,
  UpdateUserRolesUsersUserIdRolesPutErrors,
  DeleteUserUsersUserIdDeleteData,
  DeleteUserUsersUserIdDeleteResponses,
  DeleteUserUsersUserIdDeleteErrors,
  GetUserUsersUserIdGetData,
  GetUserUsersUserIdGetResponses,
  GetUserUsersUserIdGetErrors,
  UpdateUserUsersUserIdPutData,
  UpdateUserUsersUserIdPutResponses,
  UpdateUserUsersUserIdPutErrors,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutData,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutResponses,
  UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutErrors,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutData,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutResponses,
  UpdateEmployeeTypesUsersUserIdEmployeeTypePutErrors,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
  UpdateUserNpiUsersUserIdNpiPatchData,
  UpdateUserNpiUsersUserIdNpiPatchResponses,
  UpdateUserNpiUsersUserIdNpiPatchErrors,
  UpdateUserTypeUsersUserIdUserTypePatchData,
  UpdateUserTypeUsersUserIdUserTypePatchResponses,
  UpdateUserTypeUsersUserIdUserTypePatchErrors,
  GetAvailableCliniciansUserClinicsAvailableGetData,
  GetAvailableCliniciansUserClinicsAvailableGetResponses,
  GetAvailableCliniciansUserClinicsAvailableGetErrors,
  DeleteCurrentAgencyAgenciesDeleteData,
  DeleteCurrentAgencyAgenciesDeleteResponses,
  UpdateCurrentAgencyAgenciesPutData,
  UpdateCurrentAgencyAgenciesPutResponses,
  UpdateCurrentAgencyAgenciesPutErrors,
  GetAgencyConfigAgencyConfigGetData,
  GetAgencyConfigAgencyConfigGetResponses,
  UpdateAgencyConfigAgencyConfigPutData,
  UpdateAgencyConfigAgencyConfigPutResponses,
  UpdateAgencyConfigAgencyConfigPutErrors,
  GetAgencyClinicsAgencyClinicsGetData,
  GetAgencyClinicsAgencyClinicsGetResponses,
  GetAgencyClinicsAgencyClinicsGetErrors,
  CreateAgencyClinicAgencyClinicsPostData,
  CreateAgencyClinicAgencyClinicsPostResponses,
  CreateAgencyClinicAgencyClinicsPostErrors,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetData,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetResponses,
  ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetErrors,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
  GetAgencyInsurancesClinicsInsuranceGetData,
  GetAgencyInsurancesClinicsInsuranceGetResponses,
  GetAgencyInsurancesClinicsInsuranceGetErrors,
  CreateAgencyInsuranceClinicsInsurancePostData,
  CreateAgencyInsuranceClinicsInsurancePostResponses,
  CreateAgencyInsuranceClinicsInsurancePostErrors,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostData,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostResponses,
  DuplicateClinicInsurancesClinicsInsuranceDuplicatePostErrors,
  RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostData,
  RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostResponses,
  RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostErrors,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteData,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteResponses,
  DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteErrors,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutData,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutResponses,
  UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutErrors,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetData,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetResponses,
  GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetErrors,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutData,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutResponses,
  ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutErrors,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetData,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetResponses,
  GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetErrors,
  MatchPatientsPatientsMatchPostData,
  MatchPatientsPatientsMatchPostResponses,
  MatchPatientsPatientsMatchPostErrors,
  GetPatientsPatientsGetData,
  GetPatientsPatientsGetResponses,
  GetPatientsPatientsGetErrors,
  CreatePatientPatientsPostData,
  CreatePatientPatientsPostResponses,
  CreatePatientPatientsPostErrors,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchData,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchResponses,
  SetPatientTestStatusPatientsPatientIdTestStatusPatchErrors,
  GetPatientCountPatientsCountGetData,
  GetPatientCountPatientsCountGetResponses,
  GetPatientCountPatientsCountGetErrors,
  DeletePatientPatientsPatientIdDeleteData,
  DeletePatientPatientsPatientIdDeleteResponses,
  DeletePatientPatientsPatientIdDeleteErrors,
  GetPatientPatientsPatientIdGetData,
  GetPatientPatientsPatientIdGetResponses,
  GetPatientPatientsPatientIdGetErrors,
  UpdatePatientPatientsPatientIdPutData,
  UpdatePatientPatientsPatientIdPutResponses,
  UpdatePatientPatientsPatientIdPutErrors,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetData,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetResponses,
  GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetErrors,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchData,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchResponses,
  UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchErrors,
  GetPatientVisitsPatientsPatientIdVisitsGetData,
  GetPatientVisitsPatientsPatientIdVisitsGetResponses,
  GetPatientVisitsPatientsPatientIdVisitsGetErrors,
  CreatePatientVisitPatientsPatientIdVisitsPostData,
  CreatePatientVisitPatientsPatientIdVisitsPostResponses,
  CreatePatientVisitPatientsPatientIdVisitsPostErrors,
  GetPatientTasksPatientsPatientIdTasksGetData,
  GetPatientTasksPatientsPatientIdTasksGetResponses,
  GetPatientTasksPatientsPatientIdTasksGetErrors,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostData,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostResponses,
  BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostErrors,
  GetPatientDocumentsPatientsPatientIdDocumentsGetData,
  GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
  UploadPatientDocumentPatientsPatientIdDocumentsPostData,
  UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
  UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetData,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetResponses,
  VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetErrors,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteData,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteResponses,
  DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteErrors,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetData,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetResponses,
  ListPatientCommunicationsPatientsPatientIdCommunicationsGetErrors,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostData,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostResponses,
  CreatePatientCommunicationPatientsPatientIdCommunicationsPostErrors,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteData,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteResponses,
  DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteErrors,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetData,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetResponses,
  GetPatientCommunicationPatientCommunicationsCommunicationIdGetErrors,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutData,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutResponses,
  UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutErrors,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetData,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetResponses,
  GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetErrors,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetData,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetResponses,
  GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetErrors,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetData,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetResponses,
  GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetErrors,
  CreateMiscTaskPatientsPatientIdMiscTasksPostData,
  CreateMiscTaskPatientsPatientIdMiscTasksPostResponses,
  CreateMiscTaskPatientsPatientIdMiscTasksPostErrors,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteData,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteResponses,
  DeleteMiscTaskMiscTasksMiscTaskIdDeleteErrors,
  GetMiscTaskMiscTasksMiscTaskIdGetData,
  GetMiscTaskMiscTasksMiscTaskIdGetResponses,
  GetMiscTaskMiscTasksMiscTaskIdGetErrors,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchData,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchResponses,
  UpdateMiscTaskMiscTasksMiscTaskIdPatchErrors,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
  ImportStediCsvEndpointPayorsImportStediCsvPostData,
  ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
  SearchPayorsEndpointPayorsSearchGetData,
  SearchPayorsEndpointPayorsSearchGetResponses,
  SearchPayorsEndpointPayorsSearchGetErrors,
  GetPayorsEndpointPayorsGetData,
  GetPayorsEndpointPayorsGetResponses,
  CreatePayorEndpointPayorsPostData,
  CreatePayorEndpointPayorsPostResponses,
  CreatePayorEndpointPayorsPostErrors,
  DeletePayorEndpointPayorsPayorIdDeleteData,
  DeletePayorEndpointPayorsPayorIdDeleteResponses,
  DeletePayorEndpointPayorsPayorIdDeleteErrors,
  GetPayorEndpointPayorsPayorIdGetData,
  GetPayorEndpointPayorsPayorIdGetResponses,
  GetPayorEndpointPayorsPayorIdGetErrors,
  UpdatePayorEndpointPayorsPayorIdPutData,
  UpdatePayorEndpointPayorsPayorIdPutResponses,
  UpdatePayorEndpointPayorsPayorIdPutErrors,
  GetPayorByNameEndpointPayorsByNamePayorNameGetData,
  GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
  GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
  ListPayrollVisitsPayrollVisitsGetData,
  ListPayrollVisitsPayrollVisitsGetResponses,
  ListPayrollVisitsPayrollVisitsGetErrors,
  ExportPayrollVisitsPayrollVisitsExportGetData,
  ExportPayrollVisitsPayrollVisitsExportGetResponses,
  ExportPayrollVisitsPayrollVisitsExportGetErrors,
  ListPayrollEntriesPayrollEntriesGetData,
  ListPayrollEntriesPayrollEntriesGetResponses,
  ListPayrollEntriesPayrollEntriesGetErrors,
  CreatePayrollEntryPayrollEntriesPostData,
  CreatePayrollEntryPayrollEntriesPostResponses,
  CreatePayrollEntryPayrollEntriesPostErrors,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetData,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetResponses,
  ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetErrors,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteData,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteResponses,
  RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteErrors,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteData,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteResponses,
  DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteErrors,
  GetProductUpdatesForUserProductUpdatesGetData,
  GetProductUpdatesForUserProductUpdatesGetResponses,
  GetReportingManifestReportingManifestGetData,
  GetReportingManifestReportingManifestGetResponses,
  GetReportingExtractReportingExtractsDatasetKeyGetData,
  GetReportingExtractReportingExtractsDatasetKeyGetResponses,
  GetReportingExtractReportingExtractsDatasetKeyGetErrors,
  ListReportDefinitionsReportingReportDefinitionsGetData,
  ListReportDefinitionsReportingReportDefinitionsGetResponses,
  CreateReportDefinitionReportingReportDefinitionsPostData,
  CreateReportDefinitionReportingReportDefinitionsPostResponses,
  CreateReportDefinitionReportingReportDefinitionsPostErrors,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteData,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteResponses,
  DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteErrors,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchData,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchResponses,
  UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchErrors,
  ReloadHippsReferenceHippsReferenceReloadPostData,
  ReloadHippsReferenceHippsReferenceReloadPostResponses,
  ReloadCmsGeographyCmsGeographyReloadPostData,
  ReloadCmsGeographyCmsGeographyReloadPostResponses,
  ListValueCodesRouteValueCodesGetData,
  ListValueCodesRouteValueCodesGetResponses,
  ReloadValueCodesValueCodesReloadPostData,
  ReloadValueCodesValueCodesReloadPostResponses,
  GetEligibilityChecksEndpointEligibilityGetData,
  GetEligibilityChecksEndpointEligibilityGetResponses,
  GetEligibilityChecksEndpointEligibilityGetErrors,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostData,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostResponses,
  EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostErrors,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostData,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostResponses,
  SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostErrors,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostData,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostResponses,
  SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostErrors,
  SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostData,
  SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostResponses,
  SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostErrors,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostData,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostResponses,
  SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostErrors,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostData,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostResponses,
  SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostErrors,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostData,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostResponses,
  SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostErrors,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostData,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostResponses,
  SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostErrors,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetData,
  GetBillingCyclesMetaApiBillingBillingCyclesMetaGetResponses,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetData,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetResponses,
  GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetErrors,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetData,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetResponses,
  GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetErrors,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostData,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostResponses,
  GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostErrors,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostData,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostResponses,
  GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostErrors,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetData,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetResponses,
  GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetErrors,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetData,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetResponses,
  GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetErrors,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetData,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetResponses,
  GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetErrors,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostData,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostResponses,
  UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostErrors,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostData,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostResponses,
  CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostErrors,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetData,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetResponses,
  DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetErrors,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetData,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetResponses,
  DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetErrors,
  RefreshBillingCyclesBillingRefreshBillingCyclesPostData,
  RefreshBillingCyclesBillingRefreshBillingCyclesPostResponses,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetData,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetResponses,
  GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetErrors,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetData,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetResponses,
  GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetErrors,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutData,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutResponses,
  ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutErrors,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostData,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostResponses,
  RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostErrors,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetData,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetResponses,
  ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetErrors,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostData,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostResponses,
  CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostErrors,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteData,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteResponses,
  DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteErrors,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetData,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetResponses,
  GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetErrors,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchData,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchResponses,
  UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchErrors,
  UploadRemittanceRemittancesUploadPostData,
  UploadRemittanceRemittancesUploadPostResponses,
  UploadRemittanceRemittancesUploadPostErrors,
  ListRemittancePayorsRemittancesPayorsGetData,
  ListRemittancePayorsRemittancesPayorsGetResponses,
  GetRemittanceStatusCountsRemittancesStatusCountsGetData,
  GetRemittanceStatusCountsRemittancesStatusCountsGetResponses,
  ListRemittancesRemittancesGetData,
  ListRemittancesRemittancesGetResponses,
  ListRemittancesRemittancesGetErrors,
  CreateRemittanceRemittancesPostData,
  CreateRemittanceRemittancesPostResponses,
  CreateRemittanceRemittancesPostErrors,
  SearchRemittanceClaimsRemittancesClaimsSearchGetData,
  SearchRemittanceClaimsRemittancesClaimsSearchGetResponses,
  SearchRemittanceClaimsRemittancesClaimsSearchGetErrors,
  DeleteRemittanceRemittancesRemittanceIdDeleteData,
  DeleteRemittanceRemittancesRemittanceIdDeleteResponses,
  DeleteRemittanceRemittancesRemittanceIdDeleteErrors,
  GetRemittanceDetailRemittancesRemittanceIdGetData,
  GetRemittanceDetailRemittancesRemittanceIdGetResponses,
  GetRemittanceDetailRemittancesRemittanceIdGetErrors,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutData,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutResponses,
  UpdateRemittanceWorksheetRemittancesRemittanceIdPutErrors,
  CompleteRemittanceRemittancesRemittanceIdCompletePostData,
  CompleteRemittanceRemittancesRemittanceIdCompletePostResponses,
  CompleteRemittanceRemittancesRemittanceIdCompletePostErrors,
  ReopenRemittanceRemittancesRemittanceIdReopenPostData,
  ReopenRemittanceRemittancesRemittanceIdReopenPostResponses,
  ReopenRemittanceRemittancesRemittanceIdReopenPostErrors,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetData,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetResponses,
  DownloadRemittanceRemittancesRemittanceIdDownloadGetErrors,
  GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetData,
  GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetResponses,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetData,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetResponses,
  GetPatientDiagnosesReportReportsPatientDiagnosesGetErrors,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetData,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetResponses,
  ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetErrors,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetData,
  GetOpenOasisReportOptionsReportsOpenOasisOptionsGetResponses,
  GetOpenOasisReportReportsOpenOasisGetData,
  GetOpenOasisReportReportsOpenOasisGetResponses,
  GetOpenOasisReportReportsOpenOasisGetErrors,
  ExportOpenOasisReportReportsOpenOasisExportGetData,
  ExportOpenOasisReportReportsOpenOasisExportGetResponses,
  ExportOpenOasisReportReportsOpenOasisExportGetErrors,
  GetScheduleReportOptionsReportsScheduleOptionsGetData,
  GetScheduleReportOptionsReportsScheduleOptionsGetResponses,
  GetScheduleReportOptionsReportsScheduleOptionsGetErrors,
  GetScheduleReportReportsScheduleGetData,
  GetScheduleReportReportsScheduleGetResponses,
  GetScheduleReportReportsScheduleGetErrors,
  ExportScheduleReportReportsScheduleExportGetData,
  ExportScheduleReportReportsScheduleExportGetResponses,
  ExportScheduleReportReportsScheduleExportGetErrors,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetData,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetResponses,
  GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetErrors,
  GetScheduleDeviationReportReportsScheduleDeviationGetData,
  GetScheduleDeviationReportReportsScheduleDeviationGetResponses,
  GetScheduleDeviationReportReportsScheduleDeviationGetErrors,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetData,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetResponses,
  ExportScheduleDeviationReportReportsScheduleDeviationExportGetErrors,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetData,
  GetCensusReportClinicOptionsReportsCensusClinicOptionsGetResponses,
  GetCensusReportReportsCensusGetData,
  GetCensusReportReportsCensusGetResponses,
  GetCensusReportReportsCensusGetErrors,
  ExportCensusReportReportsCensusExportGetData,
  ExportCensusReportReportsCensusExportGetResponses,
  ExportCensusReportReportsCensusExportGetErrors,
  PrintCensusReportReportsCensusPrintGetData,
  PrintCensusReportReportsCensusPrintGetResponses,
  PrintCensusReportReportsCensusPrintGetErrors,
  GetWorklogReportOptionsReportsWorklogOptionsGetData,
  GetWorklogReportOptionsReportsWorklogOptionsGetResponses,
  GetWorklogReportOptionsReportsWorklogOptionsGetErrors,
  GetWorklogReportReportsWorklogGetData,
  GetWorklogReportReportsWorklogGetResponses,
  GetWorklogReportReportsWorklogGetErrors,
  ExportWorklogReportReportsWorklogExportGetData,
  ExportWorklogReportReportsWorklogExportGetResponses,
  ExportWorklogReportReportsWorklogExportGetErrors,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetData,
  GetWoundStatusReportOptionsReportsWoundStatusOptionsGetResponses,
  GetWoundStatusReportReportsWoundStatusGetData,
  GetWoundStatusReportReportsWoundStatusGetResponses,
  GetWoundStatusReportReportsWoundStatusGetErrors,
  ExportWoundStatusReportReportsWoundStatusExportGetData,
  ExportWoundStatusReportReportsWoundStatusExportGetResponses,
  ExportWoundStatusReportReportsWoundStatusExportGetErrors,
  GetBucketStatusS3BucketStatusGetData,
  GetBucketStatusS3BucketStatusGetResponses,
  HealthCheckTemporalHealthGetData,
  HealthCheckTemporalHealthGetResponses,
  GetIntakeFormSchemaIntakeFormSchemaGetData,
  GetIntakeFormSchemaIntakeFormSchemaGetResponses,
  GetIntakeExtractionPromptIntakeExtractionPromptGetData,
  GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
  UploadFileAndCreateIntakeIntakeUploadPostData,
  UploadFileAndCreateIntakeIntakeUploadPostResponses,
  UploadFileAndCreateIntakeIntakeUploadPostErrors,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
  GetAuthQueueEndpointIntakeAuthQueueGetData,
  GetAuthQueueEndpointIntakeAuthQueueGetResponses,
  GetAuthQueueEndpointIntakeAuthQueueGetErrors,
  ExportIntakesEndpointIntakeExportGetData,
  ExportIntakesEndpointIntakeExportGetResponses,
  ExportIntakesEndpointIntakeExportGetErrors,
  DeleteIntakeEndpointIntakeIntakeIdDeleteData,
  DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
  DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
  GetIntakeEndpointIntakeIntakeIdGetData,
  GetIntakeEndpointIntakeIntakeIdGetResponses,
  GetIntakeEndpointIntakeIntakeIdGetErrors,
  UpdateIntakeEndpointIntakeIntakeIdPutData,
  UpdateIntakeEndpointIntakeIntakeIdPutResponses,
  UpdateIntakeEndpointIntakeIntakeIdPutErrors,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchData,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchResponses,
  SetIntakeTestStatusIntakeIntakeIdTestStatusPatchErrors,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
  GetIntakesEndpointIntakeGetData,
  GetIntakesEndpointIntakeGetResponses,
  GetIntakesEndpointIntakeGetErrors,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostData,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostResponses,
  ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostErrors,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostData,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostResponses,
  AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostErrors,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
  RejectIntakeEndpointIntakeIntakeIdRejectPutData,
  RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
  RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteData,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteResponses,
  DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteErrors,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostData,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostResponses,
  StampIntakeDocumentIntakeDocumentsDocumentIdStampPostErrors,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostData,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostResponses,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostErrors,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetData,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetResponses,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetErrors,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostData,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostResponses,
  ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostErrors,
  GetVisitTypeOptionsVisitsTypeOptionsGetData,
  GetVisitTypeOptionsVisitsTypeOptionsGetResponses,
  GetMissedVisitOptionsVisitsMissedVisitOptionsGetData,
  GetMissedVisitOptionsVisitsMissedVisitOptionsGetResponses,
  GetMyTasksVisitsMyTasksGetData,
  GetMyTasksVisitsMyTasksGetResponses,
  GetMyTasksVisitsMyTasksGetErrors,
  ValidateOasisVisitsVisitIdValidateOasisPostData,
  ValidateOasisVisitsVisitIdValidateOasisPostResponses,
  ValidateOasisVisitsVisitIdValidateOasisPostErrors,
  ExportOasisBatchVisitsExportOasisBatchPostData,
  ExportOasisBatchVisitsExportOasisBatchPostResponses,
  ExportOasisBatchVisitsExportOasisBatchPostErrors,
  ListOasisManagerVisitsVisitsOasisManagerGetData,
  ListOasisManagerVisitsVisitsOasisManagerGetResponses,
  ListOasisManagerVisitsVisitsOasisManagerGetErrors,
  MarkVisitsExportedVisitsMarkExportedPostData,
  MarkVisitsExportedVisitsMarkExportedPostResponses,
  MarkVisitsExportedVisitsMarkExportedPostErrors,
  UnmarkVisitsExportedVisitsUnmarkExportedPostData,
  UnmarkVisitsExportedVisitsUnmarkExportedPostResponses,
  UnmarkVisitsExportedVisitsUnmarkExportedPostErrors,
  ExportOasisVisitsVisitIdExportOasisPostData,
  ExportOasisVisitsVisitIdExportOasisPostResponses,
  ExportOasisVisitsVisitIdExportOasisPostErrors,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
  DeleteVisitVisitsVisitIdDeleteData,
  DeleteVisitVisitsVisitIdDeleteResponses,
  DeleteVisitVisitsVisitIdDeleteErrors,
  GetVisitVisitsVisitIdGetData,
  GetVisitVisitsVisitIdGetResponses,
  GetVisitVisitsVisitIdGetErrors,
  UpdateVisitVisitsVisitIdPutData,
  UpdateVisitVisitsVisitIdPutResponses,
  UpdateVisitVisitsVisitIdPutErrors,
  GetVisitWorkLogVisitsVisitIdWorkLogGetData,
  GetVisitWorkLogVisitsVisitIdWorkLogGetResponses,
  GetVisitWorkLogVisitsVisitIdWorkLogGetErrors,
  CreateVisitVisitsPostData,
  CreateVisitVisitsPostResponses,
  CreateVisitVisitsPostErrors,
  GetVisitDataVisitsVisitIdDataGetData,
  GetVisitDataVisitsVisitIdDataGetResponses,
  GetVisitDataVisitsVisitIdDataGetErrors,
  UpdateVisitDataVisitsVisitIdDataPutData,
  UpdateVisitDataVisitsVisitIdDataPutResponses,
  UpdateVisitDataVisitsVisitIdDataPutErrors,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutData,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutResponses,
  UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutErrors,
  GetVisitPdfVisitsVisitIdPdfGetData,
  GetVisitPdfVisitsVisitIdPdfGetResponses,
  GetVisitPdfVisitsVisitIdPdfGetErrors,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetData,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetResponses,
  GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetErrors,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteData,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteResponses,
  UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteErrors,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostData,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostResponses,
  MarkVisitAsMissedVisitsVisitIdMarkMissedPostErrors,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchData,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchResponses,
  UpdateMissedVisitDataVisitsVisitIdMissedDataPatchErrors,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchData,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchResponses,
  SetVisitAuthorizationVisitsVisitIdAuthorizationPatchErrors,
  GetVisitEvvReadingsVisitsVisitIdEvvGetData,
  GetVisitEvvReadingsVisitsVisitIdEvvGetResponses,
  GetVisitEvvReadingsVisitsVisitIdEvvGetErrors,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetData,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetResponses,
  ListVisitDiagnosesVisitsVisitIdDiagnosesGetErrors,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostData,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostResponses,
  CreateVisitDiagnosisVisitsVisitIdDiagnosesPostErrors,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteData,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteResponses,
  DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteErrors,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutData,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutResponses,
  UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutErrors,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutData,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutResponses,
  UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutErrors,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetData,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetResponses,
  SearchDiagnosisCodesRouteDiagnosisCodesSearchGetErrors,
  GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetData,
  GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetResponses,
  GetQuestionSchemaRogerdocQuestionSchemaGetData,
  GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
  GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostData,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostResponses,
  GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostErrors,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetData,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetResponses,
  GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetErrors,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetData,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetResponses,
  GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetErrors,
  CheckRogerdocHealthRogerdocHealthGetData,
  CheckRogerdocHealthRogerdocHealthGetResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
  UploadCodingFilesRogerdocCodingUploadFilesPostData,
  UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
  UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
  RogerdocVspUpdateData,
  RogerdocVspUpdateResponses,
  RogerdocGetFeatureFlagsData,
  RogerdocGetFeatureFlagsResponses,
  ListRogerdocAccountLinksRogerdocAccountLinksGetData,
  ListRogerdocAccountLinksRogerdocAccountLinksGetResponses,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostData,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostResponses,
  CreateRogerdocAccountLinkRogerdocAccountLinksPostErrors,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteData,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteResponses,
  ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteErrors,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutData,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutResponses,
  AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutErrors,
  GetGoalsProgressValidationConfigData,
  GetGoalsProgressValidationConfigResponses,
  SetGoalsProgressValidationConfigData,
  SetGoalsProgressValidationConfigResponses,
  SetGoalsProgressValidationConfigErrors,
  RogerdocWorksheetGoalsPassthroughPostData,
  RogerdocWorksheetGoalsPassthroughPostResponses,
  RogerdocWorksheetGoalsPassthroughPostErrors,
  RogerdocFetchGoalsTemplatesPassthroughPostData,
  RogerdocFetchGoalsTemplatesPassthroughPostResponses,
  RogerdocPassthroughDeleteData,
  RogerdocPassthroughDeleteResponses,
  RogerdocPassthroughDeleteErrors,
  RogerdocPassthroughGetData,
  RogerdocPassthroughGetResponses,
  RogerdocPassthroughGetErrors,
  RogerdocPassthroughPatchData,
  RogerdocPassthroughPatchResponses,
  RogerdocPassthroughPatchErrors,
  RogerdocPassthroughPostData,
  RogerdocPassthroughPostResponses,
  RogerdocPassthroughPostErrors,
  RogerdocPassthroughPutData,
  RogerdocPassthroughPutResponses,
  RogerdocPassthroughPutErrors,
  ListBespokeTemplatesBespokeTemplatesGetData,
  ListBespokeTemplatesBespokeTemplatesGetResponses,
  ListBespokeTemplatesBespokeTemplatesGetErrors,
  CreateBespokeTemplateBespokeTemplatesPostData,
  CreateBespokeTemplateBespokeTemplatesPostResponses,
  CreateBespokeTemplateBespokeTemplatesPostErrors,
  ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetData,
  ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetResponses,
  ListEnabledSectionsBespokeTemplatesEnabledGetData,
  ListEnabledSectionsBespokeTemplatesEnabledGetResponses,
  ListEnabledSectionsBespokeTemplatesEnabledGetErrors,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetData,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetResponses,
  ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetErrors,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostData,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostResponses,
  ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostErrors,
  BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostData,
  BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostResponses,
  BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostErrors,
  DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteData,
  DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteResponses,
  DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteErrors,
  UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchData,
  UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchResponses,
  UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchErrors,
  ContextSectionsFormsManagerContextSectionsGetData,
  ContextSectionsFormsManagerContextSectionsGetResponses,
  ContextSectionsFormsManagerContextSectionsGetErrors,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetData,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetResponses,
  ContextSectionLayoutFormsManagerContextSectionLayoutGetErrors,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetData,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetResponses,
  ContextSectionLayoutsFormsManagerContextSectionLayoutsGetErrors,
  ContextSectionQuestionsFormsManagerContextSectionQuestionsGetData,
  ContextSectionQuestionsFormsManagerContextSectionQuestionsGetResponses,
  ContextSectionQuestionsFormsManagerContextSectionQuestionsGetErrors,
  PushLayoutFormsManagerPushLayoutPostData,
  PushLayoutFormsManagerPushLayoutPostResponses,
  PushLayoutFormsManagerPushLayoutPostErrors,
  ListVibecoderModelsVibecoderLayoutAssistantModelsGetData,
  ListVibecoderModelsVibecoderLayoutAssistantModelsGetResponses,
  VibecoderLayoutChatVibecoderLayoutAssistantChatPostData,
  VibecoderLayoutChatVibecoderLayoutAssistantChatPostResponses,
  VibecoderLayoutChatVibecoderLayoutAssistantChatPostErrors,
  GenerateX12270X12270GeneratePostData,
  GenerateX12270X12270GeneratePostResponses,
  GenerateX12270X12270GeneratePostErrors,
  CheckEligibilityWithX12270X12270EligibilityCheckPostData,
  CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
  CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
  GenerateX12271X12271GeneratePostData,
  GenerateX12271X12271GeneratePostResponses,
  GenerateX12271X12271GeneratePostErrors,
  ParseX12271X12271ParsePostData,
  ParseX12271X12271ParsePostResponses,
  ParseX12271X12271ParsePostErrors,
  GenerateX12837iX12837iGeneratePostData,
  GenerateX12837iX12837iGeneratePostResponses,
  GenerateX12837iX12837iGeneratePostErrors,
  CheckEligibilityX12WaystarEligibilityPostData,
  CheckEligibilityX12WaystarEligibilityPostResponses,
  CheckEligibilityX12WaystarEligibilityPostErrors,
  CheckEligibilityDirectWaystarEligibilityDirectPostData,
  CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
  CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
  CheckPriorAuthorizationWaystarPriorAuthPostData,
  CheckPriorAuthorizationWaystarPriorAuthPostResponses,
  CheckPriorAuthorizationWaystarPriorAuthPostErrors,
  SubmitClaimWaystarClaimsSubmit837iPostData,
  SubmitClaimWaystarClaimsSubmit837iPostResponses,
  SubmitClaimWaystarClaimsSubmit837iPostErrors,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
  CheckEligibilityStediEligibilityPostData,
  CheckEligibilityStediEligibilityPostResponses,
  CheckEligibilityStediEligibilityPostErrors,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
  SubmitClaim837iStediClaim837iPostData,
  SubmitClaim837iStediClaim837iPostResponses,
  SubmitClaim837iStediClaim837iPostErrors,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetData,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetResponses,
  GetStediClaimUb04PdfStediClaimsClaimIdUb04GetErrors,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
  ReceiveStediWebhookStediWebhooksReceivePostData,
  ReceiveStediWebhookStediWebhooksReceivePostResponses,
  ReceiveStediWebhookStediWebhooksReceivePostErrors,
  CreatePatientInKinnserKinnserPatientsPostData,
  CreatePatientInKinnserKinnserPatientsPostResponses,
  CreatePatientInKinnserKinnserPatientsPostErrors,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostData,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostResponses,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostErrors,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostData,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostResponses,
  CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostErrors,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostData,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostResponses,
  AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostErrors,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostData,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostResponses,
  AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostErrors,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostData,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostResponses,
  UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostErrors,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostData,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostResponses,
  TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostErrors,
  GetKinnserClinicDataKinnserClinicsClinicIdGetData,
  GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
  GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
  GetKinnserClinicsKinnserClinicsGetData,
  GetKinnserClinicsKinnserClinicsGetResponses,
  SearchAllergiesAllergiesGetData,
  SearchAllergiesAllergiesGetResponses,
  SearchAllergiesAllergiesGetErrors,
  CreateAllergyAllergiesPostData,
  CreateAllergyAllergiesPostResponses,
  CreateAllergyAllergiesPostErrors,
  GetUserDefinedAllergiesAllergiesUserDefinedGetData,
  GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
  ImportAllergiesFromFileAllergiesImportPostData,
  ImportAllergiesFromFileAllergiesImportPostResponses,
  DeleteAllergyAllergiesAllergyIdDeleteData,
  DeleteAllergyAllergiesAllergyIdDeleteResponses,
  DeleteAllergyAllergiesAllergyIdDeleteErrors,
  GetAllergyAllergiesAllergyIdGetData,
  GetAllergyAllergiesAllergyIdGetResponses,
  GetAllergyAllergiesAllergyIdGetErrors,
  GetPatientAllergiesPatientsPatientIdAllergyGetData,
  GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
  GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
  CreatePatientAllergyPatientsPatientIdAllergyPostData,
  CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
  CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
  ListPatientInsurancesPatientsPatientIdInsuranceGetData,
  ListPatientInsurancesPatientsPatientIdInsuranceGetResponses,
  ListPatientInsurancesPatientsPatientIdInsuranceGetErrors,
  CreatePatientInsurancePatientsPatientIdInsurancePostData,
  CreatePatientInsurancePatientsPatientIdInsurancePostResponses,
  CreatePatientInsurancePatientsPatientIdInsurancePostErrors,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteData,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteResponses,
  DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteErrors,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetData,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetResponses,
  GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetErrors,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutData,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutResponses,
  UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutErrors,
  SearchMedicationsEndpointMedicationsGetData,
  SearchMedicationsEndpointMedicationsGetResponses,
  SearchMedicationsEndpointMedicationsGetErrors,
  GetMedicationEndpointMedicationsMedicationIdGetData,
  GetMedicationEndpointMedicationsMedicationIdGetResponses,
  GetMedicationEndpointMedicationsMedicationIdGetErrors,
  GetPatientMedicationsPatientsPatientIdMedicationsGetData,
  GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
  CreatePatientMedicationPatientsPatientIdMedicationsPostData,
  CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
  CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
  GetMedicationOrderLaunchValidationData,
  GetMedicationOrderLaunchValidationResponses,
  GetMedicationOrderLaunchValidationErrors,
  CreateMedicationOrderData,
  CreateMedicationOrderResponses,
  CreateMedicationOrderErrors,
  ScreenMedicationInteractionsData,
  ScreenMedicationInteractionsResponses,
  ScreenMedicationInteractionsErrors,
  ScreenCandidateMedicationData,
  ScreenCandidateMedicationResponses,
  ScreenCandidateMedicationErrors,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostData,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationPdfPatientsPatientIdMedicationsPdfPostErrors,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
  GetPatientPharmacyPatientsPatientIdPharmacyGetData,
  GetPatientPharmacyPatientsPatientIdPharmacyGetResponses,
  GetPatientPharmacyPatientsPatientIdPharmacyGetErrors,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutData,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutResponses,
  UpsertPatientPharmacyPatientsPatientIdPharmacyPutErrors,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetData,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetResponses,
  ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetErrors,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostData,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostResponses,
  CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostErrors,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteData,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteResponses,
  DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteErrors,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutData,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutResponses,
  UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutErrors,
  GetPatientWoundsPatientsPatientIdWoundsGetData,
  GetPatientWoundsPatientsPatientIdWoundsGetResponses,
  GetPatientWoundsPatientsPatientIdWoundsGetErrors,
  CreatePatientWoundPatientsPatientIdWoundsPostData,
  CreatePatientWoundPatientsPatientIdWoundsPostResponses,
  CreatePatientWoundPatientsPatientIdWoundsPostErrors,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteData,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteResponses,
  DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteErrors,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutData,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutResponses,
  UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutErrors,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostData,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostResponses,
  GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostErrors,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetData,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetResponses,
  GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetErrors,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostData,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostResponses,
  CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostErrors,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteData,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteResponses,
  DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteErrors,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutData,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutResponses,
  UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutErrors,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetData,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetResponses,
  GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetErrors,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostData,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostResponses,
  UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostErrors,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostData,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostResponses,
  IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostErrors,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostData,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostResponses,
  IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostErrors,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetData,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetResponses,
  GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetErrors,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteData,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteResponses,
  DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteErrors,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetData,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetResponses,
  ListInfectionLogsPatientsPatientIdInfectionLogsGetErrors,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostData,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostResponses,
  CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostErrors,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteData,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteResponses,
  DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteErrors,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetData,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetResponses,
  GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetErrors,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutData,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutResponses,
  UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutErrors,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostData,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostResponses,
  SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostErrors,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostData,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostResponses,
  ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostErrors,
  ListNoaPayersNoasPayersGetData,
  ListNoaPayersNoasPayersGetResponses,
  ListNoaPayersNoasPayersGetErrors,
  ListMissingNoasNoasMissingGetData,
  ListMissingNoasNoasMissingGetResponses,
  ListNoasNoasGetData,
  ListNoasNoasGetResponses,
  ListNoasNoasGetErrors,
  GetNoaNoasNoaIdGetData,
  GetNoaNoasNoaIdGetResponses,
  GetNoaNoasNoaIdGetErrors,
  UpdateNoaNoasNoaIdPatchData,
  UpdateNoaNoasNoaIdPatchResponses,
  UpdateNoaNoasNoaIdPatchErrors,
  GetNoa837iNoasNoaId837iGetData,
  GetNoa837iNoasNoaId837iGetResponses,
  GetNoa837iNoasNoaId837iGetErrors,
  GetNoaUb04PdfNoasNoaIdUb04GetData,
  GetNoaUb04PdfNoasNoaIdUb04GetResponses,
  GetNoaUb04PdfNoasNoaIdUb04GetErrors,
  SubmitNoa837iNoasNoaIdSubmitPostData,
  SubmitNoa837iNoasNoaIdSubmitPostResponses,
  SubmitNoa837iNoasNoaIdSubmitPostErrors,
  SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchData,
  SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchResponses,
  SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchErrors,
  ValidateNoaNoasNoaIdValidatePostData,
  ValidateNoaNoasNoaIdValidatePostResponses,
  ValidateNoaNoasNoaIdValidatePostErrors,
  SendNoaNoasNoaIdSendPostData,
  SendNoaNoasNoaIdSendPostResponses,
  SendNoaNoasNoaIdSendPostErrors,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostData,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostResponses,
  MarkNotApplicableNoasNoaIdMarkNotApplicablePostErrors,
  MarkPaidNoasNoaIdMarkPaidPostData,
  MarkPaidNoasNoaIdMarkPaidPostResponses,
  MarkPaidNoasNoaIdMarkPaidPostErrors,
  MarkSentNoasNoaIdMarkSentPostData,
  MarkSentNoasNoaIdMarkSentPostResponses,
  MarkSentNoasNoaIdMarkSentPostErrors,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostData,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostResponses,
  RevertToNotReadyNoasNoaIdRevertToNotReadyPostErrors,
  BulkSendNoasBulkSendPostData,
  BulkSendNoasBulkSendPostResponses,
  BulkSendNoasBulkSendPostErrors,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostData,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostResponses,
  CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostErrors,
  ListCahpsExportsCahpsExportsGetData,
  ListCahpsExportsCahpsExportsGetResponses,
  GenerateCahpsExportCahpsExportsGeneratePostData,
  GenerateCahpsExportCahpsExportsGeneratePostResponses,
  GenerateCahpsExportCahpsExportsGeneratePostErrors,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetData,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetResponses,
  DownloadCahpsExportCahpsExportsExportIdDownloadGetErrors,
  QueryDashboardData,
  QueryDashboardResponses,
  QueryDashboardErrors,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetData,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetResponses,
  ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetErrors,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetData,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetResponses,
  GetCms485PrefillPatientsPatientIdCms485PrefillGetErrors,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetData,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetResponses,
  ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetErrors,
  GetEpisodeEpisodesEpisodeIdGetData,
  GetEpisodeEpisodesEpisodeIdGetResponses,
  GetEpisodeEpisodesEpisodeIdGetErrors,
  UpdateEpisodeEpisodesEpisodeIdPatchData,
  UpdateEpisodeEpisodesEpisodeIdPatchResponses,
  UpdateEpisodeEpisodesEpisodeIdPatchErrors,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetData,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetResponses,
  GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetErrors,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutData,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutResponses,
  UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutErrors,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostData,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostResponses,
  BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostErrors,
  GetEpisodeLupaData,
  GetEpisodeLupaResponses,
  GetEpisodeLupaErrors,
  SyncEpisodeDateToVisitData,
  SyncEpisodeDateToVisitResponses,
  SyncEpisodeDateToVisitErrors,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchData,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchResponses,
  UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchErrors,
  CreateEpisodeData,
  CreateEpisodeResponses,
  CreateEpisodeErrors,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetData,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetResponses,
  ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetErrors,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostData,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostResponses,
  CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostErrors,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetData,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetResponses,
  GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetErrors,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetData,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetResponses,
  GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetErrors,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteData,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteResponses,
  DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteErrors,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetData,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetResponses,
  GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetErrors,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutData,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutResponses,
  UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutErrors,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetData,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetResponses,
  ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetErrors,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostData,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostResponses,
  CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostErrors,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteData,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteResponses,
  DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteErrors,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetData,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetResponses,
  GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetErrors,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutData,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutResponses,
  UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutErrors,
  ListFallLogsPatientsPatientIdFallLogsGetData,
  ListFallLogsPatientsPatientIdFallLogsGetResponses,
  ListFallLogsPatientsPatientIdFallLogsGetErrors,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostData,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostResponses,
  CreateFallLogEndpointPatientsPatientIdFallLogsPostErrors,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteData,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteResponses,
  DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteErrors,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutData,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutResponses,
  UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutErrors,
  ListEpisodesForPatientData,
  ListEpisodesForPatientResponses,
  ListEpisodesForPatientErrors,
  ListClinicPhysiciansAdminClinicPhysiciansGetData,
  ListClinicPhysiciansAdminClinicPhysiciansGetResponses,
  ListClinicPhysiciansAdminClinicPhysiciansGetErrors,
  CreateClinicPhysicianAdminClinicPhysiciansPostData,
  CreateClinicPhysicianAdminClinicPhysiciansPostResponses,
  CreateClinicPhysicianAdminClinicPhysiciansPostErrors,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostData,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostResponses,
  DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostErrors,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteData,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteResponses,
  DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteErrors,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutData,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutResponses,
  UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutErrors,
  GetOrderManagerCountsOrdersManagerCountsGetData,
  GetOrderManagerCountsOrdersManagerCountsGetResponses,
  GetOrderTypeOptionsOrdersTypeOptionsGetData,
  GetOrderTypeOptionsOrdersTypeOptionsGetResponses,
  GetOrderManagerItemsOrdersManagerGetData,
  GetOrderManagerItemsOrdersManagerGetResponses,
  GetOrderManagerItemsOrdersManagerGetErrors,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetData,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetResponses,
  GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetErrors,
  GetOrderCms485FormOrdersOrderIdCms485FormGetData,
  GetOrderCms485FormOrdersOrderIdCms485FormGetResponses,
  GetOrderCms485FormOrdersOrderIdCms485FormGetErrors,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetData,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetResponses,
  GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetErrors,
  CheckoutOrderOrdersOrderIdCheckoutPostData,
  CheckoutOrderOrdersOrderIdCheckoutPostResponses,
  CheckoutOrderOrdersOrderIdCheckoutPostErrors,
  CheckinOrderOrdersOrderIdCheckinPostData,
  CheckinOrderOrdersOrderIdCheckinPostResponses,
  CheckinOrderOrdersOrderIdCheckinPostErrors,
  DeleteOrderOrdersOrderIdDeleteData,
  DeleteOrderOrdersOrderIdDeleteResponses,
  DeleteOrderOrdersOrderIdDeleteErrors,
  GetOrderOrdersOrderIdGetData,
  GetOrderOrdersOrderIdGetResponses,
  GetOrderOrdersOrderIdGetErrors,
  UpdateOrderOrdersOrderIdPatchData,
  UpdateOrderOrdersOrderIdPatchResponses,
  UpdateOrderOrdersOrderIdPatchErrors,
  GetOrderPdfOrdersOrderIdPdfGetData,
  GetOrderPdfOrdersOrderIdPdfGetResponses,
  GetOrderPdfOrdersOrderIdPdfGetErrors,
  CreateOrderOrdersPostData,
  CreateOrderOrdersPostResponses,
  CreateOrderOrdersPostErrors,
  GetMyTasksTasksMyTasksGetData,
  GetMyTasksTasksMyTasksGetResponses,
  GetMyTasksTasksMyTasksGetErrors,
  GetTaskDocumentsTasksTaskIdDocumentsGetData,
  GetTaskDocumentsTasksTaskIdDocumentsGetResponses,
  GetTaskDocumentsTasksTaskIdDocumentsGetErrors,
  UploadTaskDocumentTasksTaskIdDocumentsPostData,
  UploadTaskDocumentTasksTaskIdDocumentsPostResponses,
  UploadTaskDocumentTasksTaskIdDocumentsPostErrors,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetData,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetResponses,
  GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetErrors,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteData,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteResponses,
  DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteErrors,
  GetTaskSignaturesTasksTaskIdSignaturesGetData,
  GetTaskSignaturesTasksTaskIdSignaturesGetResponses,
  GetTaskSignaturesTasksTaskIdSignaturesGetErrors,
  SignTaskEndpointTasksTaskIdSignPostData,
  SignTaskEndpointTasksTaskIdSignPostResponses,
  SignTaskEndpointTasksTaskIdSignPostErrors,
  ApproveTaskEndpointTasksTaskIdApprovePostData,
  ApproveTaskEndpointTasksTaskIdApprovePostResponses,
  ApproveTaskEndpointTasksTaskIdApprovePostErrors,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostData,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostResponses,
  SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostErrors,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostData,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostResponses,
  ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostErrors,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetData,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetResponses,
  VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetErrors,
  BreakSignaturesEndpointTasksTaskIdEditPostData,
  BreakSignaturesEndpointTasksTaskIdEditPostResponses,
  BreakSignaturesEndpointTasksTaskIdEditPostErrors,
  UpdateTaskNotesTasksTaskIdNotesPutData,
  UpdateTaskNotesTasksTaskIdNotesPutResponses,
  UpdateTaskNotesTasksTaskIdNotesPutErrors,
  BulkAppendTaskNotesTasksNotesBulkPostData,
  BulkAppendTaskNotesTasksNotesBulkPostResponses,
  BulkAppendTaskNotesTasksNotesBulkPostErrors,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetData,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetResponses,
  GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetErrors,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
  MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
  MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
  RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
  PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
  CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetData,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetResponses,
  GetPatientGoalsForVisitGoalsVisitVisitIdGetErrors,
  AddGoalToVisitGoalsVisitVisitIdPostData,
  AddGoalToVisitGoalsVisitVisitIdPostResponses,
  AddGoalToVisitGoalsVisitVisitIdPostErrors,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetData,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetResponses,
  GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetErrors,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetData,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetResponses,
  GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetErrors,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostData,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostResponses,
  GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostErrors,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetData,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetResponses,
  GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetErrors,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetData,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetResponses,
  GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetErrors,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetData,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetResponses,
  GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetErrors,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetData,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetResponses,
  GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetErrors,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteData,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteResponses,
  DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteErrors,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutData,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutResponses,
  UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutErrors,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostData,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostResponses,
  AddInterventionToVisitGoalsVisitVisitIdInterventionPostErrors,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteData,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteResponses,
  DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteErrors,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostData,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostResponses,
  ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostErrors,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostData,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostResponses,
  SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostErrors,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostData,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostResponses,
  CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostErrors,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostData,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostResponses,
  BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostErrors,
  SendSupportEmailApiSupportContactPostData,
  SendSupportEmailApiSupportContactPostResponses,
  SendSupportEmailApiSupportContactPostErrors,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostData,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostResponses,
  PreviewTestPatientCleanupAdminTestPatientsPreviewPostErrors,
  DeleteTestPatientsAdminTestPatientsDeletePostData,
  DeleteTestPatientsAdminTestPatientsDeletePostResponses,
  DeleteTestPatientsAdminTestPatientsDeletePostErrors,
  GetAgenciesInternalToolsAgenciesGetData,
  GetAgenciesInternalToolsAgenciesGetResponses,
  GetAgenciesInternalToolsAgenciesGetErrors,
  CreateAgencyInternalToolsAgenciesPostData,
  CreateAgencyInternalToolsAgenciesPostResponses,
  CreateAgencyInternalToolsAgenciesPostErrors,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetData,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetResponses,
  ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetErrors,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteData,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteResponses,
  RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteErrors,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetData,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetResponses,
  GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetErrors,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutData,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutResponses,
  UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutErrors,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostData,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostResponses,
  SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostErrors,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetData,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetResponses,
  GetAllProductUpdatesInternalToolsProductUpdatesAllGetErrors,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchData,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchResponses,
  UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchErrors,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostData,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostResponses,
  UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostErrors,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteData,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteResponses,
  DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteErrors,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteData,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteResponses,
  DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteErrors,
  InternalHealthCheckInternalHealthGetData,
  InternalHealthCheckInternalHealthGetResponses,
  InternalHealthCheckInternalHealthGetErrors,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostData,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostResponses,
  EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostErrors,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetData,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsInternalPatientsPatientIdMedicationsGetErrors,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostData,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostResponses,
  CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostErrors,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostData,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostResponses,
  GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostErrors,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteData,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteResponses,
  DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteErrors,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetData,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetErrors,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutData,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutResponses,
  UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutErrors,
  GetVisitsListInternalInternalVisitsGetData,
  GetVisitsListInternalInternalVisitsGetResponses,
  GetVisitsListInternalInternalVisitsGetErrors,
  CreateVisitInternalInternalVisitsPostData,
  CreateVisitInternalInternalVisitsPostResponses,
  CreateVisitInternalInternalVisitsPostErrors,
  DeleteVisitInternalInternalVisitsVisitIdDeleteData,
  DeleteVisitInternalInternalVisitsVisitIdDeleteResponses,
  DeleteVisitInternalInternalVisitsVisitIdDeleteErrors,
  GetVisitInternalInternalVisitsVisitIdGetData,
  GetVisitInternalInternalVisitsVisitIdGetResponses,
  GetVisitInternalInternalVisitsVisitIdGetErrors,
  UpdateVisitInternalInternalVisitsVisitIdPutData,
  UpdateVisitInternalInternalVisitsVisitIdPutResponses,
  UpdateVisitInternalInternalVisitsVisitIdPutErrors,
  GetVisitDataInternalInternalVisitsVisitIdDataGetData,
  GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
  GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutData,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutResponses,
  UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutErrors,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutData,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutResponses,
  PushVisitEvvInternalInternalVisitsVisitIdEvvPutErrors,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
  MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
  MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
  RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
  PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
  CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetData,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetResponses,
  GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetErrors,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostData,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostResponses,
  AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostErrors,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetData,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetResponses,
  GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetErrors,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostData,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostResponses,
  GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostErrors,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetData,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetResponses,
  GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetErrors,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostData,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostResponses,
  AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostErrors,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetData,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetErrors,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetData,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetData,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetResponses,
  ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetErrors,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostData,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostResponses,
  CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostErrors,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteData,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteResponses,
  DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteErrors,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutData,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutResponses,
  UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutErrors,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutData,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutResponses,
  UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutErrors,
  GenerateTestDataDevTestDataGeneratePostData,
  GenerateTestDataDevTestDataGeneratePostResponses,
  GenerateTestDataDevTestDataGeneratePostErrors,
  ClearTestDataDevTestDataClearDeleteData,
  ClearTestDataDevTestDataClearDeleteResponses,
  ClearTestDataDevTestDataClearDeleteErrors,
  DeletePatientHardDevTestDataPatientPatientIdDeleteData,
  DeletePatientHardDevTestDataPatientPatientIdDeleteResponses,
  DeletePatientHardDevTestDataPatientPatientIdDeleteErrors,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostData,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostResponses,
  ImportKinnserPatientPortfolioDevTestDataKinnserImportPostErrors,
  RunDemoAgencySetupEndpointDemoAgencySetupPostData,
  RunDemoAgencySetupEndpointDemoAgencySetupPostResponses,
  RunDemoAgencySetupEndpointDemoAgencySetupPostErrors,
  RootGetData,
  RootGetResponses,
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Trigger Error
 */
export const triggerErrorSentryDebugExceptionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<TriggerErrorSentryDebugExceptionGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TriggerErrorSentryDebugExceptionGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/exception',
    ...options,
  });
};

/**
 * Log Error
 */
export const logErrorSentryDebugLogErrorGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LogErrorSentryDebugLogErrorGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LogErrorSentryDebugLogErrorGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/log-error',
    ...options,
  });
};

/**
 * Health Check
 * Health check endpoint
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthCheckHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/health',
    ...options,
  });
};

/**
 * Login
 * Redirect to WorkOS SSO login page.
 */
export const loginAuthLoginGet = <ThrowOnError extends boolean = false>(
  options?: Options<LoginAuthLoginGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LoginAuthLoginGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/login',
    ...options,
  });
};

/**
 * Auth Callback
 * Handle WorkOS authentication callback.
 */
export const authCallbackAuthCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthCallbackAuthCallbackGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    AuthCallbackAuthCallbackGetResponses,
    AuthCallbackAuthCallbackGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/callback',
    ...options,
  });
};

/**
 * Logout
 * Logout user by clearing cookies and triggering WorkOS logout.
 */
export const logoutAuthLogoutGet = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutAuthLogoutGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LogoutAuthLogoutGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/logout',
    ...options,
  });
};

/**
 * Get Current Ctx Info
 * Get current user information with agency details.
 */
export const getCurrentCtxInfoAuthMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentCtxInfoAuthMeGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCurrentCtxInfoAuthMeGetResponses,
    GetCurrentCtxInfoAuthMeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/me',
    ...options,
  });
};

/**
 * Get Widget Token
 * Get widget token for WorkOS widgets (e.g., OrganizationSwitcher).
 * Returns the access token from the current session.
 */
export const getWidgetTokenAuthWidgetTokenGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetWidgetTokenAuthWidgetTokenGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetWidgetTokenAuthWidgetTokenGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/widget-token',
    ...options,
  });
};

/**
 * Switch Organization
 * Switch to a different organization.
 * Returns a redirect URL to re-authenticate with the new organization.
 */
export const switchOrganizationAuthSwitchOrganizationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SwitchOrganizationAuthSwitchOrganizationPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SwitchOrganizationAuthSwitchOrganizationPostResponses,
    SwitchOrganizationAuthSwitchOrganizationPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/switch-organization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Organizations
 * Get all organizations that the current user belongs to.
 * Used for the organization switcher to display available organizations.
 */
export const getUserOrganizationsAuthOrganizationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserOrganizationsAuthOrganizationsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserOrganizationsAuthOrganizationsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/organizations',
    ...options,
  });
};

/**
 * Get Active Attestations
 * Return the currently active attestation text per family for the signing UI.
 *
 * Clients display this text before calling sign/approve; they send
 * ``attestation_version`` on those calls for server validation.
 */
export const getActiveAttestationsSigningAttestationsActiveGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetActiveAttestationsSigningAttestationsActiveGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetActiveAttestationsSigningAttestationsActiveGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/signing/attestations/active',
    ...options,
  });
};

/**
 * Get Esignature Credential Status
 * Whether the caller has an e-signature password, and any active lockout.
 *
 * The signing dialog uses this to choose between asking for the existing
 * password and walking a first-time signer through creating one.
 */
export const getEsignatureCredentialStatusSigningCredentialGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEsignatureCredentialStatusSigningCredentialGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEsignatureCredentialStatusSigningCredentialGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/signing/credential',
    ...options,
  });
};

/**
 * Set Esignature Credential
 * Create the caller's first e-signature password.
 */
export const setEsignatureCredentialSigningCredentialPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetEsignatureCredentialSigningCredentialPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    SetEsignatureCredentialSigningCredentialPutResponses,
    SetEsignatureCredentialSigningCredentialPutErrors,
    ThrowOnError
  >({
    url: '/signing/credential',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Change Esignature Credential
 * Replace the caller's e-signature password, proving the current one.
 */
export const changeEsignatureCredentialSigningCredentialChangePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ChangeEsignatureCredentialSigningCredentialChangePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ChangeEsignatureCredentialSigningCredentialChangePostResponses,
    ChangeEsignatureCredentialSigningCredentialChangePostErrors,
    ThrowOnError
  >({
    url: '/signing/credential/change',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Request Esignature Credential Reset
 * Email the caller a single-use code to reset their e-signature password.
 *
 * The destination is always the caller's own stored email. There is no address
 * parameter, so a reset can neither be aimed at someone else nor used to probe
 * which addresses exist.
 */
export const requestEsignatureCredentialResetSigningCredentialResetRequestPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      RequestEsignatureCredentialResetSigningCredentialResetRequestPostData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).post<
      RequestEsignatureCredentialResetSigningCredentialResetRequestPostResponses,
      unknown,
      ThrowOnError
    >({
      url: '/signing/credential/reset-request',
      ...options,
    });
  };

/**
 * Complete Esignature Credential Reset
 * Set a new e-signature password from an emailed reset code.
 *
 * Authenticated, so a reset needs both the emailed code (proving control of
 * the inbox) and a live session (proving SSO identity).
 */
export const completeEsignatureCredentialResetSigningCredentialResetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CompleteEsignatureCredentialResetSigningCredentialResetPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CompleteEsignatureCredentialResetSigningCredentialResetPostResponses,
    CompleteEsignatureCredentialResetSigningCredentialResetPostErrors,
    ThrowOnError
  >({
    url: '/signing/credential/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Intakes For Auth Management
 * Get intake records for authorization management.
 * Returns intakes that need attention for:
 * - Missing eligibility check (no successful check in last 30 days)
 * - Missing prior authorization (requires_prior_auth=true but not VERIFIED)
 * - Pending review or under review status
 * - Accepted status (ready to admit)
 *
 * Excludes:
 * - Rejected intakes (not active for authorization management)
 * - Scheduled intakes that don't have eligibility or authorization issues
 *
 * If user has an agency, results are filtered to that agency.
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects
 */
export const getIntakesForAuthManagementAuthorizationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakesForAuthManagementAuthorizationGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakesForAuthManagementAuthorizationGetResponses,
    GetIntakesForAuthManagementAuthorizationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/',
    ...options,
  });
};

/**
 * List Permissions
 * List permissions from the global catalog, optionally filtered by scope.
 */
export const listPermissionsRbacPermissionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPermissionsRbacPermissionsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListPermissionsRbacPermissionsGetResponses,
    ListPermissionsRbacPermissionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions',
    ...options,
  });
};

/**
 * Create Permission
 * Create a new permission (system-wide).
 */
export const createPermissionRbacPermissionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePermissionRbacPermissionsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePermissionRbacPermissionsPostResponses,
    CreatePermissionRbacPermissionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Permission
 * Get a specific permission by ID.
 */
export const getPermissionRbacPermissionsPermissionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPermissionRbacPermissionsPermissionIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPermissionRbacPermissionsPermissionIdGetResponses,
    GetPermissionRbacPermissionsPermissionIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions/{permission_id}',
    ...options,
  });
};

/**
 * Update Permission
 * Update a permission's name and/or description.
 */
export const updatePermissionRbacPermissionsPermissionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePermissionRbacPermissionsPermissionIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdatePermissionRbacPermissionsPermissionIdPatchResponses,
    UpdatePermissionRbacPermissionsPermissionIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/permissions/{permission_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Roles
 * List roles visible to the current agency (system + agency-specific).
 * When agency_id is provided, requires strawhat super-user access and returns
 * roles for that specific agency instead of the caller's current agency.
 *
 * If SHOW_UNASSIGNED_ROLES is enabled, roles are filtered by:
 * - Always show roles the user already has assigned
 * - Show roles with no feature_flag_slug (visible to everyone)
 * - Show roles where the user has the required feature flag
 */
export const listRolesRbacRolesGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListRolesRbacRolesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListRolesRbacRolesGetResponses,
    ListRolesRbacRolesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles',
    ...options,
  });
};

/**
 * Create Role
 * Create a role for the current agency, optionally attaching permissions in the same transaction.
 */
export const createRoleRbacRolesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateRoleRbacRolesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateRoleRbacRolesPostResponses,
    CreateRoleRbacRolesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Role
 * Soft-delete a custom role.
 */
export const deleteRoleRbacRolesRoleIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteRoleRbacRolesRoleIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteRoleRbacRolesRoleIdDeleteResponses,
    DeleteRoleRbacRolesRoleIdDeleteErrors,
    ThrowOnError
  >({
    url: '/rbac/roles/{role_id}',
    ...options,
  });
};

/**
 * Get Role
 * Get a specific role by ID.
 */
export const getRoleRbacRolesRoleIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetRoleRbacRolesRoleIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetRoleRbacRolesRoleIdGetResponses,
    GetRoleRbacRolesRoleIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles/{role_id}',
    ...options,
  });
};

/**
 * Update Role
 * Update a custom role's name, description, and permissions in a single transaction.
 */
export const updateRoleRbacRolesRoleIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateRoleRbacRolesRoleIdPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateRoleRbacRolesRoleIdPatchResponses,
    UpdateRoleRbacRolesRoleIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/roles/{role_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Role Permissions
 * List all permissions assigned to a role.
 */
export const listRolePermissionsRbacRolePermissionsRoleIdPermissionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetResponses,
    ListRolePermissionsRbacRolePermissionsRoleIdPermissionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_permissions/{role_id}/permissions',
    ...options,
  });
};

/**
 * Add Permission To Role
 * Add a permission to a role.
 */
export const addPermissionToRoleRbacRolePermissionsRoleIdPermissionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostResponses,
    AddPermissionToRoleRbacRolePermissionsRoleIdPermissionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_permissions/{role_id}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Remove Permission From Role
 * Remove a permission from a role.
 */
export const removePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteResponses,
      RemovePermissionFromRoleRbacRolePermissionsRoleIdPermissionsPermissionIdDeleteErrors,
      ThrowOnError
    >({
      url: '/rbac/role_permissions/{role_id}/permissions/{permission_id}',
      ...options,
    });
  };

/**
 * Create Agency Assignment
 * Assign a role to a user at agency level.
 */
export const createAgencyAssignmentRbacRoleAssignmentsAgencyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostResponses,
    CreateAgencyAssignmentRbacRoleAssignmentsAgencyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/agency',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Clinic Assignment
 * Assign a role to a user at clinic level.
 */
export const createClinicAssignmentRbacRoleAssignmentsClinicPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostResponses,
    CreateClinicAssignmentRbacRoleAssignmentsClinicPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/clinic',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Bulk Upsert Assignments
 * Upsert role assignments for a set of users, reconciling against the current state.
 *
 * Users in user_ids get active assignments (created or restored).
 * Users not in user_ids have their active assignments soft-deleted.
 * For clinic-scoped roles, reconciliation is scoped to the provided clinic_ids.
 * Returns all currently active assignments for the role after the operation.
 */
export const bulkUpsertAssignmentsRbacRoleAssignmentsBulkPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutResponses,
    BulkUpsertAssignmentsRbacRoleAssignmentsBulkPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Users By Role
 * Return all users that have the given role, optionally scoped to specific clinics.
 *
 * - Without `clinic_ids`: returns users with an agency-scoped assignment. `clinic_ids` in
 * each item will be empty.
 * - With `clinic_ids`: returns users with a clinic-scoped assignment at any of the given
 * clinics. `clinic_ids` in each item lists only the clinics from the provided set where
 * the user holds the role.
 */
export const getUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetResponses,
    GetUsersByRoleRbacRoleAssignmentsUsersByRoleRoleIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/users-by-role/{role_id}',
    ...options,
  });
};

/**
 * List User Assignments
 * List all active role assignments for a specific user in the current agency.
 */
export const listUserAssignmentsRbacRoleAssignmentsUserUserIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetResponses,
    ListUserAssignmentsRbacRoleAssignmentsUserUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/user/{user_id}',
    ...options,
  });
};

/**
 * Bulk Assign Agency Roles To User
 * Reconcile agency-scoped role assignments for a single user.
 *
 * role_ids defines the complete desired set of agency-scoped roles.
 * Any active agency-scoped assignments not in role_ids are soft-deleted.
 */
export const bulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutResponses,
      BulkAssignAgencyRolesToUserRbacRoleAssignmentsUserUserIdAgencyRolesPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/user/{user_id}/agency-roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Bulk Assign Clinic Roles To User
 * Reconcile clinic-scoped role assignments for a single user.
 *
 * assignments defines the complete desired set of (role_id, clinic_id) pairs.
 * Any active clinic-scoped assignments not represented here are soft-deleted.
 */
export const bulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutResponses,
      BulkAssignClinicRolesToUserRbacRoleAssignmentsUserUserIdClinicRolesPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/user/{user_id}/clinic-roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * List Distinct Roles Assigned At Agency
 * Distinct roles that have at least one active user assignment at the given agency.
 *
 * Cross-agency reads require strawhat super-user access (enforced by
 * ``optional_agency_execution_scope`` before calling CRUD).
 */
export const listDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetResponses,
      ListDistinctRolesAssignedAtAgencyRbacRoleAssignmentsAgenciesAgencyIdAssignedRolesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/agencies/{agency_id}/assigned_roles',
      ...options,
    });
  };

/**
 * Delete Assignment
 * Soft-delete a role assignment.
 */
export const deleteAssignmentRbacRoleAssignmentsAssignmentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteResponses,
    DeleteAssignmentRbacRoleAssignmentsAssignmentIdDeleteErrors,
    ThrowOnError
  >({
    url: '/rbac/role_assignments/{assignment_id}',
    ...options,
  });
};

/**
 * Get Assignment
 * Get a specific role assignment by ID.
 */
export const getAssignmentRbacRoleAssignmentsAssignmentIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetResponses,
    GetAssignmentRbacRoleAssignmentsAssignmentIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/role_assignments/{assignment_id}',
    ...options,
  });
};

/**
 * List User Role Assignments
 * List all active role assignments for a user in an agency, including both:
 * - agency-scoped roles (clinic_id is null)
 * - clinic-scoped roles (clinic_id is set)
 */
export const listUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetResponses,
      ListUserRoleAssignmentsRbacRoleAssignmentsUsersUserIdAssignmentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/rbac/role_assignments/users/{user_id}/assignments',
      ...options,
    });
  };

/**
 * List Workos Feature Flags
 * List all feature-flag slugs defined in the WorkOS environment.
 */
export const listWorkosFeatureFlagsRbacFeatureFlagsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListWorkosFeatureFlagsRbacFeatureFlagsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListWorkosFeatureFlagsRbacFeatureFlagsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rbac/feature-flags',
    ...options,
  });
};

/**
 * Get Users
 * Get all users with pagination
 */
export const getUsersUsersGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersUsersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUsersUsersGetResponses,
    GetUsersUsersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
  });
};

/**
 * Create User
 * Create a new user
 */
export const createUserUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserUsersPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateUserUsersPostResponses,
    CreateUserUsersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Agency Members
 * Returns user records ordered by last name, first name.
 * Does not require elevated permissions beyond normal agency access.
 * When agency_id is provided, requires strawhat super-user access and returns
 * users for that specific agency instead of the caller's current agency.
 */
export const getAgencyMembersUsersAgencyMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyMembersUsersAgencyMembersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyMembersUsersAgencyMembersGetResponses,
    GetAgencyMembersUsersAgencyMembersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/agency-members',
    ...options,
  });
};

/**
 * Get Users By Permission
 * Return users in the current agency who have the given permission at the requested scope.
 */
export const getUsersByPermissionUsersByPermissionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersByPermissionUsersByPermissionGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUsersByPermissionUsersByPermissionGetResponses,
    GetUsersByPermissionUsersByPermissionGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/by-permission',
    ...options,
  });
};

/**
 * List Org Members
 * List all members of the current WorkOS organization who are not Roger Admins unless
 * the user making the request is a super user.
 * Used by Clinician Manager to list all users in the current organization.
 *
 * For each member, includes their Roger User record (if it exists),
 * all UserClinic assignments in the current agency, and distinct RBAC role
 * display names from active role assignments in this agency.
 */
export const listOrgMembersUsersOrgMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListOrgMembersUsersOrgMembersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListOrgMembersUsersOrgMembersGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/org-members',
    ...options,
  });
};

/**
 * Invite User
 * Invite one or more users to the agency.
 *
 * Accepts a list of emails and processes them all in a single request.
 * Creates Roger DB records (User, UserAgency, RoleAssignments) for each email,
 * then sends WorkOS invitations/memberships in parallel to avoid N+1 API calls.
 */
export const inviteUserUsersInvitePost = <ThrowOnError extends boolean = false>(
  options: Options<InviteUserUsersInvitePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    InviteUserUsersInvitePostResponses,
    InviteUserUsersInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Resend Invite
 * Resend the invitation email for a single pending user in the caller's agency.
 *
 * Looks up the pending WorkOS invitation for the email in the caller's organization
 * and resends it. If no pending invitation exists (e.g. it expired), a fresh
 * invitation is sent instead. No Roger DB records are mutated — this only re-triggers
 * the WorkOS invitation email, so existing role assignments are preserved.
 */
export const resendInviteUsersResendInvitePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ResendInviteUsersResendInvitePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ResendInviteUsersResendInvitePostResponses,
    ResendInviteUsersResendInvitePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/resend-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update User Roles
 * Replace a user's agency-scoped role assignments.
 * Works for both active users and pending (invited-but-not-yet-logged-in) users.
 * When agency_id is provided, requires strawhat super-user access and operates
 * on that specific agency instead of the caller's current agency.
 */
export const updateUserRolesUsersUserIdRolesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserRolesUsersUserIdRolesPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateUserRolesUsersUserIdRolesPutResponses,
    UpdateUserRolesUsersUserIdRolesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete User
 * Delete a user
 */
export const deleteUserUsersUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUserUsersUserIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteUserUsersUserIdDeleteResponses,
    DeleteUserUsersUserIdDeleteErrors,
    ThrowOnError
  >({
    url: '/users/{user_id}',
    ...options,
  });
};

/**
 * Get User
 * Get a specific user by ID. Restricted to Strawhat super-users.
 */
export const getUserUsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserUsersUserIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUserUsersUserIdGetResponses,
    GetUserUsersUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
  });
};

/**
 * Update User
 * Update a user
 */
export const updateUserUsersUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserUsersUserIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateUserUsersUserIdPutResponses,
    UpdateUserUsersUserIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Clinic Disciplines
 * Update clinical disciplines for a user at each clinic.
 */
export const updateClinicDisciplinesUsersUserIdClinicDisciplinesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutResponses,
    UpdateClinicDisciplinesUsersUserIdClinicDisciplinesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-disciplines',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Employee Types
 * Update per-clinic employee types for a user (EMR-517).
 */
export const updateEmployeeTypesUsersUserIdEmployeeTypePut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutResponses,
    UpdateEmployeeTypesUsersUserIdEmployeeTypePutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/employee-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sync Clinic Assignments
 * Endpoint no longer used. Keeping it here for now so that merge conflicts are minimized.
 */
export const syncClinicAssignmentsUsersUserIdClinicAssignmentsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign User To All Clinics
 * Endpoint no longer used. Keeping it here for now so that merge conflicts are minimized.
 */
export const assignUserToAllClinicsUsersUserIdAssignAllClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/assign-all-clinics',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update User Npi
 * Update a user's NPI number. Requires clinician-mgr:access permission.
 */
export const updateUserNpiUsersUserIdNpiPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserNpiUsersUserIdNpiPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateUserNpiUsersUserIdNpiPatchResponses,
    UpdateUserNpiUsersUserIdNpiPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/npi',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update User Type
 * Update a user's agency-scoped clinical title (EMR-699).
 */
export const updateUserTypeUsersUserIdUserTypePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateUserTypeUsersUserIdUserTypePatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateUserTypeUsersUserIdUserTypePatchResponses,
    UpdateUserTypeUsersUserIdUserTypePatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/user-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Available Clinicians
 * Get available clinicians for the current context's agency. Raises error if no agency in context.
 */
export const getAvailableCliniciansUserClinicsAvailableGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAvailableCliniciansUserClinicsAvailableGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAvailableCliniciansUserClinicsAvailableGetResponses,
    GetAvailableCliniciansUserClinicsAvailableGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/available',
    ...options,
  });
};

/**
 * Delete Current Agency
 * Delete the caller's current agency (Strawhat super-user only).
 */
export const deleteCurrentAgencyAgenciesDelete = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DeleteCurrentAgencyAgenciesDeleteData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).delete<
    DeleteCurrentAgencyAgenciesDeleteResponses,
    unknown,
    ThrowOnError
  >({
    url: '/agencies',
    ...options,
  });
};

/**
 * Update Current Agency
 * Update the caller's current agency.
 */
export const updateCurrentAgencyAgenciesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCurrentAgencyAgenciesPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateCurrentAgencyAgenciesPutResponses,
    UpdateCurrentAgencyAgenciesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Agency Config
 * Return Intake Manager column customization for the current agency.
 */
export const getAgencyConfigAgencyConfigGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyConfigAgencyConfigGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyConfigAgencyConfigGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-config',
    ...options,
  });
};

/**
 * Update Agency Config
 * Update configuration for the current agency.
 *
 * Both fields are independently optional: a caller that sends only one leaves
 * the other untouched. That matters because the column layout and the
 * signature-workflow toggle are edited from different screens, and a partial
 * update from one must not reset the other.
 */
export const updateAgencyConfigAgencyConfigPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAgencyConfigAgencyConfigPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgencyConfigAgencyConfigPutResponses,
    UpdateAgencyConfigAgencyConfigPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Agency Clinics
 * Get agency clinics with optional filtering by agency
 */
export const getAgencyClinicsAgencyClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyClinicsAgencyClinicsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyClinicsAgencyClinicsGetResponses,
    GetAgencyClinicsAgencyClinicsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
  });
};

/**
 * Create Agency Clinic
 * Create a new agency clinic
 */
export const createAgencyClinicAgencyClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyClinicAgencyClinicsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyClinicAgencyClinicsPostResponses,
    CreateAgencyClinicAgencyClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Agency Clinic Physicians
 * List active clinic physicians for task creation and order assignment.
 */
export const listAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetResponses,
      ListAgencyClinicPhysiciansAgencyClinicsAgencyClinicIdPhysiciansGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/agency-clinics/{agency_clinic_id}/physicians',
      ...options,
    });
  };

/**
 * Delete Agency Clinic
 * Delete an agency clinic
 */
export const deleteAgencyClinicAgencyClinicsAgencyClinicIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
    ThrowOnError
  >({
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
  });
};

/**
 * Get Agency Clinic
 * Get a specific agency clinic by ID
 */
export const getAgencyClinicAgencyClinicsAgencyClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
  });
};

/**
 * Update Agency Clinic
 * Update an agency clinic
 */
export const updateAgencyClinicAgencyClinicsAgencyClinicIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sync Clinics From Clinic Info
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This endpoint retrieves clinic information from the RogerDoc API and creates
 * or updates AgencyClinic and AgencyInsurance records in the database.
 * Clinic records are deduplicated based on clinic_key, and insurance records
 * are deduplicated based on clinic_key and insurance_key.
 *
 * Args:
 * request: FastAPI request object
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * Dictionary with sync results:
 * {
 * "clinics": {
 * "created_count": 5,
 * "updated_count": 2,
 * "skipped_count": 1,
 * "total_count": 8
 * },
 * "insurances": {
 * "created_count": 12,
 * "updated_count": 3,
 * "skipped_count": 2,
 * "total_count": 17
 * },
 * "message": "Clinics and insurances synced successfully"
 * }
 *
 * Raises:
 * HTTPException: If RogerDoc API is unavailable or database operations fail
 */
export const syncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/sync-from-clinic-info',
    ...options,
  });
};

/**
 * Get Agency Insurances
 * Get agency insurance records.
 *
 * Retrieve insurance provider configurations for agencies. Can filter by
 * agency ID and/or agency clinic ID.
 *
 * Args:
 * agency_id: Optional UUID to filter by specific agency
 * agency_clinic_id: Optional UUID to filter by specific agency clinic
 * skip: Number of records to skip for pagination
 * limit: Optional maximum number of records to return (no limit if not specified)
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * List of agency insurance records
 */
export const getAgencyInsurancesClinicsInsuranceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyInsurancesClinicsInsuranceGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyInsurancesClinicsInsuranceGetResponses,
    GetAgencyInsurancesClinicsInsuranceGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance',
    ...options,
  });
};

/**
 * Create Agency Insurance
 * Create a new agency insurance record.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * The selected clinic must belong to the agency and must not participate in
 * Kinnser (``is_kinnser`` / deprecated KINNSER_SYNCED origin); Kinnser-
 * participating clinics manage insurances through the clinic-info sync.
 */
export const createAgencyInsuranceClinicsInsurancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyInsuranceClinicsInsurancePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyInsuranceClinicsInsurancePostResponses,
    CreateAgencyInsuranceClinicsInsurancePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Duplicate Clinic Insurances
 * Copy every insurance from a source clinic onto a destination clinic.
 *
 * Useful when onboarding a clinic that should reuse the insurance roster of
 * another (e.g. copying from a scraped Kinnser clinic onto a Roger-only
 * clinic). Destination must not participate in Kinnser. Insurances whose
 * Payer ID and name already exist on the destination clinic are skipped, so
 * the operation is safe to re-run.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Both clinics
 * must belong to the agency.
 */
export const duplicateClinicInsurancesClinicsInsuranceDuplicatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostResponses,
    DuplicateClinicInsurancesClinicsInsuranceDuplicatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Refresh Payor Enrollments
 * Fetch clinic payor enrollment status from Stedi and return refreshed insurances.
 *
 * Queries the Stedi Enrollments API for the clinic's NPI, maps each enrollment
 * onto the clinic's tracked eligibility/claims/ERA statuses, and returns the
 * clinic's insurance rows with the updated statuses.
 */
export const refreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostResponses,
      RefreshPayorEnrollmentsClinicsInsuranceRefreshPayorEnrollmentsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/clinics/insurance/refresh-payor-enrollments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Agency Insurance
 * Delete an agency insurance record.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * Only insurances belonging to the current user's agency can be deleted.
 */
export const deleteAgencyInsuranceClinicsInsuranceInsuranceIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteResponses,
    DeleteAgencyInsuranceClinicsInsuranceInsuranceIdDeleteErrors,
    ThrowOnError
  >({
    url: '/clinics/insurance/{insurance_id}',
    ...options,
  });
};

/**
 * Update Agency Insurance
 * Update an existing agency insurance record.
 *
 * Only available when the agency has is_rogeremr_enabled=True.
 * Only insurances belonging to the current user's agency can be updated.
 * Re-maps payor_id when edi_payer_id changes.
 */
export const updateAgencyInsuranceClinicsInsuranceInsuranceIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutResponses,
    UpdateAgencyInsuranceClinicsInsuranceInsuranceIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Insurance Visit Rates
 * Get the per-visit rate grid for an insurance.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency are visible.
 */
export const getInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetResponses,
    GetInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}/rates',
    ...options,
  });
};

/**
 * Replace Insurance Visit Rates
 * Replace an insurance's per-visit rate rows with an admin edit (replace-all).
 *
 * Rows absent from the payload are deleted; created rows are MANUAL; existing
 * rows whose values change flip to MANUAL but keep their WellSky provenance.
 * Returns the fresh, authoritative grid after saving.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency can be edited.
 */
export const replaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutResponses,
    ReplaceInsuranceVisitRatesClinicsInsuranceInsuranceIdRatesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance/{insurance_id}/rates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Insurance Visit Rate Defaults
 * Get the Roger default billing codes for an insurance's rate grid (EMR-198).
 *
 * Pure lookup — never writes. One record per non-legacy visit type: revenue
 * from the global map, and the Medicare HCPCS G-code only for Medicare-like
 * payers (other payers get a null hcpcs_code so the gap stays visible).
 *
 * Only available when the agency has is_rogeremr_enabled=True. Only
 * insurances belonging to the current user's agency are visible.
 */
export const getInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetResponses,
      GetInsuranceVisitRateDefaultsClinicsInsuranceInsuranceIdRatesDefaultsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/clinics/insurance/{insurance_id}/rates/defaults',
      ...options,
    });
  };

/**
 * Match Patients
 * Find potential duplicate patients in Roger EMR for the same agency clinic.
 *
 * Weighted scoring (SSN, name, DOB, phone, zip, gender) with a minimum score
 * threshold; intended to mirror Kinnser-style duplicate detection for intakes.
 */
export const matchPatientsPatientsMatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MatchPatientsPatientsMatchPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MatchPatientsPatientsMatchPostResponses,
    MatchPatientsPatientsMatchPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/match',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patients
 * Get all patients with optional search and pagination.
 * If user has an agency, results are filtered to that agency.
 * By default, only patients with at least one active episode are returned.
 * Set show_inactive=true to include all patients.
 */
export const getPatientsPatientsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPatientsPatientsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPatientsPatientsGetResponses,
    GetPatientsPatientsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
  });
};

/**
 * Create Patient
 * Create a new patient.
 * Admission and episode are NOT auto-created - they must be created separately
 * with a valid start date through the intake workflow or admission endpoint.
 */
export const createPatientPatientsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatientPatientsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientPatientsPostResponses,
    CreatePatientPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Patient Test Status
 * Mark or un-mark a patient as a test/practice patient.
 *
 * Available to any authenticated clinician (Keyur, ROG-1718) — clinicians in
 * training may need to run test patients before committing to real work. The
 * flag is set only here, never through the general patient update body. It does
 * not block billing: the payer/CMS exits warn-and-confirm (claim, NOA) or mock
 * (eligibility) for a flagged patient. The marking UI explains this up front.
 */
export const setPatientTestStatusPatientsPatientIdTestStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPatientTestStatusPatientsPatientIdTestStatusPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    SetPatientTestStatusPatientsPatientIdTestStatusPatchResponses,
    SetPatientTestStatusPatientsPatientIdTestStatusPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/test-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Count
 * Get total count of patients.
 * If user has an agency, count is filtered to that agency.
 */
export const getPatientCountPatientsCountGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPatientCountPatientsCountGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPatientCountPatientsCountGetResponses,
    GetPatientCountPatientsCountGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/count',
    ...options,
  });
};

/**
 * Delete Patient
 * Delete a patient.
 */
export const deletePatientPatientsPatientIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePatientPatientsPatientIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientPatientsPatientIdDeleteResponses,
    DeletePatientPatientsPatientIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}',
    ...options,
  });
};

/**
 * Get Patient
 * Get a specific patient by ID.
 */
export const getPatientPatientsPatientIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientPatientsPatientIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientPatientsPatientIdGetResponses,
    GetPatientPatientsPatientIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
  });
};

/**
 * Update Patient
 * Update a patient.
 */
export const updatePatientPatientsPatientIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePatientPatientsPatientIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdatePatientPatientsPatientIdPutResponses,
    UpdatePatientPatientsPatientIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Current Episode
 * Return the latest episode for a patient with its case manager assignment.
 */
export const getCurrentEpisodePatientsPatientIdCurrentEpisodeGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetResponses,
    GetCurrentEpisodePatientsPatientIdCurrentEpisodeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/current-episode',
    ...options,
  });
};

/**
 * Update Current Episode Case Manager
 * Update the case manager on the patient's latest episode.
 */
export const updateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).patch<
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchResponses,
      UpdateCurrentEpisodeCaseManagerPatientsPatientIdCurrentEpisodeCaseManagerPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/current-episode/case-manager',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Patient Visits
 * Get all visits for a patient (across all admissions/episodes).
 * If user has an agency, results are filtered to that agency.
 * Includes episode start and end dates for each visit.
 */
export const getPatientVisitsPatientsPatientIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientVisitsPatientsPatientIdVisitsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientVisitsPatientsPatientIdVisitsGetResponses,
    GetPatientVisitsPatientsPatientIdVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
  });
};

/**
 * Create Patient Visit
 * Create a new visit for a patient.
 *
 * The visit will be created for the provided episode, or the most recent
 * episode of the patient when no episode is provided.
 * If no episode exists, returns an error - episodes must be created explicitly
 * with proper start dates through the intake workflow or admission endpoint.
 * If user has an agency, ensures the patient belongs to that agency.
 */
export const createPatientVisitPatientsPatientIdVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientVisitPatientsPatientIdVisitsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientVisitPatientsPatientIdVisitsPostResponses,
    CreatePatientVisitPatientsPatientIdVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Tasks
 * Get all tasks (visits + orders) for a patient with task-scope fields only.
 */
export const getPatientTasksPatientsPatientIdTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientTasksPatientsPatientIdTasksGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientTasksPatientsPatientIdTasksGetResponses,
    GetPatientTasksPatientsPatientIdTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/tasks',
    ...options,
  });
};

/**
 * Bulk Create Patient Visits
 * Create several visits for a patient in a single transaction.
 *
 * Every visit is created for the same episode and assignee. Items may mix
 * visit types and disciplines, so a caller can schedule (for example) three RN
 * visits and two PT visits at once. The whole request is atomic: if any item
 * fails validation (e.g. a date outside the episode), none are created.
 *
 * The visits are created for the provided episode, or the patient's most
 * recent episode when none is provided. The episode must be active.
 */
export const bulkCreatePatientVisitsPatientsPatientIdVisitsBulkPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostResponses,
    BulkCreatePatientVisitsPatientsPatientIdVisitsBulkPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Documents
 * Get all documents for a patient.
 */
export const getPatientDocumentsPatientsPatientIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentsPatientsPatientIdDocumentsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
    GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
  });
};

/**
 * Upload Patient Document
 * Upload a new document for a patient.
 */
export const uploadPatientDocumentPatientsPatientIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadPatientDocumentPatientsPatientIdDocumentsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
    UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Get Patient Document Url
 * Get a presigned URL to view/download a specific patient document.
 */
export const getPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}/url',
    ...options,
  });
};

/**
 * Verify Patient Document Signature
 * Verify a signed patient document's integrity (e.g. medication record).
 *
 * Recomputes the MAC from the stored snapshot under the stored key and
 * checks the mutable signed_at column against its hashed twin in the
 * snapshot's signature_event block.
 */
export const verifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetResponses,
      VerifyPatientDocumentSignaturePatientsPatientIdDocumentsDocumentIdVerifyGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/documents/{document_id}/verify',
      ...options,
    });
  };

/**
 * Delete Patient Document
 * Soft-delete a patient document by setting deleted_at/deleted_by.
 */
export const deletePatientDocumentPatientsPatientIdDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteResponses,
    DeletePatientDocumentPatientsPatientIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}/documents/{document_id}',
    ...options,
  });
};

/**
 * Update Patient Document
 * Update a patient document (e.g., rename).
 */
export const updatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Patient Communications
 * List all patient communication log entries for a patient.
 */
export const listPatientCommunicationsPatientsPatientIdCommunicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetResponses,
    ListPatientCommunicationsPatientsPatientIdCommunicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/communications',
    ...options,
  });
};

/**
 * Create Patient Communication
 * Create a communication log entry for the patient's current episode.
 */
export const createPatientCommunicationPatientsPatientIdCommunicationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostResponses,
    CreatePatientCommunicationPatientsPatientIdCommunicationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/communications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Communication
 */
export const deletePatientCommunicationPatientCommunicationsCommunicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteResponses,
      DeletePatientCommunicationPatientCommunicationsCommunicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patient-communications/{communication_id}',
      ...options,
    });
  };

/**
 * Get Patient Communication
 */
export const getPatientCommunicationPatientCommunicationsCommunicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetResponses,
    GetPatientCommunicationPatientCommunicationsCommunicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patient-communications/{communication_id}',
    ...options,
  });
};

/**
 * Update Patient Communication
 */
export const updatePatientCommunicationPatientCommunicationsCommunicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutResponses,
      UpdatePatientCommunicationPatientCommunicationsCommunicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-communications/{communication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Patient Communication Pdf
 * Generate a PDF print view for a single patient communication.
 *
 * Renders the communication metadata (date, type, physician, assignee)
 * plus the free-form notes/details. Returns the PDF inline so the client
 * can open it in a new tab.
 */
export const getPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetResponses,
      GetPatientCommunicationPdfPatientCommunicationsCommunicationIdPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patient-communications/{communication_id}/pdf',
      ...options,
    });
  };

/**
 * Get Thirty Day Summary Prefill
 * Return 30-Day Summary fields prefilled from CMS-485 (preferred) or SOC OASIS.
 *
 * Demographics and physician header blocks on the PDF are resolved at render time
 * from patient/episode records; this endpoint only returns editable
 * ``communication_data`` fields.
 */
export const getThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetResponses,
      GetThirtyDaySummaryPrefillPatientCommunicationsCommunicationIdThirtyDaySummaryPrefillGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patient-communications/{communication_id}/thirty-day-summary-prefill',
      ...options,
    });
  };

/**
 * Get Thirty Day Summary Pdf
 * Generate a PDF print view for a 30-Day Summary communication.
 *
 * Mirrors ``get_discharge_summary_pdf`` in ``orders.py``: loads the
 * communication with full PDF context, rejects any non-30-Day-Summary type
 * with HTTP 400, and renders the clinical sections stored in
 * ``communication_data`` via :func:`render_communication_pdf_bytes`, which
 * dispatches a 30-Day Summary to its dedicated boxed-form generator.
 */
export const getThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetResponses,
      GetThirtyDaySummaryPdfPatientCommunicationsCommunicationIdThirtyDaySummaryPdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/patient-communications/{communication_id}/thirty-day-summary-pdf',
      ...options,
    });
  };

/**
 * Create Misc Task
 * Create a misc task on the patient's selected (or latest) episode.
 */
export const createMiscTaskPatientsPatientIdMiscTasksPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateMiscTaskPatientsPatientIdMiscTasksPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMiscTaskPatientsPatientIdMiscTasksPostResponses,
    CreateMiscTaskPatientsPatientIdMiscTasksPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/misc-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Misc Task
 */
export const deleteMiscTaskMiscTasksMiscTaskIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteMiscTaskMiscTasksMiscTaskIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteMiscTaskMiscTasksMiscTaskIdDeleteResponses,
    DeleteMiscTaskMiscTasksMiscTaskIdDeleteErrors,
    ThrowOnError
  >({
    url: '/misc-tasks/{misc_task_id}',
    ...options,
  });
};

/**
 * Get Misc Task
 */
export const getMiscTaskMiscTasksMiscTaskIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMiscTaskMiscTasksMiscTaskIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetMiscTaskMiscTasksMiscTaskIdGetResponses,
    GetMiscTaskMiscTasksMiscTaskIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/misc-tasks/{misc_task_id}',
    ...options,
  });
};

/**
 * Update Misc Task
 */
export const updateMiscTaskMiscTasksMiscTaskIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateMiscTaskMiscTasksMiscTaskIdPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateMiscTaskMiscTasksMiscTaskIdPatchResponses,
    UpdateMiscTaskMiscTasksMiscTaskIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/misc-tasks/{misc_task_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Import Waystar Csv Endpoint
 * Import payors from Waystar CSV file stored in S3.
 *
 * Downloads the CSV file from s3://roger-public-assets/waystar-payor-list.csv
 * and imports the payor data into the database.
 *
 * Returns:
 * Import results with counts and any errors
 */
export const importWaystarCsvEndpointPayorsImportWaystarCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-waystar-csv',
    ...options,
  });
};

/**
 * Import Stedi Csv Endpoint
 * Import payors from the latest Stedi payer network CSV.
 *
 * Downloads the CSV file directly from Stedi's payer network API
 * at https://www.stedi.com/healthcare/network and imports the
 * payor data into the database.
 *
 * Returns:
 * Import results with counts and any errors
 */
export const importStediCsvEndpointPayorsImportStediCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportStediCsvEndpointPayorsImportStediCsvPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-stedi-csv',
    ...options,
  });
};

/**
 * Search Payors Endpoint
 * Search payors by name or electronic payer ID.
 *
 * Performs case-insensitive partial matching against payor_name,
 * electronic_payor_id, and stedi_display_name fields.
 */
export const searchPayorsEndpointPayorsSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SearchPayorsEndpointPayorsSearchGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    SearchPayorsEndpointPayorsSearchGetResponses,
    SearchPayorsEndpointPayorsSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/search',
    ...options,
  });
};

/**
 * Get Payors Endpoint
 * Get all payors.
 *
 * Args:
 * db_session: Database session
 *
 * Returns:
 * List of payor records
 */
export const getPayorsEndpointPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPayorsEndpointPayorsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPayorsEndpointPayorsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
  });
};

/**
 * Create Payor Endpoint
 * Create a new payor record.
 *
 * Args:
 * payor_data: Payor creation data
 * db_session: Database session
 *
 * Returns:
 * Created payor record
 *
 * Raises:
 * HTTPException: If payor with same name already exists
 */
export const createPayorEndpointPayorsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePayorEndpointPayorsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePayorEndpointPayorsPostResponses,
    CreatePayorEndpointPayorsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Payor Endpoint
 * Delete a payor record.
 *
 * Args:
 * payor_id: Payor UUID
 * db_session: Database session
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const deletePayorEndpointPayorsPayorIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePayorEndpointPayorsPayorIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePayorEndpointPayorsPayorIdDeleteResponses,
    DeletePayorEndpointPayorsPayorIdDeleteErrors,
    ThrowOnError
  >({
    url: '/payors/{payor_id}',
    ...options,
  });
};

/**
 * Get Payor Endpoint
 * Get a specific payor by ID.
 *
 * Args:
 * payor_id: Payor UUID
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorEndpointPayorsPayorIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPayorEndpointPayorsPayorIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPayorEndpointPayorsPayorIdGetResponses,
    GetPayorEndpointPayorsPayorIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
  });
};

/**
 * Update Payor Endpoint
 * Update a payor record.
 *
 * Args:
 * payor_id: Payor UUID
 * payor_data: Payor update data
 * db_session: Database session
 *
 * Returns:
 * Updated payor record
 *
 * Raises:
 * HTTPException: If payor not found or validation fails
 */
export const updatePayorEndpointPayorsPayorIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePayorEndpointPayorsPayorIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdatePayorEndpointPayorsPayorIdPutResponses,
    UpdatePayorEndpointPayorsPayorIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Payor By Name Endpoint
 * Get a payor by name.
 *
 * Args:
 * payor_name: Name of the payor
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByNameEndpointPayorsByNamePayorNameGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPayorByNameEndpointPayorsByNamePayorNameGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
    GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/by-name/{payor_name}',
    ...options,
  });
};

/**
 * Get Payor By Electronic Id Endpoint
 * Get a payor by electronic payor ID.
 *
 * Args:
 * electronic_payor_id: Standardized industry identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-electronic-id/{electronic_payor_id}',
      ...options,
    });
  };

/**
 * Get Payor By Clearinghouse Id Endpoint
 * Get a payor by clearinghouse payor ID.
 *
 * Args:
 * clearinghouse_payor_id: Clearinghouse-specific identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-clearinghouse-id/{clearinghouse_payor_id}',
      ...options,
    });
  };

/**
 * List Payroll Visits
 * Payroll-eligible visits not yet included in any payroll (flat list).
 */
export const listPayrollVisitsPayrollVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListPayrollVisitsPayrollVisitsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListPayrollVisitsPayrollVisitsGetResponses,
    ListPayrollVisitsPayrollVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/visits',
    ...options,
  });
};

/**
 * Export Payroll Visits
 * Export ALL matching payroll-eligible visits to an Excel (.xlsx) file.
 */
export const exportPayrollVisitsPayrollVisitsExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportPayrollVisitsPayrollVisitsExportGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ExportPayrollVisitsPayrollVisitsExportGetResponses,
    ExportPayrollVisitsPayrollVisitsExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/visits/export',
    ...options,
  });
};

/**
 * List Payroll Entries
 * Date-wise payroll entries for the agency (Previous Payroll list).
 */
export const listPayrollEntriesPayrollEntriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListPayrollEntriesPayrollEntriesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListPayrollEntriesPayrollEntriesGetResponses,
    ListPayrollEntriesPayrollEntriesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries',
    ...options,
  });
};

/**
 * Create Payroll Entry
 * Add the selected visits to this clinic's payroll for the date (upsert).
 */
export const createPayrollEntryPayrollEntriesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePayrollEntryPayrollEntriesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePayrollEntryPayrollEntriesPostResponses,
    CreatePayrollEntryPayrollEntriesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Payroll Entry Visits
 * Visits inside a payroll entry, ordered by visit date for grouping.
 */
export const listPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetResponses,
    ListPayrollEntryVisitsPayrollEntriesPayrollEntryIdVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/{payroll_entry_id}/visits',
    ...options,
  });
};

/**
 * Remove Payroll Entry Visit
 * Remove one visit from a payroll, returning it to the Unpaid list.
 */
export const removePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteResponses,
      RemovePayrollEntryVisitPayrollEntriesPayrollEntryIdVisitsVisitIdDeleteErrors,
      ThrowOnError
    >({
      url: '/payroll/entries/{payroll_entry_id}/visits/{visit_id}',
      ...options,
    });
  };

/**
 * Delete Payroll Entry
 * Delete a payroll entry, releasing its visits back to the manager.
 */
export const deletePayrollEntryPayrollEntriesPayrollEntryIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteResponses,
    DeletePayrollEntryPayrollEntriesPayrollEntryIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payroll/entries/{payroll_entry_id}',
    ...options,
  });
};

/**
 * Get Product Updates For User
 * Return visible product updates for the current user.
 */
export const getProductUpdatesForUserProductUpdatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetProductUpdatesForUserProductUpdatesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetProductUpdatesForUserProductUpdatesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/product-updates',
    ...options,
  });
};

/**
 * Get Reporting Manifest
 */
export const getReportingManifestReportingManifestGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetReportingManifestReportingManifestGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetReportingManifestReportingManifestGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/manifest',
    ...options,
  });
};

/**
 * Get Reporting Extract
 * Serve one dataset's Parquet extract, optionally narrowed to an axis window.
 *
 * The scope params form a discriminated contract (Epic 5.1 D1): ``scope=full``
 * (the default) takes no other predicate param; ``scope=primary`` takes
 * ``axis`` plus ``kind`` (``range`` | ``equality`` | ``is_null``) and the
 * ``lower``/``upper`` bounds with their inclusivity. Scope is an I/O optimization
 * ONLY — the browser authored and executes the real ``WHERE``, and column scope
 * comes from ``served_columns``.
 *
 * **Only the PRIMARY dataset of a report may be windowed** (D4). Each dataset is a
 * separate extract that DuckDB joins in the browser, so the server cannot see join
 * intent: if a related fetch were windowed too, a visit from last month whose episode
 * started 14 months ago would arrive without its episode row and the LEFT JOIN would
 * silently produce NULL episode columns. Related fetches must use ``scope=full``.
 */
export const getReportingExtractReportingExtractsDatasetKeyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReportingExtractReportingExtractsDatasetKeyGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetReportingExtractReportingExtractsDatasetKeyGetResponses,
    GetReportingExtractReportingExtractsDatasetKeyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/extracts/{dataset_key}',
    ...options,
  });
};

/**
 * List Report Definitions
 */
export const listReportDefinitionsReportingReportDefinitionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListReportDefinitionsReportingReportDefinitionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ListReportDefinitionsReportingReportDefinitionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/report-definitions',
    ...options,
  });
};

/**
 * Create Report Definition
 */
export const createReportDefinitionReportingReportDefinitionsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateReportDefinitionReportingReportDefinitionsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateReportDefinitionReportingReportDefinitionsPostResponses,
    CreateReportDefinitionReportingReportDefinitionsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reporting/report-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Report Definition
 * Delete an agency report definition. Owner-only (_get_mutable_row).
 *
 * Deliberately NOT gated on _authorize_definition_access, unlike PATCH: that
 * gate is a DISCLOSURE control (every PATCH echoes the stored definition,
 * name, and description back to the caller), and a 204 discloses nothing.
 * Adding it here would make an owner who lost a joined dataset's permission
 * unable to delete their own report — it would vanish from the listing, 403
 * on PATCH, and 403 on DELETE, i.e. become undeletable dead weight only an
 * admin could clear. It would also break the repair path
 * _authorize_definition_access's own docstring names: an unparseable stored
 * definition 403s that gate by design, and delete-and-recreate is how the
 * owner fixes it. Owner-only deletion of a row the caller can no longer read
 * is intended; see test_delete_allowed_when_stored_definition_is_hidden.
 */
export const deleteReportDefinitionReportingReportDefinitionsDefinitionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteResponses,
      DeleteReportDefinitionReportingReportDefinitionsDefinitionIdDeleteErrors,
      ThrowOnError
    >({
      url: '/reporting/report-definitions/{definition_id}',
      ...options,
    });
  };

/**
 * Update Report Definition
 */
export const updateReportDefinitionReportingReportDefinitionsDefinitionIdPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).patch<
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchResponses,
      UpdateReportDefinitionReportingReportDefinitionsDefinitionIdPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reporting/report-definitions/{definition_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Reload Hipps Reference
 * Re-materialize the global hipps_* tables from the bundled SQLite DB.
 */
export const reloadHippsReferenceHippsReferenceReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ReloadHippsReferenceHippsReferenceReloadPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ReloadHippsReferenceHippsReferenceReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/hipps-reference/reload',
    ...options,
  });
};

/**
 * Reload Cms Geography
 * Re-materialize cms_zip_geography from bundled CSVs.
 */
export const reloadCmsGeographyCmsGeographyReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ReloadCmsGeographyCmsGeographyReloadPostData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ReloadCmsGeographyCmsGeographyReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cms-geography/reload',
    ...options,
  });
};

/**
 * List Value Codes Route
 * Full NUBC value-code list (110 assignable codes), ordered by code.
 */
export const listValueCodesRouteValueCodesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListValueCodesRouteValueCodesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListValueCodesRouteValueCodesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/value-codes',
    ...options,
  });
};

/**
 * Reload Value Codes
 * Re-materialize value_codes from the bundled CSV.
 */
export const reloadValueCodesValueCodesReloadPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ReloadValueCodesValueCodesReloadPostData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ReloadValueCodesValueCodesReloadPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/value-codes/reload',
    ...options,
  });
};

/**
 * Get Eligibility Checks Endpoint
 * Get eligibility checks with optional filtering.
 */
export const getEligibilityChecksEndpointEligibilityGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEligibilityChecksEndpointEligibilityGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEligibilityChecksEndpointEligibilityGetResponses,
    GetEligibilityChecksEndpointEligibilityGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/',
    ...options,
  });
};

/**
 * Perform Real Eligibility Check
 * Perform a real eligibility check for an intake using Stedi API.
 *
 * This endpoint:
 * 1. Gets the intake and associated payor data
 * 2. Creates a Stedi eligibility request using intake demographics directly
 * 3. Submits the request to Stedi API
 * 4. Creates an eligibility check record linked to the intake
 * 5. Updates the intake with eligibility results
 *
 * Note: Patient records are NOT created during eligibility checks.
 * Patients are only created at the "Push to EMR" step.
 *
 * Args:
 * intake_id: Intake UUID
 * db_session: Database session
 * current_ctx: Current user context with agency information
 *
 * Returns:
 * Created/updated eligibility check record
 *
 * Raises:
 * HTTPException: If intake not found, payor not found, or API call fails
 */
export const performRealEligibilityCheckEligibilityIntakeIntakeIdCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/intake/{intake_id}/check',
    ...options,
  });
};

/**
 * Enqueue Billing Cycle
 * Enqueue a Temporal workflow to create billing cycles for the current agency.
 *
 * Creates cycles for active episodes whose billing period has ended. If
 * ``current_date`` is omitted, the agency's timezone is used to determine the
 * date. Returns the workflow ID immediately; the workflow runs asynchronously.
 */
export const enqueueBillingCycleBillingDevEnqueueBillingCycleCreationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostResponses,
    EnqueueBillingCycleBillingDevEnqueueBillingCycleCreationPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/dev/enqueue-billing-cycle-creation',
    ...options,
  });
};

/**
 * Set Billing Cycle Status Pending Approval
 * Set the status of a billing cycle to pending approval.
 *
 * Possible paths:
 * - User approves -> READY_TO_SEND
 * - User clicks send -> PENDING_PAYMENT (plus sent to clearinghouse)
 * - Clearinghouse pays -> PAID
 * - Clearinghouse denies -> REJECTED
 * - User updates and resubmits -> PENDING_PAYMENT
 * - Repeat this process until the claim is paid or denied & user gives up
 * - User clicks void -> CANCELLED/REJECTED
 * - No possible paths after this point. The user has marked it as effectively deleted
 * We will never actually delete this or remove it from the display for auditing purposes.
 */
export const setBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostResponses,
      SetBillingCycleStatusPendingApprovalBillingBillingCycleBillingCycleIdSetStatusPendingApprovalPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/pending-approval',
      ...options,
    });
  };

/**
 * Set Billing Cycle Status Ready To Send
 * Set the status of a billing cycle to ready to send.
 */
export const setBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostResponses,
      SetBillingCycleStatusReadyToSendBillingBillingCycleBillingCycleIdSetStatusReadyToSendPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/ready-to-send',
      ...options,
    });
  };

/**
 * Set Billing Cycle Status Void
 * Void a billing cycle (Roger-side only).
 *
 * Allowed from PENDING_APPROVAL, READY_TO_SEND, or PENDING_PAYMENT.
 * Sets the cycle to CANCELLED, releases its visits for rebilling, and
 * instantly recreates a replacement DRAFT cycle for the same date range
 * (unless a live cycle already covers it). Any linked Claim and remittance
 * rows are intentionally left untouched (they are the immutable record of
 * what was submitted), and no cancellation claim (TOB 0328) is transmitted
 * to the payer.
 *
 * We will never actually delete this or remove it from the display for
 * auditing purposes.
 */
export const setBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostResponses,
      SetBillingCycleStatusVoidBillingBillingCycleBillingCycleIdSetStatusVoidPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/void',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Set Billing Cycle Status Pending Payment
 * Manually advance a billing cycle to pending payment WITHOUT transmitting to a
 * clearinghouse — for claims the user submitted outside Roger (payer portal,
 * paper). The claim record and its patient control number are set once at Create
 * Claim and are left unchanged here, except that ROG-2751 stamps the claim's
 * ``submitted_date`` (the Billed date) when it is unset, so manually-sent claims
 * show a Billed date like Stedi-sent ones. The user is responsible for tracking
 * the claim from here; the 277/835 pipeline will not advance it automatically.
 */
export const setBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostResponses,
      SetBillingCycleStatusPendingPaymentBillingBillingCycleBillingCycleIdSetStatusPendingPaymentPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/pending-payment',
      ...options,
    });
  };

/**
 * Set Billing Cycle Status Paid
 * Manually mark a pending-payment billing cycle as paid (e.g. payment
 * received outside the clearinghouse). Also marks the linked claim PAID.
 */
export const setBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostResponses,
      SetBillingCycleStatusPaidBillingBillingCycleBillingCycleIdSetStatusPaidPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/paid',
      ...options,
    });
  };

/**
 * Set Billing Cycle Status Rejected
 * Manually mark a pending-payment billing cycle as rejected. Also marks the
 * linked claim DENIED. This is also the recovery path for a mistaken
 * "mark as sent" (undo is out of scope).
 */
export const setBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostResponses,
      SetBillingCycleStatusRejectedBillingBillingCycleBillingCycleIdSetStatusRejectedPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/set-status/rejected',
      ...options,
    });
  };

/**
 * Send Billing Cycle To Clearinghouse
 * Send a billing cycle to the clearinghouse and update the status to pending payment.
 * After this point the billing cycle status will be updated by the back end listening
 * to the clearinghouse webhook.
 *
 * Right now it's just for stedi cause that's all we support
 *
 * Possible paths:
 * - clearinghouse pays -> PAID
 * - clearinghouse denies -> REJECTED
 * - User updates and resubmits -> PENDING_PAYMENT
 * - Repeat this process until the claim is paid or denied & user gives up
 */
export const sendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostResponses,
      SendBillingCycleToClearinghouseBillingBillingCycleBillingCycleIdSendToClearinghousePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/send-to-clearinghouse',
      ...options,
    });
  };

/**
 * Get Billing Cycles Meta Api
 * Get metadata for the current agency's billing cycles.
 */
export const getBillingCyclesMetaApiBillingBillingCyclesMetaGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetBillingCyclesMetaApiBillingBillingCyclesMetaGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetBillingCyclesMetaApiBillingBillingCyclesMetaGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/meta',
    ...options,
  });
};

/**
 * Get Billing Cycle Count For Patient Api
 * Count of the current agency's billing cycles for a patient (any status).
 */
export const getBillingCycleCountForPatientApiBillingBillingCyclesCountGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetResponses,
    GetBillingCycleCountForPatientApiBillingBillingCyclesCountGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/count',
    ...options,
  });
};

/**
 * Get Patient Geographic Value Codes Api
 * Return the generated UB-04 geographic value codes (VC 61/85) for a patient.
 *
 * VC 61 is the CBSA and VC 85 the FIPS county, both derived from the patient's
 * ZIP via the same CMS/HUD geography lookup that worksheet population uses to
 * fill missing VC 61/85 (see
 * ``fill_missing_geographic_value_codes_for_episode``). This is a read-only
 * derivation: it neither writes a worksheet nor applies the PDGM eligibility
 * gate (there is no billing cycle / insurance in scope here), so it always
 * reports whatever geography the patient's ZIP maps to.
 *
 * ``amount`` fields are ``None`` when the patient has no ZIP on file, the ZIP
 * does not map to CMS geography, or the reference table has no value for that
 * field. The values are raw code literals, not dollar amounts.
 */
export const getPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetResponses,
      GetPatientGeographicValueCodesApiBillingPatientPatientIdGeographicValueCodesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/patient/{patient_id}/geographic-value-codes',
      ...options,
    });
  };

/**
 * Get Draft Billing Cycles Api
 * Get a paginated page of draft billing cycles for the current agency.
 */
export const getDraftBillingCyclesApiBillingBillingCyclesDraftsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostResponses,
    GetDraftBillingCyclesApiBillingBillingCyclesDraftsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/drafts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Active Billing Cycles Api
 * Get a paginated page of billing cycles matching the given statuses.
 */
export const getActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostResponses,
    GetActiveBillingCyclesApiBillingBillingCyclesActiveCyclesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycles/active-cycles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Billing Cycle Eoe Preview Api
 * Get EOE claim preview data for a billing cycle, including patient demographics,
 * address, episode information, admission information, and OASIS visit details.
 */
export const getBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetResponses,
      GetBillingCycleEoePreviewApiBillingBillingCycleBillingCycleIdEoePreviewGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/eoe-preview',
      ...options,
    });
  };

/**
 * Get Billing Cycle Hipps Preview Api
 * Compute the HIPPS code for a billing cycle without saving it to the database.
 *
 * Used by the EOE claim preview popup to display the expected HIPPS code before
 * the user creates the claim.
 */
export const getBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetResponses,
      GetBillingCycleHippsPreviewApiBillingBillingCycleBillingCycleIdHippsPreviewGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/hipps-preview',
      ...options,
    });
  };

/**
 * Get Billing Cycle Visits And Supplies Api
 * Get all visits and supplies for a billing cycle.
 */
export const getBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetResponses,
      GetBillingCycleVisitsAndSuppliesApiBillingBillingCycleBillingCycleIdVisitsAndSuppliesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/visits-and-supplies',
      ...options,
    });
  };

/**
 * Update Billing Worksheet Api
 * Update editable fields on the claims worksheet for a billing cycle.
 *
 * Applies all changes in a single transaction. Currently supports updating
 * the billable status of visits.
 */
export const updateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostResponses,
    UpdateBillingWorksheetApiBillingBillingCycleUpdateWorksheetPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/update-worksheet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Stedi 837 Claim Json Api
 * Create a Stedi 837I claim JSON for a billing cycle.
 */
export const createStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostResponses,
      CreateStedi837ClaimJsonApiBillingBillingCycleBillingCycleIdCreateStedi837ClaimJsonPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/create-stedi-837-claim-json',
      ...options,
    });
  };

/**
 * Download Billing Cycle 837 Edi
 * Generate X12 837I EDI for a billing cycle without persisting a claim or calling Stedi.
 *
 * Builds the 837I claim JSON from the billing cycle, transforms it to EDI locally, and
 * returns the raw X12 message as plain text.
 */
export const downloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetResponses,
      DownloadBillingCycle837EdiBillingBillingCycleBillingCycleIdDownload837EdiGetErrors,
      ThrowOnError
    >({
      responseType: 'text',
      url: '/billing/billing-cycle/{billing_cycle_id}/download-837-edi',
      ...options,
    });
  };

/**
 * Download Billing Cycle Ub04 Pdf
 * Generate a UB-04 (CMS-1450) PDF from the current saved worksheet.
 */
export const downloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetResponses,
      DownloadBillingCycleUb04PdfBillingBillingCycleBillingCycleIdDownloadUb04PdfGetErrors,
      ThrowOnError
    >({
      responseType: 'blob',
      url: '/billing/billing-cycle/{billing_cycle_id}/download-ub04-pdf',
      ...options,
    });
  };

/**
 * Refresh Billing Cycles
 * Enqueue a billing cycle refresh for the current agency: reruns cycle
 * creation and recreates periods whose cycles were voided. Returns the
 * workflow id; poll the status endpoint to track completion.
 */
export const refreshBillingCyclesBillingRefreshBillingCyclesPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RefreshBillingCyclesBillingRefreshBillingCyclesPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    RefreshBillingCyclesBillingRefreshBillingCyclesPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/refresh-billing-cycles',
    ...options,
  });
};

/**
 * Get Refresh Billing Cycles Status
 * Return the latest run status for an agency's refresh workflow.
 */
export const getRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetResponses,
      GetRefreshBillingCyclesStatusBillingRefreshBillingCyclesWorkflowIdStatusGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/refresh-billing-cycles/{workflow_id}/status',
      ...options,
    });
  };

/**
 * Get Billing Cycle Worksheet
 * Return the (agency-scoped) worksheet for a billing cycle.
 */
export const getBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetResponses,
      GetBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet',
      ...options,
    });
  };

/**
 * Replace Billing Cycle Worksheet
 * Replace the expanded saved UB-04 worksheet document without changing status.
 */
export const replaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutResponses,
      ReplaceBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetFullPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet/full',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Refresh Billing Cycle Worksheet
 * Destructively refresh worksheet data without changing cycle status.
 */
export const refreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostResponses,
      RefreshBillingCycleWorksheetBillingBillingCycleBillingCycleIdWorksheetRefreshPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/worksheet/refresh',
      ...options,
    });
  };

/**
 * List Billing Cycle Notes
 * List notes for a billing cycle, newest first.
 */
export const listBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetResponses,
    ListBillingCycleNotesBillingBillingCycleBillingCycleIdNotesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/{billing_cycle_id}/notes',
    ...options,
  });
};

/**
 * Create Billing Cycle Note
 * Create a new note on a billing cycle.
 */
export const createBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostResponses,
      CreateBillingCycleNoteBillingBillingCycleBillingCycleIdNotesPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/billing/billing-cycle/{billing_cycle_id}/notes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Billing Cycle Note
 * Soft-delete a note. Only the author may delete.
 */
export const deleteBillingCycleNoteBillingBillingCycleNotesNoteIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteResponses,
    DeleteBillingCycleNoteBillingBillingCycleNotesNoteIdDeleteErrors,
    ThrowOnError
  >({
    url: '/billing/billing-cycle/notes/{note_id}',
    ...options,
  });
};

/**
 * Get Billing Cycle Note
 * Get a single billing cycle note by ID.
 */
export const getBillingCycleNoteBillingBillingCycleNotesNoteIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetResponses,
    GetBillingCycleNoteBillingBillingCycleNotesNoteIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/notes/{note_id}',
    ...options,
  });
};

/**
 * Update Billing Cycle Note
 * Update a note's body. Only the author may edit.
 */
export const updateBillingCycleNoteBillingBillingCycleNotesNoteIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchResponses,
    UpdateBillingCycleNoteBillingBillingCycleNotesNoteIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/billing/billing-cycle/notes/{note_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Remittance
 * Upload a raw 835 EDI file: translate, dedupe, and store every ST as a row.
 */
export const uploadRemittanceRemittancesUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadRemittanceRemittancesUploadPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UploadRemittanceRemittancesUploadPostResponses,
    UploadRemittanceRemittancesUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/remittances/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * List Remittance Payors
 * The agency's payor options for the remittance list's Insurance filter.
 */
export const listRemittancePayorsRemittancesPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListRemittancePayorsRemittancesPayorsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListRemittancePayorsRemittancesPayorsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/payors',
    ...options,
  });
};

/**
 * Get Remittance Status Counts
 * Per-status totals for the remittance status tab bar.
 */
export const getRemittanceStatusCountsRemittancesStatusCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRemittanceStatusCountsRemittancesStatusCountsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetRemittanceStatusCountsRemittancesStatusCountsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/status-counts',
    ...options,
  });
};

/**
 * List Remittances
 * Paginated remittance list for the current agency (default newest first).
 */
export const listRemittancesRemittancesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListRemittancesRemittancesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListRemittancesRemittancesGetResponses,
    ListRemittancesRemittancesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/',
    ...options,
  });
};

/**
 * Create Remittance
 * Create a Saved manual remittance worksheet.
 */
export const createRemittanceRemittancesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateRemittanceRemittancesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateRemittanceRemittancesPostResponses,
    CreateRemittanceRemittancesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Search Remittance Claims
 * Search this agency's claims for the worksheet Add Claims dialog.
 */
export const searchRemittanceClaimsRemittancesClaimsSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SearchRemittanceClaimsRemittancesClaimsSearchGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchRemittanceClaimsRemittancesClaimsSearchGetResponses,
    SearchRemittanceClaimsRemittancesClaimsSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/claims/search',
    ...options,
  });
};

/**
 * Delete Remittance
 * Soft-delete a Saved remittance worksheet.
 */
export const deleteRemittanceRemittancesRemittanceIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteRemittanceRemittancesRemittanceIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteRemittanceRemittancesRemittanceIdDeleteResponses,
    DeleteRemittanceRemittancesRemittanceIdDeleteErrors,
    ThrowOnError
  >({
    url: '/remittances/{remittance_id}',
    ...options,
  });
};

/**
 * Get Remittance Detail
 * Full nested detail for one remittance advice: payments, lines, adjustments.
 */
export const getRemittanceDetailRemittancesRemittanceIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetRemittanceDetailRemittancesRemittanceIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetRemittanceDetailRemittancesRemittanceIdGetResponses,
    GetRemittanceDetailRemittancesRemittanceIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}',
    ...options,
  });
};

/**
 * Update Remittance
 * Save the editable fields of a Saved remittance worksheet.
 */
export const updateRemittanceWorksheetRemittancesRemittanceIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutResponses,
    UpdateRemittanceWorksheetRemittancesRemittanceIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Complete Remittance Worksheet
 * Complete a Saved worksheet and atomically post its claim payments.
 */
export const completeRemittanceRemittancesRemittanceIdCompletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CompleteRemittanceRemittancesRemittanceIdCompletePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CompleteRemittanceRemittancesRemittanceIdCompletePostResponses,
    CompleteRemittanceRemittancesRemittanceIdCompletePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/complete',
    ...options,
  });
};

/**
 * Reopen Remittance Worksheet
 * Reopen a completed worksheet and conservatively unapply its payments.
 */
export const reopenRemittanceRemittancesRemittanceIdReopenPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReopenRemittanceRemittancesRemittanceIdReopenPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReopenRemittanceRemittancesRemittanceIdReopenPostResponses,
    ReopenRemittanceRemittancesRemittanceIdReopenPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/reopen',
    ...options,
  });
};

/**
 * Download Remittance
 * Download the raw 835 EDI text stored for a remittance advice.
 */
export const downloadRemittanceRemittancesRemittanceIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadRemittanceRemittancesRemittanceIdDownloadGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadRemittanceRemittancesRemittanceIdDownloadGetResponses,
    DownloadRemittanceRemittancesRemittanceIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/remittances/{remittance_id}/download',
    ...options,
  });
};

/**
 * Get Patient Diagnoses Report Clinic Options
 */
export const getPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).get<
      GetPatientDiagnosesReportClinicOptionsReportsPatientDiagnosesClinicOptionsGetResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/patient-diagnoses/clinic-options',
      ...options,
    });
  };

/**
 * Get Patient Diagnoses Report
 */
export const getPatientDiagnosesReportReportsPatientDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPatientDiagnosesReportReportsPatientDiagnosesGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPatientDiagnosesReportReportsPatientDiagnosesGetResponses,
    GetPatientDiagnosesReportReportsPatientDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/patient-diagnoses',
    ...options,
  });
};

/**
 * Export Patient Diagnoses Report
 */
export const exportPatientDiagnosesReportReportsPatientDiagnosesExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetResponses,
    ExportPatientDiagnosesReportReportsPatientDiagnosesExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/patient-diagnoses/export',
    ...options,
  });
};

/**
 * Get Open Oasis Report Options
 */
export const getOpenOasisReportOptionsReportsOpenOasisOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOpenOasisReportOptionsReportsOpenOasisOptionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOpenOasisReportOptionsReportsOpenOasisOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/open-oasis/options',
    ...options,
  });
};

/**
 * Get Open Oasis Report
 */
export const getOpenOasisReportReportsOpenOasisGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOpenOasisReportReportsOpenOasisGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOpenOasisReportReportsOpenOasisGetResponses,
    GetOpenOasisReportReportsOpenOasisGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/open-oasis',
    ...options,
  });
};

/**
 * Export Open Oasis Report
 */
export const exportOpenOasisReportReportsOpenOasisExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportOpenOasisReportReportsOpenOasisExportGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ExportOpenOasisReportReportsOpenOasisExportGetResponses,
    ExportOpenOasisReportReportsOpenOasisExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/open-oasis/export',
    ...options,
  });
};

/**
 * Get Schedule Report Options
 */
export const getScheduleReportOptionsReportsScheduleOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetScheduleReportOptionsReportsScheduleOptionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetScheduleReportOptionsReportsScheduleOptionsGetResponses,
    GetScheduleReportOptionsReportsScheduleOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule/options',
    ...options,
  });
};

/**
 * Get Schedule Report
 */
export const getScheduleReportReportsScheduleGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetScheduleReportReportsScheduleGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetScheduleReportReportsScheduleGetResponses,
    GetScheduleReportReportsScheduleGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule',
    ...options,
  });
};

/**
 * Export Schedule Report
 */
export const exportScheduleReportReportsScheduleExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportScheduleReportReportsScheduleExportGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ExportScheduleReportReportsScheduleExportGetResponses,
    ExportScheduleReportReportsScheduleExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/schedule/export',
    ...options,
  });
};

/**
 * Get Schedule Deviation Report Options
 */
export const getScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).get<
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetResponses,
      GetScheduleDeviationReportOptionsReportsScheduleDeviationOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/reports/schedule-deviation/options',
      ...options,
    });
  };

/**
 * Get Schedule Deviation Report
 */
export const getScheduleDeviationReportReportsScheduleDeviationGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetScheduleDeviationReportReportsScheduleDeviationGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetScheduleDeviationReportReportsScheduleDeviationGetResponses,
    GetScheduleDeviationReportReportsScheduleDeviationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/schedule-deviation',
    ...options,
  });
};

/**
 * Export Schedule Deviation Report
 */
export const exportScheduleDeviationReportReportsScheduleDeviationExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetResponses,
    ExportScheduleDeviationReportReportsScheduleDeviationExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/schedule-deviation/export',
    ...options,
  });
};

/**
 * Get Census Report Clinic Options
 */
export const getCensusReportClinicOptionsReportsCensusClinicOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCensusReportClinicOptionsReportsCensusClinicOptionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCensusReportClinicOptionsReportsCensusClinicOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/census/clinic-options',
    ...options,
  });
};

/**
 * Get Census Report
 */
export const getCensusReportReportsCensusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCensusReportReportsCensusGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCensusReportReportsCensusGetResponses,
    GetCensusReportReportsCensusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/census',
    ...options,
  });
};

/**
 * Export Census Report
 */
export const exportCensusReportReportsCensusExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportCensusReportReportsCensusExportGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ExportCensusReportReportsCensusExportGetResponses,
    ExportCensusReportReportsCensusExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/census/export',
    ...options,
  });
};

/**
 * Print Census Report
 */
export const printCensusReportReportsCensusPrintGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PrintCensusReportReportsCensusPrintGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    PrintCensusReportReportsCensusPrintGetResponses,
    PrintCensusReportReportsCensusPrintGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/census/print',
    ...options,
  });
};

/**
 * Get Worklog Report Options
 */
export const getWorklogReportOptionsReportsWorklogOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWorklogReportOptionsReportsWorklogOptionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetWorklogReportOptionsReportsWorklogOptionsGetResponses,
    GetWorklogReportOptionsReportsWorklogOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/worklog/options',
    ...options,
  });
};

/**
 * Get Worklog Report
 */
export const getWorklogReportReportsWorklogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWorklogReportReportsWorklogGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetWorklogReportReportsWorklogGetResponses,
    GetWorklogReportReportsWorklogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/worklog',
    ...options,
  });
};

/**
 * Export Worklog Report
 */
export const exportWorklogReportReportsWorklogExportGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportWorklogReportReportsWorklogExportGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ExportWorklogReportReportsWorklogExportGetResponses,
    ExportWorklogReportReportsWorklogExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/worklog/export',
    ...options,
  });
};

/**
 * Get Wound Status Report Options
 */
export const getWoundStatusReportOptionsReportsWoundStatusOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetWoundStatusReportOptionsReportsWoundStatusOptionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetWoundStatusReportOptionsReportsWoundStatusOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/wound-status/options',
    ...options,
  });
};

/**
 * Get Wound Status Report
 */
export const getWoundStatusReportReportsWoundStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetWoundStatusReportReportsWoundStatusGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetWoundStatusReportReportsWoundStatusGetResponses,
    GetWoundStatusReportReportsWoundStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/reports/wound-status',
    ...options,
  });
};

/**
 * Export Wound Status Report
 */
export const exportWoundStatusReportReportsWoundStatusExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ExportWoundStatusReportReportsWoundStatusExportGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ExportWoundStatusReportReportsWoundStatusExportGetResponses,
    ExportWoundStatusReportReportsWoundStatusExportGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/reports/wound-status/export',
    ...options,
  });
};

/**
 * Get Bucket Status
 * Get the status of the S3 bucket.
 */
export const getBucketStatusS3BucketStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetBucketStatusS3BucketStatusGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetBucketStatusS3BucketStatusGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/s3/bucket/status',
    ...options,
  });
};

/**
 * Health Check
 * Health check endpoint for Temporal integration.
 */
export const healthCheckTemporalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthCheckTemporalHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthCheckTemporalHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal/health',
    ...options,
  });
};

/**
 * Get Intake Form Schema
 * Get the intake form schema.
 *
 * Returns the JSON schema that defines the intake form structure,
 * field definitions, and validation rules. Used by the frontend
 * to dynamically render the intake form.
 *
 * Returns:
 * The intake form schema as a dict
 */
export const getIntakeFormSchemaIntakeFormSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakeFormSchemaIntakeFormSchemaGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakeFormSchemaIntakeFormSchemaGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/form-schema',
    ...options,
  });
};

/**
 * Get Intake Extraction Prompt
 * Get the current intake extraction prompt.
 *
 * Returns the LLM prompt used for extracting referral data from
 * intake documents, including field-specific instructions derived
 * from the intake schema.
 *
 * Returns:
 * Dict with 'prompt' key containing the extraction prompt
 */
export const getIntakeExtractionPromptIntakeExtractionPromptGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakeExtractionPromptIntakeExtractionPromptGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/extraction-prompt',
    ...options,
  });
};

/**
 * Upload File And Create Intake
 * Upload a file directly through the backend and create an intake record.
 *
 * This endpoint handles the file upload through the backend to avoid CORS issues
 * with direct S3 uploads.
 *
 * Args:
 * file: The uploaded file
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * fake_extraction: Dev-only (non-prod): skip the parsing workflow and fill
 * the intake with sample extraction data instead
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadFileAndCreateIntakeIntakeUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadFileAndCreateIntakeIntakeUploadPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UploadFileAndCreateIntakeIntakeUploadPostResponses,
    UploadFileAndCreateIntakeIntakeUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Multiple Files And Create Intake
 * Upload multiple files and create a single intake record with multiple documents.
 *
 * This endpoint handles uploading multiple PDF files and creates one intake
 * with all documents attached.
 *
 * Args:
 * files: List of uploaded files
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * parsing_strategy: Strategy for parsing multiple documents:
 * - "sequential": Process each document separately and merge results (default, processes all pages)
 * - "combined": Process all documents together in a single AI call
 * fake_extraction: Dev-only (non-prod): skip the parsing workflow and fill
 * the intake with sample extraction data instead
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload-multiple',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Get Auth Queue Endpoint
 * Get intakes that need prior authorization work.
 *
 * Returns intakes that:
 * - Are not rejected
 * - Have eligibility check result (insurance_verified = True)
 * - Require prior auth (requires_prior_auth = True)
 * - Don't yet have prior auth (authorization_status is None, empty, or 'PENDING')
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects needing prior auth
 */
export const getAuthQueueEndpointIntakeAuthQueueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAuthQueueEndpointIntakeAuthQueueGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthQueueEndpointIntakeAuthQueueGetResponses,
    GetAuthQueueEndpointIntakeAuthQueueGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/auth-queue',
    ...options,
  });
};

/**
 * Export Intakes Endpoint
 * Export filtered intakes to an Excel (.xlsx) file.
 */
export const exportIntakesEndpointIntakeExportGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ExportIntakesEndpointIntakeExportGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ExportIntakesEndpointIntakeExportGetResponses,
    ExportIntakesEndpointIntakeExportGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/export',
    ...options,
  });
};

/**
 * Delete Intake Endpoint
 * Delete an intake record by ID.
 * NOTE: THIS CAN CURRENTLY BE TRIGGERED BY ANY USER. WILL ADD SECURITY AFTER WE
 * HAVE THE CONCEPT OF USER LOGIN IN FASTAPI.
 * Currently only verifies the intake belongs to that agency if user is authenticated
 *
 * This endpoint safely deletes:
 * - The intake record
 * - Related intake history records
 * - Related intake documents (and their S3 files)
 * - Related medications
 * - Cancels any running workflows
 *
 * Preserves:
 * - Created admissions (clears the intake reference)
 * - Patient records
 * - Payor records
 * - Agency records
 *
 * Args:
 * intake_id: Intake ID to delete
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const deleteIntakeEndpointIntakeIntakeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteIntakeEndpointIntakeIntakeIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
    DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
    ThrowOnError
  >({
    url: '/intake/{intake_id}',
    ...options,
  });
};

/**
 * Get Intake Endpoint
 * Get an intake record by ID.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with intake data
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const getIntakeEndpointIntakeIntakeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetIntakeEndpointIntakeIntakeIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeEndpointIntakeIntakeIdGetResponses,
    GetIntakeEndpointIntakeIntakeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
  });
};

/**
 * Update Intake Endpoint
 * Update an intake record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * intake_update: Intake update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeEndpointIntakeIntakeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateIntakeEndpointIntakeIntakeIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateIntakeEndpointIntakeIntakeIdPutResponses,
    UpdateIntakeEndpointIntakeIntakeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Intake Test Status
 * Mark or un-mark an intake as a test/practice record.
 *
 * Gated to intake users and agency admins (``intake:access`` OR ``emr:manage``;
 * super-users pass via the RBAC short-circuit). The marker propagates to the
 * patient at push-to-EMR and short-circuits the intake-time eligibility check,
 * so it is set only here.
 */
export const setIntakeTestStatusIntakeIntakeIdTestStatusPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchResponses,
    SetIntakeTestStatusIntakeIntakeIdTestStatusPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/test-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Intake Processing Status
 * Get the current processing status of an intake's workflow.
 *
 * This queries the running Temporal workflow (if active) to get real-time
 * status without polling the database. The workflow exposes current stage,
 * progress percentage, activity name, and any error messages.
 *
 * Args:
 * intake_id: UUID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Current processing status from the workflow, or fallback status
 * if workflow is not running
 *
 * Raises:
 * HTTPException: If intake not found or not authorized
 */
export const getIntakeProcessingStatusIntakeIntakeIdProcessingStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/processing-status',
    ...options,
  });
};

/**
 * Get Intakes Endpoint
 * Get intake records with optional filtering and pagination.
 * If user has an agency, results are filtered to that agency.
 *
 * Args:
 * intake_status: Filter by intake status
 * patient_id: Filter by patient ID
 * search: Search term across patient, referral, insurance, clinic, assignee, and extracted field data
 * start_date: Start date filter (defaults to 6 weeks ago)
 * end_date: End date filter (defaults to today)
 * clinic_id: Filter by clinic ID (agency_clinic_id)
 * page: Page number (1-indexed)
 * per_page: Number of items per page (default 25, max 100)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeListResponse with paginated intake data
 */
export const getIntakesEndpointIntakeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakesEndpointIntakeGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakesEndpointIntakeGetResponses,
    GetIntakesEndpointIntakeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/',
    ...options,
  });
};

/**
 * Initialize Emr Selection Endpoint
 * Initialize EMR selection when entering the Push to EMR step.
 *
 * This endpoint is called when a user navigates to the "Push to EMR" step.
 * If only one EMR option (Roger or Kinnser) is enabled via agency settings,
 * and no EMR selection has been made yet, it automatically sets the
 * appropriate push flag.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with potentially updated EMR selection flags
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const initializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/intake/{intake_id}/initialize-emr-selection',
      ...options,
    });
  };

/**
 * Schedule In Kinnser
 * Schedule an intake on an existing Kinnser patient+episode (task → upload → details).
 */
export const scheduleInKinnserIntakeIntakeIdScheduleInKinnserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostResponses,
    ScheduleInKinnserIntakeIntakeIdScheduleInKinnserPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/schedule_in_kinnser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Auto Add In Kinnser
 * Auto-add admission/episode (or episode) then upload docs and update task details.
 */
export const autoAddInKinnserIntakeIntakeIdAutoAddInKinnserPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostResponses,
    AutoAddInKinnserIntakeIntakeIdAutoAddInKinnserPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/auto_add_in_kinnser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Intake Fields Endpoint
 * Update specific fields in the intake's JSONB 'fields' column.
 * Merges updates with existing fields rather than replacing.
 *
 * Args:
 * intake_id: Intake ID
 * field_updates: Dictionary of field names and values to update
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const updateIntakeFieldsEndpointIntakeIntakeIdFieldsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/fields',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Intake Status Endpoint
 * Update intake status and create history record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeStatusEndpointIntakeIntakeIdStatusPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reject Intake Endpoint
 * Reject an intake with all required information in one atomic operation.
 *
 * This endpoint:
 * 1. Sets rejection_reason and rejection_details in the database
 * 2. Sets reviewed_date to current timestamp
 * 3. Sets reviewed_by to the current user
 * 4. Updates status to REJECTED
 *
 * Args:
 * intake_id: Intake ID
 * rejection_request: Rejection details
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message with rejection details
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const rejectIntakeEndpointIntakeIntakeIdRejectPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RejectIntakeEndpointIntakeIntakeIdRejectPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
    RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Confirm Tab Status Endpoint
 * Confirm completion status for a specific intake workflow tab.
 *
 * This endpoint updates the tab_statuses JSONB field for a specific tab
 * and recomputes the global intake status based on the new tab statuses.
 *
 * Note: Tabs can be completed in any order. There is no enforced prerequisite
 * ordering - users may skip ahead or complete tabs out of sequence as needed
 * for their workflow.
 *
 * Special case: When push_to_emr tab is confirmed as 'complete', ALL tabs
 * are marked as complete (since the patient is now locked/created).
 *
 * Args:
 * intake_id: Intake ID
 * tab_key: Tab key (extraction, eligibility, prior_auth, ready_to_call, scheduling, push_to_emr)
 * tab_status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const confirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/tab/{tab_key}/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Referral Doc Presigned Url
 * Get a presigned S3 URL for the intake's referral document (PDF).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'url': <presigned_url> }
 * Raises:
 * HTTPException: If intake or PDF is missing
 */
export const getReferralDocPresignedUrlIntakeIntakeIdReferralDocGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-doc',
    ...options,
  });
};

/**
 * Get Referral Docs Presigned Urls
 * Get presigned S3 URLs for all of the intake's referral documents (PDFs).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'documents': [{ 'id': <doc_id>, 'file_name': <name>, 'url': <presigned_url> }, ...] }
 * Raises:
 * HTTPException: If intake is not found
 */
export const getReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-docs',
    ...options,
  });
};

/**
 * Get Intake Documents Name Dict
 * Return a mapping of document upload names to display names for all documents
 * attached to the given intake. Upload name is the file path with the
 * referral_docs/ prefix stripped; display name is the document's file_name.
 */
export const getIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/documents/name_dict',
    ...options,
  });
};

/**
 * Delete Intake Document
 * Soft-delete an intake document.
 *
 * Blocked if the document was used in extraction, or if the intake is
 * currently being analyzed. The S3 file is preserved so the row can be
 * recovered via undelete().
 */
export const deleteIntakeDocumentIntakeDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteResponses,
    DeleteIntakeDocumentIntakeDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({
    url: '/intake/documents/{document_id}',
    ...options,
  });
};

/**
 * Update Intake Document
 * Update an intake document's metadata (e.g., display filename).
 *
 * Args:
 * document_id: Document ID
 * request: Update request containing new file_name
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * IntakeDocumentResponse: Updated document data
 * Raises:
 * HTTPException: If document is not found or access denied
 */
export const updateIntakeDocumentIntakeDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Document To Intake
 * Upload a new document to an existing intake.
 *
 * Documents uploaded via this endpoint are marked with used_in_extraction=False
 * since they were added after the initial extraction.
 *
 * Args:
 * intake_id: The intake ID to add the document to
 * file: The uploaded PDF file
 * display_name: Optional display name (defaults to original filename)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeDocumentResponse: The created document record
 */
export const uploadDocumentToIntakeIntakeIntakeIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/{intake_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Stamp Intake Document
 * Append a stamp page to an intake document PDF.
 *
 * The stamp page contains "Received by {initials} on {date}" centered on a
 * blank page, where initials come from the current user and date is today in
 * Pacific Time. The S3 object is overwritten in-place so the stamped PDF is
 * used for all downstream operations (push to EMR, etc.).
 */
export const stampIntakeDocumentIntakeDocumentsDocumentIdStampPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostResponses,
    StampIntakeDocumentIntakeDocumentsDocumentIdStampPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/documents/{document_id}/stamp',
    ...options,
  });
};

/**
 * Trigger Ai Analysis Endpoint
 * Trigger AI analysis for an intake document.
 *
 * This endpoint starts a Temporal workflow to analyze the PDF document
 * associated with the intake and extract clinical insights.
 *
 * Args:
 * intake_id: ID of the intake to analyze
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * AIAnalysisResponse with workflow ID and status
 *
 * Raises:
 * HTTPException: If intake not found or analysis fails
 */
export const triggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostResponses,
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/trigger-ai-analysis',
    ...options,
  });
};

/**
 * Reprocess Intake Endpoint
 * Re-trigger the referral parsing workflow for an existing intake.
 *
 * This endpoint allows reprocessing of an intake's documents without
 * re-uploading the files. It collects all existing document S3 keys
 * and starts a new IntakeReferralParsingWorkflow.
 *
 * Args:
 * intake_id: ID of the intake to reprocess
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeReprocessResponse with workflow ID and status
 *
 * Raises:
 * HTTPException: If intake not found or reprocessing fails
 */
export const reprocessIntakeEndpointIntakeIntakeIdReprocessPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reprocess',
    ...options,
  });
};

/**
 * Get Ai Analysis Endpoint
 * Get AI analysis results for an intake.
 *
 * This endpoint fetches the results of a previously triggered AI analysis workflow.
 *
 * Args:
 * intake_id: ID of the intake
 * workflow_id: ID of the Temporal workflow
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * AIAnalysisResponse with analysis results
 *
 * Raises:
 * HTTPException: If intake not found or workflow not found
 */
export const getAiAnalysisEndpointIntakeIntakeIdAiAnalysisGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetResponses,
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/ai-analysis',
    ...options,
  });
};

/**
 * Get Episode Details Endpoint
 * Get episode and admission details for a scheduled intake.
 *
 * Args:
 * intake_id: ID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Dictionary with episode and admission details
 *
 * Raises:
 * HTTPException: If intake not found or not scheduled
 */
export const getEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/episode-details',
    ...options,
  });
};

/**
 * Onboard Patient Roger
 * Onboard a patient to Roger EMR using an intake ID.
 * This is the final step of the intake process.
 */
export const onboardPatientRogerIntakeIntakeIdOnboardPatientRogerPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/onboard_patient_roger',
    ...options,
  });
};

/**
 * Schedule Roger Existing Patient
 * Schedule an admission/episode/visit on an EXISTING Roger patient for a matched intake.
 *
 * Unlike `onboard_patient_roger`, this never creates a new Patient. The exact records
 * created depend on `kinnser_visit_type` / `kinnser_creation_type` stored in intake.fields
 * (the `kinnser_` prefix is historical — these keys are shared by both Kinnser and Roger
 * scheduling flows):
 *
 * - SOC + new_admission:  Admission + Episode + Visit
 * - SOC + new_episode:    Episode + Visit on the patient's most recent Admission
 * - ROC:                  Visit (ROC*) on the patient's most recent Episode
 *
 * Intake documents are copied onto the patient on each call (same as onboarding).
 */
export const scheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostResponses,
      ScheduleRogerExistingPatientIntakeIntakeIdScheduleRogerExistingPatientPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/intake/{intake_id}/schedule_roger_existing_patient',
      ...options,
    });
  };

/**
 * Get Visit Type Options
 * Return all visit types with metadata for the create-task UI.
 *
 * Legacy OASIS-E2 types are included with ``is_legacy=True``; the frontend
 * filters them out of creation pickers. Order types live behind
 * ``/orders/type-options``. The frontend merges both lists for the create-task UI.
 */
export const getVisitTypeOptionsVisitsTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetVisitTypeOptionsVisitsTypeOptionsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetVisitTypeOptionsVisitsTypeOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/type-options',
    ...options,
  });
};

/**
 * Get Missed Visit Options
 * Reason + notification-method options (value + display label, in display
 * order) for the missed-visit form.
 *
 * The labels come from ``MISSED_VISIT_REASON_LABELS`` /
 * ``NOTIFICATION_METHOD_LABELS`` in ``app.models.enum.visit`` — the single
 * source of truth shared with the missed-visit print view — so the on-screen
 * form and the printed PDF render identical copy.
 */
export const getMissedVisitOptionsVisitsMissedVisitOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMissedVisitOptionsVisitsMissedVisitOptionsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMissedVisitOptionsVisitsMissedVisitOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/missed-visit-options',
    ...options,
  });
};

/**
 * Get My Tasks
 * Legacy Hotbox work queue route retained for generated client compatibility.
 */
export const getMyTasksVisitsMyTasksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetMyTasksVisitsMyTasksGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMyTasksVisitsMyTasksGetResponses,
    GetMyTasksVisitsMyTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/my-tasks',
    ...options,
  });
};

/**
 * Validate Oasis
 * Validate OASIS answers using the same derived field enrichment as export.
 */
export const validateOasisVisitsVisitIdValidateOasisPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ValidateOasisVisitsVisitIdValidateOasisPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ValidateOasisVisitsVisitIdValidateOasisPostResponses,
    ValidateOasisVisitsVisitIdValidateOasisPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/validateOasis',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Export Oasis Batch
 * Export multiple OASIS assessments as a ZIP archive.
 */
export const exportOasisBatchVisitsExportOasisBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportOasisBatchVisitsExportOasisBatchPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ExportOasisBatchVisitsExportOasisBatchPostResponses,
    ExportOasisBatchVisitsExportOasisBatchPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/exportOasis/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Oasis Manager Visits
 * List OASIS visits for the OASIS Manager page.
 */
export const listOasisManagerVisitsVisitsOasisManagerGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListOasisManagerVisitsVisitsOasisManagerGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ListOasisManagerVisitsVisitsOasisManagerGetResponses,
    ListOasisManagerVisitsVisitsOasisManagerGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/oasis-manager',
    ...options,
  });
};

/**
 * Mark Visits Exported
 * Mark completed OASIS visits as exported (uploaded to iQIES).
 */
export const markVisitsExportedVisitsMarkExportedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkVisitsExportedVisitsMarkExportedPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MarkVisitsExportedVisitsMarkExportedPostResponses,
    MarkVisitsExportedVisitsMarkExportedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/mark-exported',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Unmark Visits Exported
 * Revert exported OASIS visits back to completed status.
 */
export const unmarkVisitsExportedVisitsUnmarkExportedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnmarkVisitsExportedVisitsUnmarkExportedPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UnmarkVisitsExportedVisitsUnmarkExportedPostResponses,
    UnmarkVisitsExportedVisitsUnmarkExportedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/unmark-exported',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Export Oasis
 * Export a single OASIS assessment as a CMS-compliant XML file.
 */
export const exportOasisVisitsVisitIdExportOasisPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExportOasisVisitsVisitIdExportOasisPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ExportOasisVisitsVisitIdExportOasisPostResponses,
    ExportOasisVisitsVisitIdExportOasisPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/{visit_id}/exportOasis',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visits By Clinician
 * Get visits assigned to a specific clinician for the current agency.
 *
 * Args:
 * clinician_id: Clinician account UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 * limit: Maximum number of visits to return
 * offset: Number of visits to skip for pagination
 *
 * Returns:
 * List of visits assigned to the clinician
 *
 * Raises:
 * HTTPException: If clinician not found or not accessible by current agency
 */
export const getVisitsByClinicianVisitsByClinicianClinicianIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/by-clinician/{clinician_id}',
    ...options,
  });
};

/**
 * Delete Visit
 * Delete a visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const deleteVisitVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteVisitVisitsVisitIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteVisitVisitsVisitIdDeleteResponses,
    DeleteVisitVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({
    url: '/visits/{visit_id}',
    ...options,
  });
};

/**
 * Get Visit
 * Get a specific visit by ID.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitVisitsVisitIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetVisitVisitsVisitIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitVisitsVisitIdGetResponses,
    GetVisitVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
  });
};

/**
 * Update Visit
 * Update visit basic information.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitVisitsVisitIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitVisitsVisitIdPutResponses,
    UpdateVisitVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Work Log
 * Return the visit's work log: lifecycle events reconstructed from audit rows.
 *
 * Consecutive events of the same type by the same actor are collapsed into a
 * single entry (see ``compact_work_log``), oldest first.
 */
export const getVisitWorkLogVisitsVisitIdWorkLogGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitWorkLogVisitsVisitIdWorkLogGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitWorkLogVisitsVisitIdWorkLogGetResponses,
    GetVisitWorkLogVisitsVisitIdWorkLogGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/work-log',
    ...options,
  });
};

/**
 * Create Visit
 * Create a new visit.
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitVisitsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateVisitVisitsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitVisitsPostResponses,
    CreateVisitVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Data
 * Get only the visit_data for a specific visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitDataVisitsVisitIdDataGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitDataVisitsVisitIdDataGetResponses,
    GetVisitDataVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
  });
};

/**
 * Update Visit Data
 * Update visit data with optimistic concurrency control.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitDataVisitsVisitIdDataPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitDataVisitsVisitIdDataPutResponses,
    UpdateVisitDataVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Active Diagnoses Data
 * Update active diagnoses comorbidity data (M1028) for a visit.
 */
export const updateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutResponses,
    UpdateActiveDiagnosesDataVisitsVisitIdActiveDiagnosesDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/active-diagnoses-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Pdf
 * Generate and return a PDF report for a visit.
 *
 * For a missed visit, renders the documented missed-visit details instead
 * of the (empty) assessment chart. Otherwise fetches the question schema
 * from RogerDoc and renders the visit data as a PDF with sections and
 * questions.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If visit not found, schema unavailable, or PDF generation fails
 */
export const getVisitPdfVisitsVisitIdPdfGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitPdfVisitsVisitIdPdfGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitPdfVisitsVisitIdPdfGetResponses,
    GetVisitPdfVisitsVisitIdPdfGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/{visit_id}/pdf',
    ...options,
  });
};

/**
 * Get Visit Pdf Revision
 * Render the chart's print view as it stood at a past point in time.
 *
 * Reconstructs the visit's form answers, task metadata, diagnoses,
 * comorbidities, and wounds/assessments as of ``as_of`` from the ``zz_``
 * audit-history tables, then renders the standard chart print view. Goals are
 * not yet reconstructed and are omitted so present-day goals are never shown on
 * a historical revision. A chart with no ``zz_`` history at or before ``as_of``
 * (it predates audit coverage) is reported as unavailable with a 422 rather
 * than rendered from present-day values (see ``visit_chart_revision``).
 */
export const getVisitPdfRevisionVisitsVisitIdPdfRevisionGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetResponses,
    GetVisitPdfRevisionVisitsVisitIdPdfRevisionGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/visits/{visit_id}/pdf-revision',
    ...options,
  });
};

/**
 * Unmark Visit As Missed
 * Unmark a missed visit: deletes missed_visit_data row, restores original billable_status.
 *
 * Deleting the missed_visit_data row clears Visit.is_missed, which is what
 * brings the visit back into billing-cycle logic; required_for_billing is not
 * touched here.
 */
export const unmarkVisitAsMissedVisitsVisitIdMarkMissedDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteResponses,
    UnmarkVisitAsMissedVisitsVisitIdMarkMissedDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/mark-missed',
    ...options,
  });
};

/**
 * Mark Visit As Missed
 * Mark a visit as missed: creates missed_visit_data row, sets billable_status=NON_BILLABLE.
 *
 * The missed_visit_data row (via Visit.is_missed) is what excludes the visit
 * from billing-cycle logic; required_for_billing is left untouched so it keeps
 * its "skip readiness checks" meaning.
 */
export const markVisitAsMissedVisitsVisitIdMarkMissedPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostResponses,
    MarkVisitAsMissedVisitsVisitIdMarkMissedPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/mark-missed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Missed Visit Data
 * Update fields on an existing missed_visit_data row.
 */
export const updateMissedVisitDataVisitsVisitIdMissedDataPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchResponses,
    UpdateMissedVisitDataVisitsVisitIdMissedDataPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/missed-data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Set Visit Authorization
 * Link, switch, or unlink a visit's authorization (ROG-2787).
 */
export const setVisitAuthorizationVisitsVisitIdAuthorizationPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchResponses,
    SetVisitAuthorizationVisitsVisitIdAuthorizationPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/authorization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Evv Readings
 * Return a visit's EVV readings next to the ground truth (EMR-325).
 *
 * Read-only. Pairs what the clinician's device recorded (clock in/out time,
 * GPS, patient signature) with what we independently know — the times written
 * on the visit form and the patient's home address — so QA can spot a
 * misreported visit. Deltas are computed here so the comparison is defined in
 * one place.
 *
 * Most visits have no EVV data; `has_evv_data` is false for those and the rest
 * of the payload is empty.
 */
export const getVisitEvvReadingsVisitsVisitIdEvvGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitEvvReadingsVisitsVisitIdEvvGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitEvvReadingsVisitsVisitIdEvvGetResponses,
    GetVisitEvvReadingsVisitsVisitIdEvvGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/evv',
    ...options,
  });
};

/**
 * List Visit Diagnoses
 */
export const listVisitDiagnosesVisitsVisitIdDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetResponses,
    ListVisitDiagnosesVisitsVisitIdDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses',
    ...options,
  });
};

/**
 * Create Visit Diagnosis
 */
export const createVisitDiagnosisVisitsVisitIdDiagnosesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostResponses,
    CreateVisitDiagnosisVisitsVisitIdDiagnosesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Visit Diagnosis
 */
export const deleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteResponses,
    DeleteVisitDiagnosisVisitsDiagnosesDiagnosisIdDeleteErrors,
    ThrowOnError
  >({
    url: '/visits/diagnoses/{diagnosis_id}',
    ...options,
  });
};

/**
 * Update Visit Diagnosis
 */
export const updateVisitDiagnosisVisitsDiagnosesDiagnosisIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutResponses,
    UpdateVisitDiagnosisVisitsDiagnosesDiagnosisIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/diagnoses/{diagnosis_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Diagnosis Positions
 */
export const updateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutResponses,
    UpdateDiagnosisPositionsVisitsVisitIdDiagnosesPositionsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/diagnoses/positions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Search Diagnosis Codes Route
 */
export const searchDiagnosisCodesRouteDiagnosisCodesSearchGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetResponses,
    SearchDiagnosisCodesRouteDiagnosisCodesSearchGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/diagnosis-codes/search',
    ...options,
  });
};

/**
 * Get Roger Doc Form Type Catalog
 * Roger Doc form types for schema tooling (`visit.iter_roger_doc_form_type_catalog`).
 */
export const getRogerDocFormTypeCatalogRogerdocFormTypeCatalogGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetRogerDocFormTypeCatalogRogerdocFormTypeCatalogGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/form-type-catalog',
    ...options,
  });
};

/**
 * Get Question Schema
 * Get the question schema from Roger Calls API.
 *
 * This schema is used to generate dynamic forms for visit data collection.
 *
 * Args:
 * visit_type: VisitTypeId to get schema for (must map to a RogerDocFormType)
 * ctx: Current context for authentication
 *
 * Returns:
 * Question schema dictionary from Roger Calls API
 *
 * Raises:
 * HTTPException: If visit type has no Roger Doc schema, API is unavailable,
 * or authentication fails
 */
export const getQuestionSchemaRogerdocQuestionSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetQuestionSchemaRogerdocQuestionSchemaGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
    GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/question-schema',
    ...options,
  });
};

/**
 * Get Versioned Question Schema
 * Build a ready-to-render versioned schema for a visit type.
 *
 * Proxies `POST /form-schemas/by-form-type/{form_type}` on RogerDoc. An optional
 * body can specify `schema_version` (`name` / `version`) for exact lookup or
 * `as_of` for historical resolution; omitting the body returns the newest
 * currently-effective version.
 */
export const getVersionedQuestionSchemaRogerdocV2QuestionSchemaPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostResponses,
    GetVersionedQuestionSchemaRogerdocV2QuestionSchemaPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/v2/question-schema',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Schema
 * Return the form schema for a specific visit.
 *
 * Resolves the pin in the same order as visit creation:
 * 1. EXPLICIT_FORM_SCHEMA_PINS constant (source of truth during the ROG-1750 stopgap)
 * 2. Stored pin on the visit record (form_schema_version_name / form_schema_version)
 *
 * Returns 422 if neither source has a pin. There is no fallback to newest version.
 */
export const getVisitSchemaRogerdocV2VisitsVisitIdSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetResponses,
    GetVisitSchemaRogerdocV2VisitsVisitIdSchemaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/v2/visits/{visit_id}/schema',
    ...options,
  });
};

/**
 * Get Current Form Schema Versions
 * List currently-effective schema versions for a visit type.
 *
 * Proxies `GET /form-schemas/by-form-type/{form_type}/current` on RogerDoc.
 * Returns every version whose effective range covers `as_of` (defaults to now),
 * suitable for populating a picker. Use an entry's `name` + `version` with
 * `POST /v2/question-schema` to fetch its full form tree.
 *
 * Optional ``emr_type`` is forwarded to RogerDoc so filtering happens at the
 * Docs catalog boundary (Forms Manager passes ``rogeremr``). Omit for the
 * unfiltered list.
 */
export const getCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetResponses,
    GetCurrentFormSchemaVersionsRogerdocFormSchemasCurrentGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/form-schemas/current',
    ...options,
  });
};

/**
 * Check Rogerdoc Health
 * Check if Roger-Doc service is available and authentication works.
 *
 * Returns:
 * Health status information
 */
export const checkRogerdocHealthRogerdocHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CheckRogerdocHealthRogerdocHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CheckRogerdocHealthRogerdocHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/health',
    ...options,
  });
};

/**
 * Get Coding Upload Urls
 * Generate presigned URLs for uploading files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service which handles
 * bucket selection and presigned URL generation.
 *
 * Args:
 * request: List of files to generate upload URLs for
 * ctx: Current context for authentication
 *
 * Returns:
 * Presigned upload URLs for each file
 *
 * Raises:
 * HTTPException: If URL generation fails
 */
export const getCodingUploadUrlsRogerdocCodingUploadUrlsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/coding/upload-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Coding Files
 * Upload files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service. The backend handles
 * getting presigned URLs and uploading files to S3, avoiding CORS issues.
 *
 * All files are placed in a folder with a unique UUID:
 * roger_emr/{agency_id}/{folder_id}/{filename}
 *
 * Args:
 * files: List of files to upload
 * ctx: Current context for authentication
 *
 * Returns:
 * Upload results with S3 keys for each file
 *
 * Raises:
 * HTTPException: If upload fails
 */
export const uploadCodingFilesRogerdocCodingUploadFilesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadCodingFilesRogerdocCodingUploadFilesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
    UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/rogerdoc/coding/upload-files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Rogerdoc Vsp Update
 * Custom handler for VSP updates with audit logging.
 *
 * 1. Fetches current VSP state from RogerDoc
 * 2. Proxies the update request to RogerDoc
 * 3. On success, computes diff and creates audit log entry
 */
export const rogerdocVspUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<RogerdocVspUpdateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    RogerdocVspUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/vsp/update',
    ...options,
  });
};

/**
 * Rogerdoc Get Feature Flags
 * Get feature flags from RogerDoc using internal API key authentication.
 */
export const rogerdocGetFeatureFlags = <ThrowOnError extends boolean = false>(
  options?: Options<RogerdocGetFeatureFlagsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    RogerdocGetFeatureFlagsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/feature_flags',
    ...options,
  });
};

/**
 * List Rogerdoc Account Links
 * List RogerDoc clinician accounts (and their RogerEMR links) for the agency.
 *
 * The frontend fetches this separately after the member list loads and matches
 * each account's `roger_emr.user_email` to the agency member's email.
 */
export const listRogerdocAccountLinksRogerdocAccountLinksGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListRogerdocAccountLinksRogerdocAccountLinksGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ListRogerdocAccountLinksRogerdocAccountLinksGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links',
    ...options,
  });
};

/**
 * Create Rogerdoc Account Link
 * Create a new RogerDoc clinician account linked to a RogerEMR user.
 */
export const createRogerdocAccountLinkRogerdocAccountLinksPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateRogerdocAccountLinkRogerdocAccountLinksPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateRogerdocAccountLinkRogerdocAccountLinksPostResponses,
    CreateRogerdocAccountLinkRogerdocAccountLinksPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Clear Rogerdoc Account Link
 * Clear the RogerEMR association on a RogerDoc clinician account.
 */
export const clearRogerdocAccountLinkRogerdocAccountLinksAccountIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteResponses,
    ClearRogerdocAccountLinkRogerdocAccountLinksAccountIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links/{account_id}',
    ...options,
  });
};

/**
 * Assign Rogerdoc Account Link
 * Link an existing RogerDoc clinician account to a RogerEMR user.
 */
export const assignRogerdocAccountLinkRogerdocAccountLinksAccountIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutResponses,
    AssignRogerdocAccountLinkRogerdocAccountLinksAccountIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/account-links/{account_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Goals Progress Validation Config
 * Get goals progress validation config for the current agency.
 *
 * Requires goals:admin-tab permission.
 */
export const getGoalsProgressValidationConfig = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetGoalsProgressValidationConfigData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetGoalsProgressValidationConfigResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/goals/progress-validation-config',
    ...options,
  });
};

/**
 * Set Goals Progress Validation Config
 * Update goals progress validation config for the current agency.
 *
 * Requires goals:admin-tab permission.
 */
export const setGoalsProgressValidationConfig = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SetGoalsProgressValidationConfigData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SetGoalsProgressValidationConfigResponses,
    SetGoalsProgressValidationConfigErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/goals/progress-validation-config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Rogerdoc Worksheet Goals Passthrough Post
 * Passthrough POST for worksheet goals admin (requires goals:admin-tab).
 */
export const rogerdocWorksheetGoalsPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RogerdocWorksheetGoalsPassthroughPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    RogerdocWorksheetGoalsPassthroughPostResponses,
    RogerdocWorksheetGoalsPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/worksheet-goals/{subpath}',
    ...options,
  });
};

/**
 * Rogerdoc Fetch Goals Templates Passthrough Post
 * Passthrough POST for Wellsky goals resync (requires goals:admin-tab).
 *
 * Also syncs AgencyClinic and AgencyInsurance records from RogerDoc for the
 * current agency. Does not return until both operations complete.
 */
export const rogerdocFetchGoalsTemplatesPassthroughPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    RogerdocFetchGoalsTemplatesPassthroughPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    RogerdocFetchGoalsTemplatesPassthroughPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/fetch-goals-templates-by-dict-temporal',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Delete
 * Passthrough DELETE request to RogerDoc API.
 */
export const rogerdocPassthroughDelete = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    RogerdocPassthroughDeleteResponses,
    RogerdocPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Get
 * Passthrough GET request to RogerDoc API.
 */
export const rogerdocPassthroughGet = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    RogerdocPassthroughGetResponses,
    RogerdocPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Patch
 * Passthrough PATCH request to RogerDoc API.
 */
export const rogerdocPassthroughPatch = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    RogerdocPassthroughPatchResponses,
    RogerdocPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Post
 * Passthrough POST request to RogerDoc API.
 */
export const rogerdocPassthroughPost = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    RogerdocPassthroughPostResponses,
    RogerdocPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Put
 * Passthrough PUT request to RogerDoc API.
 */
export const rogerdocPassthroughPut = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    RogerdocPassthroughPutResponses,
    RogerdocPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * List Bespoke Templates
 * List all bespoke templates (environment-wide catalog).
 *
 * Optionally filter by schema_version_name, form_type, form_schema_version,
 * layout_field_qid_signature, and/or status.
 */
export const listBespokeTemplatesBespokeTemplatesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListBespokeTemplatesBespokeTemplatesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListBespokeTemplatesBespokeTemplatesGetResponses,
    ListBespokeTemplatesBespokeTemplatesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/',
    ...options,
  });
};

/**
 * Create Bespoke Template
 * Create a new bespoke template entry.
 */
export const createBespokeTemplateBespokeTemplatesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateBespokeTemplateBespokeTemplatesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateBespokeTemplateBespokeTemplatesPostResponses,
    CreateBespokeTemplateBespokeTemplatesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Bespoke Templates Export All
 * Legacy super-user export entrypoint; returns the same catalog as ``GET /``.
 *
 * Kept for tooling that still calls this URL; prefer ``GET /`` for new code.
 */
export const listBespokeTemplatesExportAllBespokeTemplatesExportAllGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ListBespokeTemplatesExportAllBespokeTemplatesExportAllGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/export-all',
    ...options,
  });
};

/**
 * List Enabled Sections
 * Return enabled bespoke entries (section + layout_json) for a full pin.
 */
export const listEnabledSectionsBespokeTemplatesEnabledGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEnabledSectionsBespokeTemplatesEnabledGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListEnabledSectionsBespokeTemplatesEnabledGetResponses,
    ListEnabledSectionsBespokeTemplatesEnabledGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/enabled',
    ...options,
  });
};

/**
 * List Bespoke Template Revisions
 * Lightweight template metadata for a full pin, for live-refresh polling.
 *
 * Excludes ``layout_json`` to keep the poll payload cheap; includes rows of
 * any status so a change to a standby (MCP-pushed) draft is also detected.
 */
export const listBespokeTemplateRevisionsBespokeTemplatesRevisionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetResponses,
    ListBespokeTemplateRevisionsBespokeTemplatesRevisionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/revisions',
    ...options,
  });
};

/**
 * Import Bespoke Templates Bundle
 * Upsert bespoke templates from a JSON export bundle.
 */
export const importBespokeTemplatesBundleBespokeTemplatesImportBundlePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostResponses,
    ImportBespokeTemplatesBundleBespokeTemplatesImportBundlePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/import-bundle',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Bespoke Templates Bulk Render Status
 * Bulk set Live templates to Paused, or Paused templates to Live (scope optional).
 */
export const bespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostResponses,
      BespokeTemplatesBulkRenderStatusBespokeTemplatesBulkRenderStatusPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/bespoke-templates/bulk-render-status',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Bespoke Template
 * Delete a bespoke template entry.
 */
export const deleteBespokeTemplateBespokeTemplatesTemplateIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteResponses,
    DeleteBespokeTemplateBespokeTemplatesTemplateIdDeleteErrors,
    ThrowOnError
  >({
    url: '/bespoke-templates/{template_id}',
    ...options,
  });
};

/**
 * Update Bespoke Template
 * Update a bespoke template entry.
 */
export const updateBespokeTemplateBespokeTemplatesTemplateIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchResponses,
    UpdateBespokeTemplateBespokeTemplatesTemplateIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/bespoke-templates/{template_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Context Sections
 * Canonical MCP schema pin + section names for a RogerDoc form type.
 */
export const contextSectionsFormsManagerContextSectionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionsFormsManagerContextSectionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ContextSectionsFormsManagerContextSectionsGetResponses,
    ContextSectionsFormsManagerContextSectionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/sections',
    ...options,
  });
};

/**
 * Context Section Layout
 * Current primary (live, else paused) bespoke layout_json for a section.
 */
export const contextSectionLayoutFormsManagerContextSectionLayoutGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionLayoutFormsManagerContextSectionLayoutGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ContextSectionLayoutFormsManagerContextSectionLayoutGetResponses,
    ContextSectionLayoutFormsManagerContextSectionLayoutGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/section-layout',
    ...options,
  });
};

/**
 * Context Section Layouts
 * Active (live/paused) and standby layout versions for a section.
 */
export const contextSectionLayoutsFormsManagerContextSectionLayoutsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetResponses,
    ContextSectionLayoutsFormsManagerContextSectionLayoutsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/section-layouts',
    ...options,
  });
};

/**
 * Context Section Questions
 * RogerDoc question/QID schema for one section of the MCP canonical pin.
 */
export const contextSectionQuestionsFormsManagerContextSectionQuestionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ContextSectionQuestionsFormsManagerContextSectionQuestionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ContextSectionQuestionsFormsManagerContextSectionQuestionsGetResponses,
    ContextSectionQuestionsFormsManagerContextSectionQuestionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/context/section-questions',
    ...options,
  });
};

/**
 * Push Layout
 * Write a layout to a standby template. Never modifies live or paused rows.
 */
export const pushLayoutFormsManagerPushLayoutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PushLayoutFormsManagerPushLayoutPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    PushLayoutFormsManagerPushLayoutPostResponses,
    PushLayoutFormsManagerPushLayoutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/forms-manager/push-layout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Vibecoder Models
 * Return the layout assistant model picker options for the UI dropdown.
 */
export const listVibecoderModelsVibecoderLayoutAssistantModelsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ListVibecoderModelsVibecoderLayoutAssistantModelsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    ListVibecoderModelsVibecoderLayoutAssistantModelsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/vibecoder-layout-assistant/models',
    ...options,
  });
};

/**
 * Vibecoder Layout Chat
 * Admin-only assistant with schema + DSL context; optional full layout_json replacement.
 */
export const vibecoderLayoutChatVibecoderLayoutAssistantChatPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    VibecoderLayoutChatVibecoderLayoutAssistantChatPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    VibecoderLayoutChatVibecoderLayoutAssistantChatPostResponses,
    VibecoderLayoutChatVibecoderLayoutAssistantChatPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/vibecoder-layout-assistant/chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate X12 270
 * Generate X12 270 eligibility inquiry message.
 */
export const generateX12270X12270GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12270X12270GeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12270X12270GeneratePostResponses,
    GenerateX12270X12270GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility With X12 270
 * Generate X12 270 message and submit to Waystar for eligibility check.
 */
export const checkEligibilityWithX12270X12270EligibilityCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityWithX12270X12270EligibilityCheckPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
    CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/eligibility-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate X12 271
 * Generate X12 271 eligibility response message.
 */
export const generateX12271X12271GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12271X12271GeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12271X12271GeneratePostResponses,
    GenerateX12271X12271GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Parse X12 271
 * Parse a raw X12 271 message and return the parsed response as JSON.
 */
export const parseX12271X12271ParsePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParseX12271X12271ParsePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ParseX12271X12271ParsePostResponses,
    ParseX12271X12271ParsePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/parse',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate X12 837I
 * Generate X12 837I institutional healthcare claim message.
 */
export const generateX12837iX12837iGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12837iX12837iGeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12837iX12837iGeneratePostResponses,
    GenerateX12837iX12837iGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/837i/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility X12
 * Check eligibility using X12 270 message via Waystar.
 */
export const checkEligibilityX12WaystarEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityX12WaystarEligibilityPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityX12WaystarEligibilityPostResponses,
    CheckEligibilityX12WaystarEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility Direct
 * Check eligibility directly via Waystar API.
 */
export const checkEligibilityDirectWaystarEligibilityDirectPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityDirectWaystarEligibilityDirectPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
    CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility/direct',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Prior Authorization
 * Check prior authorization via Waystar API.
 */
export const checkPriorAuthorizationWaystarPriorAuthPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckPriorAuthorizationWaystarPriorAuthPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckPriorAuthorizationWaystarPriorAuthPostResponses,
    CheckPriorAuthorizationWaystarPriorAuthPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/prior-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Submit Claim
 * Submit an X12 837i claim to Waystar via SFTP.
 */
export const submitClaimWaystarClaimsSubmit837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaimWaystarClaimsSubmit837iPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitClaimWaystarClaimsSubmit837iPostResponses,
    SubmitClaimWaystarClaimsSubmit837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/submit/837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Claim Acknowledgment
 * Check for 999 acknowledgment file for a submitted claim.
 */
export const checkClaimAcknowledgmentWaystarClaimsClaimIdAckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/{claim_id}/ack',
    ...options,
  });
};

/**
 * Check Eligibility
 * Submit a real-time eligibility check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format and returns
 * the eligibility response also in Stedi's JSON format.
 */
export const checkEligibilityStediEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityStediEligibilityPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityStediEligibilityPostResponses,
    CheckEligibilityStediEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Coordination Of Benefits
 * Submit a coordination of benefits check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format (same as eligibility)
 * and returns the COB response from Stedi.
 */
export const checkCoordinationOfBenefitsStediCoordinationOfBenefitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/coordination-of-benefits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Submit Claim 837I
 * Submit an 837I institutional claim to Stedi.
 *
 * This endpoint implements a two-phase workflow:
 * 1. Create claim record in database with DRAFT status
 * 2. Submit to Stedi and update status to SUBMITTED on success
 *
 * Args:
 * request: 837I claim submission request data including patient_id and payor_id
 * db: Database session
 *
 * Returns:
 * 837I claim submission response from Stedi with database claim ID
 */
export const submitClaim837iStediClaim837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaim837iStediClaim837iPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitClaim837iStediClaim837iPostResponses,
    SubmitClaim837iStediClaim837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/claim-837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Stedi Claim Ub04 Pdf
 * Export a stored 837I claim as a UB-04 (CMS-1450) PDF.
 *
 * Uses JSON in ``claim.claim_data`` (same payload sent to Stedi). Requires
 * that claim data exists and the claim belongs to the current agency.
 */
export const getStediClaimUb04PdfStediClaimsClaimIdUb04Get = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetResponses,
    GetStediClaimUb04PdfStediClaimsClaimIdUb04GetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/stedi/claims/{claim_id}/ub04',
    ...options,
  });
};

/**
 * Upload Claim Document For Patient
 * Upload a document for a patient that will be attached to a future claim.
 *
 * Args:
 * patient_id: Patient ID
 * file: File to upload (max 64MB)
 * report_type_code: PWK01 code (default: BM for attachments)
 * attachment_description: Description of the attachment
 * service_line_number: Optional service line number
 * provider_control_number: Optional provider control number
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * ClaimDocumentResponse with attachment control number
 */
export const uploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/stedi/patients/{patient_id}/claim-documents',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Receive Stedi Webhook
 * Receive and process Stedi webhook events.
 *
 * This endpoint receives webhook notifications from Stedi for transaction processing events.
 * Currently, it only processes 277 (claim status) transactions.
 */
export const receiveStediWebhookStediWebhooksReceivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReceiveStediWebhookStediWebhooksReceivePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReceiveStediWebhookStediWebhooksReceivePostResponses,
    ReceiveStediWebhookStediWebhooksReceivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/webhooks/receive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Patient In Kinnser
 * Create/push a patient to Kinnser from intake data.
 *
 * This endpoint validates the intake data and pushes it to Kinnser's system.
 * If validation fails, returns success=False with validation errors.
 *
 * Args:
 * request: Create request containing intake_id
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * Response with success status and Kinnser patient ID if successful,
 * or validation errors if validation failed
 */
export const createPatientInKinnserKinnserPatientsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePatientInKinnserKinnserPatientsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientInKinnserKinnserPatientsPostResponses,
    CreatePatientInKinnserKinnserPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patients',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Onboard Patient
 * Onboard a patient with task and attachment in WellSky.
 *
 * This endpoint orchestrates three sequential operations:
 * 1. Creates a patient with a new episode
 * 2. Creates a task for that patient
 * 3. Uploads an attachment to that task
 *
 * Args:
 * clinic_id: The clinic ID where the patient will be created
 * branch_id: The branch ID where the patient will be created
 * request: Onboard request containing intake_id and task/upload fields
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * Response with results from all three operations
 *
 * Raises:
 * HTTPException: If onboarding fails at any step
 */
export const onboardPatientKinnserPatientOnboardClinicIdBranchIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostResponses,
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/onboard/{clinic_id}/{branch_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Task For Episode
 * Create a task on an existing episode (e.g. ROC) in WellSky.
 *
 * Handled the same way as create_patient and onboard_patient: uses Kinnser
 * service to call Roger Doc API, returns a structured response, and raises
 * HTTPException with a clear detail message on errors.
 */
export const createTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostResponses,
      CreateTaskForEpisodeKinnserClinicClinicIdEpisodeEpisodeKeyTaskPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/clinic/{clinic_id}/episode/{episode_key}/task',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Auto Add Admission And Episode
 * Create a new admission and a new episode for an existing WellSky patient.
 *
 * Asynchronous; does not wait for WellSky to finish. No demographics sent.
 * Idempotent on (patient_key, new_admission_date, new_episode_date, clinic_id).
 */
export const autoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostResponses,
      AutoAddAdmissionAndEpisodeKinnserPatientAddAdmissionAndEpisodeAutoClinicIdPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/patient/add-admission-and-episode/auto/{clinic_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Auto Add Episode
 * Create a new episode only for an existing WellSky patient who already has an admission.
 *
 * Asynchronous; does not wait for WellSky to finish. Patient must already have an admission.
 * Idempotent on (patient_key, new_episode_date, clinic_id).
 */
export const autoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostResponses,
    AutoAddEpisodeKinnserPatientAddEpisodeAutoClinicIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/add-episode/auto/{clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Task Details
 * Update task details (e.g. comment) for an existing WellSky task.
 *
 * Runs a Temporal workflow that locates the task by episode, tab, and patient task key,
 * then applies the requested updates.
 */
export const updateTaskDetailsKinnserPatientTaskDetailsClinicIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostResponses,
    UpdateTaskDetailsKinnserPatientTaskDetailsClinicIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/task/details/{clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Task Upload For Episode
 * Upload S3 files to a WellSky task for the given episode.
 *
 * Navigates to clinic, opens episode manager for the episode, verifies patient key,
 * locates the task by patient_task_key on the given tab, and uploads files from S3.
 */
export const taskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostResponses,
      TaskUploadForEpisodeKinnserTaskUploadForEpisodeEpisodeKeyClinicIdTabNamePatientTaskKeyPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/kinnser/task/upload/for-episode/{episode_key}/{clinic_id}/{tab_name}/{patient_task_key}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Kinnser Clinic Data
 * Get Kinnser clinic data for a specific clinic.
 *
 * Returns the clinic-specific Kinnser data including
 * physicians, clinicians, managers, approvers, and insurance providers.
 *
 * Args:
 * clinic_id: The ID of the clinic to get data for
 * context: Current user context
 *
 * Returns:
 * Clinic data with available options
 */
export const getKinnserClinicDataKinnserClinicsClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetKinnserClinicDataKinnserClinicsClinicIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
    GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics/{clinic_id}',
    ...options,
  });
};

/**
 * Get Kinnser Clinics
 * Get list of available Kinnser clinics.
 *
 * Returns the list of available clinics for dropdown selection.
 *
 * Args:
 * context: Current user context
 *
 * Returns:
 * Response with list of available clinics
 */
export const getKinnserClinicsKinnserClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetKinnserClinicsKinnserClinicsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetKinnserClinicsKinnserClinicsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics',
    ...options,
  });
};

/**
 * Search Allergies
 * Search the live FDB allergen picklist (auth required).
 *
 * Results are FDB-proxied items with no local id until one is selected and
 * materialized (``POST /patients/{id}/allergy`` with ``fdb_allergen_id``).
 * Queries shorter than 3 characters return an empty result.
 */
export const searchAllergiesAllergiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchAllergiesAllergiesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchAllergiesAllergiesGetResponses,
    SearchAllergiesAllergiesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
  });
};

/**
 * Create Allergy
 * Create a new allergy.
 */
export const createAllergyAllergiesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAllergyAllergiesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAllergyAllergiesPostResponses,
    CreateAllergyAllergiesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Defined Allergies
 * Get all user-defined allergies.
 */
export const getUserDefinedAllergiesAllergiesUserDefinedGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserDefinedAllergiesAllergiesUserDefinedGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/user-defined',
    ...options,
  });
};

/**
 * Import Allergies From File
 * Import allergies from the hardcoded data file.
 * File format: allergy_name|num|letter|<br> (one per line).
 * Uses CRUD to create allergies; skips duplicates.
 */
export const importAllergiesFromFileAllergiesImportPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportAllergiesFromFileAllergiesImportPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportAllergiesFromFileAllergiesImportPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/import',
    ...options,
  });
};

/**
 * Delete Allergy
 * Delete an allergy.
 */
export const deleteAllergyAllergiesAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAllergyAllergiesAllergyIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAllergyAllergiesAllergyIdDeleteResponses,
    DeleteAllergyAllergiesAllergyIdDeleteErrors,
    ThrowOnError
  >({
    url: '/allergies/{allergy_id}',
    ...options,
  });
};

/**
 * Get Allergy
 * Get a specific allergy by ID.
 */
export const getAllergyAllergiesAllergyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAllergyAllergiesAllergyIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetAllergyAllergiesAllergyIdGetResponses,
    GetAllergyAllergiesAllergyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/{allergy_id}',
    ...options,
  });
};

/**
 * Get Patient Allergies
 * Get all allergies for a specific patient.
 */
export const getPatientAllergiesPatientsPatientIdAllergyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientAllergiesPatientsPatientIdAllergyGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
    GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
  });
};

/**
 * Create Patient Allergy
 * Add an allergy to a patient.
 *
 * Identify the allergen by an existing catalog allergy_id, or by a selected
 * FDB picklist result (fdb_allergen_id + fdb_allergen_name) which the server
 * verifies against FDB and materializes into the local catalog.
 */
export const createPatientAllergyPatientsPatientIdAllergyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientAllergyPatientsPatientIdAllergyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
    CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create User Defined Patient Allergy
 * Create and add a user-defined allergy to a patient.
 * Accepts allergy_name and reaction.
 * If allergy_name doesn't exist, it creates a new user-defined allergy.
 */
export const createUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/allergy/user-defined',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Patient Allergy
 * Delete a patient allergy entry.
 */
export const deletePatientAllergyPatientsAllergyPatientAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/allergy/{patient_allergy_id}',
    ...options,
  });
};

/**
 * List Patient Insurances
 */
export const listPatientInsurancesPatientsPatientIdInsuranceGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPatientInsurancesPatientsPatientIdInsuranceGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListPatientInsurancesPatientsPatientIdInsuranceGetResponses,
    ListPatientInsurancesPatientsPatientIdInsuranceGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/insurance',
    ...options,
  });
};

/**
 * Create Patient Insurance
 */
export const createPatientInsurancePatientsPatientIdInsurancePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientInsurancePatientsPatientIdInsurancePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientInsurancePatientsPatientIdInsurancePostResponses,
    CreatePatientInsurancePatientsPatientIdInsurancePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/insurance',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Insurance
 */
export const deletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteResponses,
      DeletePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
    });
  };

/**
 * Get Patient Insurance
 */
export const getPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetResponses,
      GetPatientInsurancePatientsPatientIdInsurancePatientInsuranceIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
    });
  };

/**
 * Update Patient Insurance
 */
export const updatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutResponses,
      UpdatePatientInsurancePatientsPatientIdInsurancePatientInsuranceIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/insurance/{patient_insurance_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Search Medications Endpoint
 * Search the live FDB medication catalog (auth required).
 *
 * Text search with optional form/route filters (``form``/``route`` carry FDB
 * ``doseFormID``/``routeID`` from the facet options). Results are reranked and
 * paginated; each item is an FDB-proxied row with no local id until it is
 * selected and materialized.
 */
export const searchMedicationsEndpointMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchMedicationsEndpointMedicationsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchMedicationsEndpointMedicationsGetResponses,
    SearchMedicationsEndpointMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/',
    ...options,
  });
};

/**
 * Get Medication Endpoint
 * Get a specific medication by ID.
 *
 * Args:
 * medication_id: Medication UUID
 *
 * Returns:
 * Medication record
 *
 * Raises:
 * HTTPException: If medication not found
 */
export const getMedicationEndpointMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationEndpointMedicationsMedicationIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetMedicationEndpointMedicationsMedicationIdGetResponses,
    GetMedicationEndpointMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/{medication_id}',
    ...options,
  });
};

/**
 * Get Patient Medications
 * Get all medications for a patient.
 *
 * Optionally filter out discontinued medications with include_discontinued=false.
 */
export const getPatientMedicationsPatientsPatientIdMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationsPatientsPatientIdMedicationsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
    GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
  });
};

/**
 * Create Patient Medication
 * Create a new medication for a patient.
 *
 * For on-market medications, provide either medication_id or
 * fdb_dispensable_drug_id (a selected FDB search result, which the
 * server materializes into a local medication row). For off-market
 * medications, set is_off_market=true and provide off_market_description.
 */
export const createPatientMedicationPatientsPatientIdMedicationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientMedicationPatientsPatientIdMedicationsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
    CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Medication Order Launch Validation
 */
export const getMedicationOrderLaunchValidation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetMedicationOrderLaunchValidationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetMedicationOrderLaunchValidationResponses,
    GetMedicationOrderLaunchValidationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/orders/launch-validation',
    ...options,
  });
};

/**
 * Create Order From Medications
 */
export const createMedicationOrder = <ThrowOnError extends boolean = false>(
  options: Options<CreateMedicationOrderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMedicationOrderResponses,
    CreateMedicationOrderErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/orders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Screen Medication Interactions
 * Preview drug-drug and drug-allergy interaction screening.
 *
 * Runs the same screen the sign flow performs, for display only — the
 * result is not persisted. Absorbs FDB latency ahead of signing.
 */
export const screenMedicationInteractions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ScreenMedicationInteractionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ScreenMedicationInteractionsResponses,
    ScreenMedicationInteractionsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/screen',
    ...options,
  });
};

/**
 * Screen Candidate Medication
 * Prospectively screen a drug being considered for assignment.
 *
 * Screens the candidate against the patient's current medications and
 * allergies, narrowed to findings involving the candidate. Advisory
 * only — nothing is persisted and assignment is never blocked; the
 * authoritative screen still runs at signing.
 */
export const screenCandidateMedication = <ThrowOnError extends boolean = false>(
  options: Options<ScreenCandidateMedicationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ScreenCandidateMedicationResponses,
    ScreenCandidateMedicationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/screen/candidate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Medication Pdf
 * Generate and return a Patient Medication Record PDF.
 *
 * Includes:
 * - Pharmacy information
 * - Medications grouped by: Future, Current, Discontinued
 * - Legend with status indicators (LS, N, C)
 * - Form sections for physician contact and medication interactions
 * - Signature section
 *
 * The PDF is dynamically generated from current medication data.
 *
 * Args:
 * patient_id: Patient UUID
 * db: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If patient not found or PDF generation fails
 */
export const getMedicationPdfPatientsPatientIdMedicationsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostResponses,
    GetMedicationPdfPatientsPatientIdMedicationsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/medications/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Medication
 * Delete a medication.
 */
export const deletePatientMedicationPatientsPatientIdMedicationsMedicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });
  };

/**
 * Get Patient Medication
 * Get a specific medication by ID.
 */
export const getPatientMedicationPatientsPatientIdMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/{medication_id}',
    ...options,
  });
};

/**
 * Update Patient Medication
 * Update a medication.
 */
export const updatePatientMedicationPatientsPatientIdMedicationsMedicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Medication Profile Attachments
 * Get all medication profile attachments for a patient.
 */
export const getMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
    });
  };

/**
 * Upload Medication Profile Attachment
 * Upload a new attachment to the patient's medication profile.
 */
export const uploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Get Medication Attachment Url
 * Get a presigned URL to download an attachment.
 */
export const getMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}/url',
      ...options,
    });
  };

/**
 * Delete Medication Profile Attachment
 * Delete a medication profile attachment.
 */
export const deleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}',
      ...options,
    });
  };

/**
 * Get Patient Pharmacy
 * Get the pharmacy for a patient, or null if none is set.
 */
export const getPatientPharmacyPatientsPatientIdPharmacyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientPharmacyPatientsPatientIdPharmacyGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientPharmacyPatientsPatientIdPharmacyGetResponses,
    GetPatientPharmacyPatientsPatientIdPharmacyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pharmacy',
    ...options,
  });
};

/**
 * Upsert Patient Pharmacy
 * Create or update the pharmacy for a patient.
 *
 * Returns null when every field is empty, which clears the pharmacy.
 */
export const upsertPatientPharmacyPatientsPatientIdPharmacyPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutResponses,
    UpsertPatientPharmacyPatientsPatientIdPharmacyPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pharmacy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Mar Medications
 * List all administration records for a visit.
 */
export const listMarMedicationsPatientsPatientIdVisitsVisitIdMarGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetResponses,
    ListMarMedicationsPatientsPatientIdVisitsVisitIdMarGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/',
    ...options,
  });
};

/**
 * Create Mar Medication
 * Record an administration of a profile medication during the visit.
 */
export const createMarMedicationPatientsPatientIdVisitsVisitIdMarPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostResponses,
    CreateMarMedicationPatientsPatientIdVisitsVisitIdMarPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Mar Medication
 * Delete a MAR entry.
 */
export const deleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteResponses,
    DeleteMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}/visits/{visit_id}/mar/{mar_id}',
    ...options,
  });
};

/**
 * Update Mar Medication
 * Update the administration details of a MAR entry.
 */
export const updateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutResponses,
    UpdateMarMedicationPatientsPatientIdVisitsVisitIdMarMarIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits/{visit_id}/mar/{mar_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Wounds
 * Get all wounds for a patient.
 *
 * Optionally filter out healed wounds with include_discontinued=false.
 */
export const getPatientWoundsPatientsPatientIdWoundsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientWoundsPatientsPatientIdWoundsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientWoundsPatientsPatientIdWoundsGetResponses,
    GetPatientWoundsPatientsPatientIdWoundsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/',
    ...options,
  });
};

/**
 * Create Patient Wound
 * Create a new wound for a patient.
 */
export const createPatientWoundPatientsPatientIdWoundsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientWoundPatientsPatientIdWoundsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientWoundPatientsPatientIdWoundsPostResponses,
    CreatePatientWoundPatientsPatientIdWoundsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Wound
 * Delete a wound. Blocked if the wound has any assessments.
 */
export const deletePatientWoundPatientsPatientIdWoundsWoundIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteResponses,
    DeletePatientWoundPatientsPatientIdWoundsWoundIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}/wounds/{wound_id}',
    ...options,
  });
};

/**
 * Update Patient Wound
 * Update a wound (including marking it as healed).
 */
export const updatePatientWoundPatientsPatientIdWoundsWoundIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutResponses,
    UpdatePatientWoundPatientsPatientIdWoundsWoundIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Wound Care Worksheet Pdf
 * Generate and return a Wound Care Worksheet PDF for a specific visit.
 *
 * Shows wounds added, discontinued, and addressed during the visit.
 */
export const getWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostResponses,
    GetWoundCareWorksheetPdfPatientsPatientIdWoundsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/patients/{patient_id}/wounds/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Wound Assessments
 * Get all assessments for a wound.
 */
export const getWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetResponses,
    GetWoundAssessmentsPatientsPatientIdWoundsWoundIdAssessmentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}/assessments',
    ...options,
  });
};

/**
 * Create Wound Assessment
 * Create a new assessment for a wound.
 */
export const createWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostResponses,
      CreateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Wound Assessment
 * Delete a wound assessment.
 */
export const deleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteResponses,
      DeleteWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments/{assessment_id}',
      ...options,
    });
  };

/**
 * Update Wound Assessment
 * Update a wound assessment.
 */
export const updateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutResponses,
      UpdateWoundAssessmentPatientsPatientIdWoundsWoundIdAssessmentsAssessmentIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/assessments/{assessment_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Wound Attachments
 * Get all attachments for a wound, optionally filtered by assessment.
 */
export const getWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetResponses,
    GetWoundAttachmentsPatientsPatientIdWoundsWoundIdAttachmentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/wounds/{wound_id}/attachments/',
    ...options,
  });
};

/**
 * Upload Wound Attachment
 * Upload an attachment for a wound, optionally scoped to an assessment.
 */
export const uploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostResponses,
      UploadWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Ingest Wound Attachments From S3
 * Ingest wound images from a source S3 bucket.
 *
 * Used by RogerDocs to push wound photos at fill-time: it passes the S3 keys
 * of the images already in its bucket, and we download → re-upload into the
 * EMR's own bucket and create a WoundAttachment row per item.
 *
 * Per-item failures are returned in the `errors` list; successful items land
 * in `attachments`. Duplicates (same wound + assessment + file_name) are
 * skipped and their existing record is returned in `attachments`.
 */
export const ingestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3Post =
  <ThrowOnError extends boolean = false>(
    options: Options<
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostResponses,
      IngestWoundAttachmentsFromS3PatientsPatientIdWoundsWoundIdAttachmentsFromS3PostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/from-s3',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Ingest Wound Attachments From Url
 * Ingest wound images from presigned HTTPS GET URLs.
 *
 * Used by RogerDocs at fill-time: it generates short-lived presigned URLs for
 * wound photos in its bucket and passes them here. RogerEMR downloads each
 * URL via HTTP (no cross-account S3 IAM), re-uploads into the EMR bucket, and
 * creates a WoundAttachment row per item.
 *
 * Per-item failures are returned in the `errors` list; successful items land
 * in `attachments`. Duplicates (same wound + assessment + file_name) are
 * skipped and their existing record is returned in `attachments`.
 */
export const ingestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostResponses,
      IngestWoundAttachmentsFromUrlPatientsPatientIdWoundsWoundIdAttachmentsFromUrlPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/from-url',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Wound Attachment Url
 * Get a presigned URL to download a wound attachment.
 */
export const getWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetResponses,
      GetWoundAttachmentUrlPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/{attachment_id}/url',
      ...options,
    });
  };

/**
 * Delete Wound Attachment
 * Delete a wound attachment.
 */
export const deleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteResponses,
      DeleteWoundAttachmentPatientsPatientIdWoundsWoundIdAttachmentsAttachmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/wounds/{wound_id}/attachments/{attachment_id}',
      ...options,
    });
  };

/**
 * List Infection Logs
 */
export const listInfectionLogsPatientsPatientIdInfectionLogsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListInfectionLogsPatientsPatientIdInfectionLogsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListInfectionLogsPatientsPatientIdInfectionLogsGetResponses,
    ListInfectionLogsPatientsPatientIdInfectionLogsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/infection-logs/',
    ...options,
  });
};

/**
 * Create Infection Log Endpoint
 */
export const createInfectionLogEndpointPatientsPatientIdInfectionLogsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostResponses,
    CreateInfectionLogEndpointPatientsPatientIdInfectionLogsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/infection-logs/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Infection Log Endpoint
 */
export const deleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteResponses,
      DeleteInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
    });
  };

/**
 * Get Infection Log Detail
 */
export const getInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetResponses,
      GetInfectionLogDetailPatientsPatientIdInfectionLogsInfectionLogIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
    });
  };

/**
 * Update Infection Log Endpoint
 */
export const updateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutResponses,
      UpdateInfectionLogEndpointPatientsPatientIdInfectionLogsInfectionLogIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Save Follow Up
 */
export const saveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostResponses,
      SaveFollowUpPatientsPatientIdInfectionLogsInfectionLogIdFollowUpsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}/follow-ups',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Re Screen Covid
 */
export const reScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostResponses,
      ReScreenCovidPatientsPatientIdInfectionLogsInfectionLogIdReScreenPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/infection-logs/{infection_log_id}/re-screen',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * List Noa Payers
 * Return distinct payers with NOA counts, respecting the active filters.
 */
export const listNoaPayersNoasPayersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListNoaPayersNoasPayersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListNoaPayersNoasPayersGetResponses,
    ListNoaPayersNoasPayersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/payers',
    ...options,
  });
};

/**
 * List Missing Noas
 * List admissions that belong to NOA-required payers but have no NOA yet.
 */
export const listMissingNoasNoasMissingGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListMissingNoasNoasMissingGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListMissingNoasNoasMissingGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/missing',
    ...options,
  });
};

/**
 * List Noas
 * List NOAs for the current agency with optional filters.
 */
export const listNoasNoasGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListNoasNoasGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListNoasNoasGetResponses,
    ListNoasNoasGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/',
    ...options,
  });
};

/**
 * Get Noa
 * Get full NOA detail.
 */
export const getNoaNoasNoaIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetNoaNoasNoaIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetNoaNoasNoaIdGetResponses,
    GetNoaNoasNoaIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}',
    ...options,
  });
};

/**
 * Update Noa
 * Update editable fields on a NOA.
 */
export const updateNoaNoasNoaIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateNoaNoasNoaIdPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateNoaNoasNoaIdPatchResponses,
    UpdateNoaNoasNoaIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Noa 837I
 * Export a NOA as an 837I claim file (EDI text or Stedi JSON).
 *
 * Query param: format=edi (default) | format=json
 * Only allowed when status is ready_to_send or sent.
 */
export const getNoa837iNoasNoaId837iGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetNoa837iNoasNoaId837iGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetNoa837iNoasNoaId837iGetResponses,
    GetNoa837iNoasNoaId837iGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/837i',
    ...options,
  });
};

/**
 * Get Noa Ub04 Pdf
 * Export a NOA as a filled UB-04 (CMS-1450) PDF.
 *
 * Generates the PDF on demand by overlaying NOA claim data onto the
 * standard UB-04 template. Available for ready_to_send, sent, or paid NOAs.
 */
export const getNoaUb04PdfNoasNoaIdUb04Get = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetNoaUb04PdfNoasNoaIdUb04GetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetNoaUb04PdfNoasNoaIdUb04GetResponses,
    GetNoaUb04PdfNoasNoaIdUb04GetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/noas/{noa_id}/ub04',
    ...options,
  });
};

/**
 * Submit Noa 837I
 * Submit a NOA as an 837I claim to Stedi electronically.
 *
 * Only allowed when status is ready_to_send. Marks the NOA as sent on success
 * and stores the Stedi correlation ID in claim_number.
 */
export const submitNoa837iNoasNoaIdSubmitPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitNoa837iNoasNoaIdSubmitPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitNoa837iNoasNoaIdSubmitPostResponses,
    SubmitNoa837iNoasNoaIdSubmitPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/submit',
    ...options,
  });
};

/**
 * Set Primary Diagnosis
 * Set the primary diagnosis code on the episode associated with this NOA.
 */
export const setPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchResponses,
    SetPrimaryDiagnosisNoasNoaIdPrimaryDiagnosisPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/primary-diagnosis',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Validate Noa
 * Re-run validation and update status (not_ready <-> ready_to_send).
 */
export const validateNoaNoasNoaIdValidatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ValidateNoaNoasNoaIdValidatePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ValidateNoaNoasNoaIdValidatePostResponses,
    ValidateNoaNoasNoaIdValidatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/validate',
    ...options,
  });
};

/**
 * Send Noa
 * Mark a NOA as sent. Only allowed from ready_to_send status.
 */
export const sendNoaNoasNoaIdSendPost = <ThrowOnError extends boolean = false>(
  options: Options<SendNoaNoasNoaIdSendPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SendNoaNoasNoaIdSendPostResponses,
    SendNoaNoasNoaIdSendPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/send',
    ...options,
  });
};

/**
 * Mark Not Applicable
 * Mark a NOA as not applicable.
 */
export const markNotApplicableNoasNoaIdMarkNotApplicablePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostResponses,
    MarkNotApplicableNoasNoaIdMarkNotApplicablePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-not-applicable',
    ...options,
  });
};

/**
 * Mark Paid
 * Mark a sent NOA as paid.
 */
export const markPaidNoasNoaIdMarkPaidPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkPaidNoasNoaIdMarkPaidPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MarkPaidNoasNoaIdMarkPaidPostResponses,
    MarkPaidNoasNoaIdMarkPaidPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-paid',
    ...options,
  });
};

/**
 * Mark Sent
 * Revert a paid or not-applicable NOA back to sent.
 */
export const markSentNoasNoaIdMarkSentPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkSentNoasNoaIdMarkSentPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    MarkSentNoasNoaIdMarkSentPostResponses,
    MarkSentNoasNoaIdMarkSentPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/mark-sent',
    ...options,
  });
};

/**
 * Revert To Not Ready
 * Revert a not-applicable NOA back to not_ready.
 */
export const revertToNotReadyNoasNoaIdRevertToNotReadyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostResponses,
    RevertToNotReadyNoasNoaIdRevertToNotReadyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/{noa_id}/revert-to-not-ready',
    ...options,
  });
};

/**
 * Bulk Send
 * Bulk mark NOAs as sent (manual submission path — does NOT call Stedi).
 *
 * Only processes NOAs in ready_to_send status; others are silently skipped.
 * For electronic Stedi submission use POST /{noa_id}/submit instead.
 */
export const bulkSendNoasBulkSendPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkSendNoasBulkSendPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    BulkSendNoasBulkSendPostResponses,
    BulkSendNoasBulkSendPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/bulk-send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Noa For Admission
 * Create a NOA for an admission (idempotent).
 */
export const createNoaForAdmissionNoasAdmissionsAdmissionIdNoaPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostResponses,
    CreateNoaForAdmissionNoasAdmissionsAdmissionIdNoaPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/noas/admissions/{admission_id}/noa',
    ...options,
  });
};

/**
 * List Cahps Exports
 */
export const listCahpsExportsCahpsExportsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListCahpsExportsCahpsExportsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListCahpsExportsCahpsExportsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/cahps-exports',
    ...options,
  });
};

/**
 * Generate Cahps Export
 */
export const generateCahpsExportCahpsExportsGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GenerateCahpsExportCahpsExportsGeneratePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateCahpsExportCahpsExportsGeneratePostResponses,
    GenerateCahpsExportCahpsExportsGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/cahps-exports/generate',
    ...options,
  });
};

/**
 * Download Cahps Export
 */
export const downloadCahpsExportCahpsExportsExportIdDownloadGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DownloadCahpsExportCahpsExportsExportIdDownloadGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    DownloadCahpsExportCahpsExportsExportIdDownloadGetResponses,
    DownloadCahpsExportCahpsExportsExportIdDownloadGetErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/cahps-exports/{export_id}/download',
    ...options,
  });
};

/**
 * Query Dashboard
 * Return only the requested dashboard widgets.
 */
export const queryDashboard = <ThrowOnError extends boolean = false>(
  options: Options<QueryDashboardData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    QueryDashboardResponses,
    QueryDashboardErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dashboard/query',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Cms485 Oasis Visits
 * Return OASIS visits eligible to source a CMS-485, earliest first.
 *
 * Eligibility follows Kinnser's plan-of-care window
 * (``app.services.cms485_oasis_eligibility``): the first ``+/- 10 days``
 * of the current episode plus the trailing ``10`` days of the previous
 * episode, restricted to non-discharge OASIS assessments.
 */
export const listCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetResponses,
    ListCms485OasisVisitsPatientsPatientIdCms485OasisVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/cms485/oasis-visits',
    ...options,
  });
};

/**
 * Get Cms485 Prefill
 * Return CMS-485 fields prefilled from an OASIS visit of the episode.
 *
 * Fields are sourced from visit_data JSONB using stable QID keys. If no OASIS
 * visit exists yet, all fields are returned empty so the dialog still opens cleanly.
 */
export const getCms485PrefillPatientsPatientIdCms485PrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCms485PrefillPatientsPatientIdCms485PrefillGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetCms485PrefillPatientsPatientIdCms485PrefillGetResponses,
    GetCms485PrefillPatientsPatientIdCms485PrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/cms485/prefill',
    ...options,
  });
};

/**
 * List Pho Roc Visits
 * Return ROC OASIS visits eligible to source a Post Hospital Order, earliest first.
 *
 * Eligibility: ROC assessments (``ROC``, ``ROCPT``, ``ROCOT``, ``ROCST``) on the
 * order's current episode only. Each ROC may link to at most one PHO in the episode.
 */
export const listPhoRocVisitsPatientsPatientIdPhoRocVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetResponses,
    ListPhoRocVisitsPatientsPatientIdPhoRocVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/pho/roc-visits',
    ...options,
  });
};

/**
 * Get Episode
 * Fetch an episode by ID.
 */
export const getEpisodeEpisodesEpisodeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetEpisodeEpisodesEpisodeIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeEpisodesEpisodeIdGetResponses,
    GetEpisodeEpisodesEpisodeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}',
    ...options,
  });
};

/**
 * Update Episode
 * Update episode core properties (dates/status) and/or RCD participation fields.
 *
 * ``acknowledge_warnings`` is a query parameter (not a schema field) so the schema's
 * field set maps one-to-one to episode columns for the audit diff and bulk update.
 */
export const updateEpisodeEpisodesEpisodeIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateEpisodeEpisodesEpisodeIdPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateEpisodeEpisodesEpisodeIdPatchResponses,
    UpdateEpisodeEpisodesEpisodeIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Episode Worksheet
 * Return the agency-scoped episode worksheet, creating it if missing.
 */
export const getEpisodeWorksheetEpisodesEpisodeIdWorksheetGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetResponses,
    GetEpisodeWorksheetEpisodesEpisodeIdWorksheetGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/worksheet',
    ...options,
  });
};

/**
 * Update Episode Worksheet
 * Replace the agency-scoped episode worksheet. Always editable.
 *
 * Full-replace (PUT): the body carries the complete worksheet, so the
 * accident/employer rule is validated against the payload directly and every
 * editable column is overwritten.
 */
export const updateEpisodeWorksheetEpisodesEpisodeIdWorksheetPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutResponses,
    UpdateEpisodeWorksheetEpisodesEpisodeIdWorksheetPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/worksheet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Batch Print Episode Tasks
 * Assemble a chart record from selected episode tasks as a ZIP or merged PDF.
 *
 * Two passes, run sequentially (the session is not ``gather``-safe):
 *
 * 1. **Validate-all (fail-fast):** every referenced task must load in the
 * current agency *and* belong to ``episode_id``. Any miss → 404 for the
 * whole request — a mismatch is an integrity/tamper signal, not a
 * per-task placeholder.
 * 2. **Render-each (partial-success):** each validated task renders via the
 * same single-task renderer its own PDF route uses. A render failure is
 * swapped for a self-identifying placeholder page and logged; the bundle
 * still returns 200 so one bad task never sinks the export.
 *
 * Read-only — no ``db.commit()``.
 */
export const batchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostResponses,
    BatchPrintEpisodeTasksEpisodesEpisodeIdTasksBatchPrintPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/episodes/{episode_id}/tasks/batch-print',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Episode Lupa
 * Per-30-day-period LUPA threshold and billable-visit count for an episode.
 */
export const getEpisodeLupa = <ThrowOnError extends boolean = false>(
  options: Options<GetEpisodeLupaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeLupaResponses,
    GetEpisodeLupaErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/lupa',
    ...options,
  });
};

/**
 * Sync Episode Date To Visit
 * Move an episode boundary to follow a boundary-defining visit's new date.
 *
 * Rescheduling a Start of Care / Recertification visit updates the episode start
 * date; a Discharge / Transfer / Death visit updates the end date. The visit and
 * the episode move together in one transaction so the visit reschedule (which
 * otherwise rejects a date outside the current window) always lands inside the
 * new window. Standard episode rules still apply: end after start, the 60-day
 * maximum, overlap, locked billing, and the stranded-record impact confirmation
 * (``acknowledge_warnings``).
 *
 * This route is intentionally separate from the general episode edit so it can be
 * authorized as a visit reschedule for users who may not edit episode dates
 * directly.
 */
export const syncEpisodeDateToVisit = <ThrowOnError extends boolean = false>(
  options: Options<SyncEpisodeDateToVisitData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    SyncEpisodeDateToVisitResponses,
    SyncEpisodeDateToVisitErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/sync-date-to-visit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Episode Assignments
 * Update physician, case manager, and/or insurance on an episode.
 */
export const updateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchResponses,
    UpdateEpisodeAssignmentsEpisodesEpisodeIdAssignmentsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Episode
 * Create a new Episode on the patient's latest open Admission.
 */
export const createEpisode = <ThrowOnError extends boolean = false>(
  options: Options<CreateEpisodeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEpisodeResponses,
    CreateEpisodeErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Episode Authorizations
 */
export const listEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetResponses,
    ListEpisodeAuthorizationsEpisodesEpisodeIdAuthorizationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/',
    ...options,
  });
};

/**
 * Create Episode Authorization
 */
export const createEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostResponses,
    CreateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Authorization Errors
 * Return authorization compliance errors for an episode (ROG-2787).
 *
 * Placed before ``/{authorization_id}`` so the literal path segment ``errors``
 * is not captured as a UUID path parameter.
 */
export const getAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetResponses,
    GetAuthorizationErrorsEpisodesEpisodeIdAuthorizationsErrorsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/authorizations/errors',
    ...options,
  });
};

/**
 * Get Authorization Evaluation
 * Return authorization utilization, links, and suggested assignments.
 */
export const getAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetResponses,
      GetAuthorizationEvaluationEpisodesEpisodeIdAuthorizationsEvaluationGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/evaluation',
      ...options,
    });
  };

/**
 * Delete Episode Authorization
 */
export const deleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteResponses,
      DeleteEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
    });
  };

/**
 * Get Episode Authorization
 */
export const getEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetResponses,
      GetEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
    });
  };

/**
 * Update Episode Authorization
 */
export const updateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutResponses,
      UpdateEpisodeAuthorizationEpisodesEpisodeIdAuthorizationsAuthorizationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/authorizations/{authorization_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * List Episode Frequencies
 */
export const listEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetResponses,
    ListEpisodeFrequenciesEpisodesEpisodeIdFrequenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/',
    ...options,
  });
};

/**
 * Create Episode Frequency
 */
export const createEpisodeFrequencyEpisodesEpisodeIdFrequenciesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostResponses,
    CreateEpisodeFrequencyEpisodesEpisodeIdFrequenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Episode Frequency
 */
export const deleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteResponses,
      DeleteEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdDeleteErrors,
      ThrowOnError
    >({
      url: '/episodes/{episode_id}/frequencies/{frequency_id}',
      ...options,
    });
  };

/**
 * Get Episode Frequency
 */
export const getEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetResponses,
    GetEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/episodes/{episode_id}/frequencies/{frequency_id}',
    ...options,
  });
};

/**
 * Update Episode Frequency
 */
export const updateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutResponses,
      UpdateEpisodeFrequencyEpisodesEpisodeIdFrequenciesFrequencyIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/episodes/{episode_id}/frequencies/{frequency_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * List Fall Logs
 */
export const listFallLogsPatientsPatientIdFallLogsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListFallLogsPatientsPatientIdFallLogsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListFallLogsPatientsPatientIdFallLogsGetResponses,
    ListFallLogsPatientsPatientIdFallLogsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/',
    ...options,
  });
};

/**
 * Create Fall Log Endpoint
 */
export const createFallLogEndpointPatientsPatientIdFallLogsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateFallLogEndpointPatientsPatientIdFallLogsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateFallLogEndpointPatientsPatientIdFallLogsPostResponses,
    CreateFallLogEndpointPatientsPatientIdFallLogsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Fall Log Endpoint
 */
export const deleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteResponses,
    DeleteFallLogEndpointPatientsPatientIdFallLogsFallLogIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}/fall-logs/{fall_log_id}',
    ...options,
  });
};

/**
 * Update Fall Log Endpoint
 */
export const updateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutResponses,
    UpdateFallLogEndpointPatientsPatientIdFallLogsFallLogIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/fall-logs/{fall_log_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Episodes For Patient
 * List a patient's episodes and whether a new one can be added.
 */
export const listEpisodesForPatient = <ThrowOnError extends boolean = false>(
  options: Options<ListEpisodesForPatientData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListEpisodesForPatientResponses,
    ListEpisodesForPatientErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/episodes',
    ...options,
  });
};

/**
 * List Clinic Physicians
 * List active clinic physicians for a clinic.
 */
export const listClinicPhysiciansAdminClinicPhysiciansGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListClinicPhysiciansAdminClinicPhysiciansGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListClinicPhysiciansAdminClinicPhysiciansGetResponses,
    ListClinicPhysiciansAdminClinicPhysiciansGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/',
    ...options,
  });
};

/**
 * Create Clinic Physician
 * Create a new clinic physician.
 */
export const createClinicPhysicianAdminClinicPhysiciansPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateClinicPhysicianAdminClinicPhysiciansPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateClinicPhysicianAdminClinicPhysiciansPostResponses,
    CreateClinicPhysicianAdminClinicPhysiciansPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Duplicate Clinic Physicians
 * Copy every physician from a source clinic onto a destination clinic.
 *
 * Useful when onboarding a clinic that should reuse the physician roster of
 * another (e.g. copying from a scraped Kinnser clinic onto a Roger-only
 * clinic). Destination must not participate in Kinnser. Physicians whose NPI
 * already exists on the destination clinic — or that have no NPI — are
 * skipped, so the operation is safe to re-run.
 *
 * Only available when the agency has is_rogeremr_enabled=True. Both clinics
 * must belong to the agency.
 */
export const duplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostResponses,
    DuplicateClinicPhysiciansAdminClinicPhysiciansDuplicatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Clinic Physician
 * Soft-delete a clinic physician. 409 if referenced by an episode, intake, or communication.
 */
export const deleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteResponses,
      DeleteClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdDeleteErrors,
      ThrowOnError
    >({
      url: '/admin/clinic-physicians/{clinic_physician_id}',
      ...options,
    });
  };

/**
 * Update Clinic Physician
 * Update a clinic physician.
 */
export const updateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutResponses,
    UpdateClinicPhysicianAdminClinicPhysiciansClinicPhysicianIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/clinic-physicians/{clinic_physician_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Order Manager Counts
 * Return order counts for each Order Manager tab.
 */
export const getOrderManagerCountsOrdersManagerCountsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOrderManagerCountsOrdersManagerCountsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrderManagerCountsOrdersManagerCountsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/manager/counts',
    ...options,
  });
};

/**
 * Get Order Type Options
 * Return the list of order type IDs with display names + signature flag.
 *
 * Mirrors ``/visits/type-options``. The frontend merges both lists for the
 * create-task UI. Excludes generated-only types (e.g. MEDICATION_ORDER) that
 * POST /orders rejects — those flow through their own workflows.
 */
export const getOrderTypeOptionsOrdersTypeOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOrderTypeOptionsOrdersTypeOptionsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOrderTypeOptionsOrdersTypeOptionsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/type-options',
    ...options,
  });
};

/**
 * Get Order Manager Items
 * List orders for the Order Manager, filtered by status.
 */
export const getOrderManagerItemsOrdersManagerGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrderManagerItemsOrdersManagerGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderManagerItemsOrdersManagerGetResponses,
    GetOrderManagerItemsOrdersManagerGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/manager',
    ...options,
  });
};

/**
 * Get Order Cms485 Prefill
 * Return CMS-485 prefill fields for this order's episode and a chosen OASIS visit.
 *
 * Resolves the order's episode and patient automatically so the frontend can
 * request prefill using only the order id plus the linked OASIS visit id.
 */
export const getOrderCms485PrefillOrdersOrderIdCms485PrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetResponses,
    GetOrderCms485PrefillOrdersOrderIdCms485PrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/cms485-prefill',
    ...options,
  });
};

/**
 * Get Order Cms485 Form
 * Return the full CMS-485 form snapshot for rendering the order form.
 */
export const getOrderCms485FormOrdersOrderIdCms485FormGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderCms485FormOrdersOrderIdCms485FormGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderCms485FormOrdersOrderIdCms485FormGetResponses,
    GetOrderCms485FormOrdersOrderIdCms485FormGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/cms485-form',
    ...options,
  });
};

/**
 * Get Order Pho Prefill
 * Return prefill fields for a Post Hospital Order from a ROC visit.
 *
 * Uses the same OASIS extraction logic as CMS-485 since ROC assessments
 * contain the same clinical data fields.
 */
export const getOrderPhoPrefillOrdersOrderIdPhoPrefillGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetResponses,
    GetOrderPhoPrefillOrdersOrderIdPhoPrefillGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/pho-prefill',
    ...options,
  });
};

/**
 * Checkout Order
 * Send a completed order (Order Manager checkout).
 *
 * Branches on the order type's signature_required flag:
 * - True  → SENT_TO_PHYSICIAN (awaits physician sign-back via checkin_order)
 * - False → SENT_NO_SIGNATURE_REQUIRED (terminal; no checkin step)
 */
export const checkoutOrderOrdersOrderIdCheckoutPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckoutOrderOrdersOrderIdCheckoutPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckoutOrderOrdersOrderIdCheckoutPostResponses,
    CheckoutOrderOrdersOrderIdCheckoutPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/checkout',
    ...options,
  });
};

/**
 * Checkin Order
 * Mark a sent order as returned with physician signature.
 *
 * Only valid for signature-required order types; rejects others with 409.
 */
export const checkinOrderOrdersOrderIdCheckinPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckinOrderOrdersOrderIdCheckinPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckinOrderOrdersOrderIdCheckinPostResponses,
    CheckinOrderOrdersOrderIdCheckinPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}/checkin',
    ...options,
  });
};

/**
 * Delete Order
 * Delete an order by ID.
 */
export const deleteOrderOrdersOrderIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteOrderOrdersOrderIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteOrderOrdersOrderIdDeleteResponses,
    DeleteOrderOrdersOrderIdDeleteErrors,
    ThrowOnError
  >({
    url: '/orders/{order_id}',
    ...options,
  });
};

/**
 * Get Order
 * Get a single order by ID.
 */
export const getOrderOrdersOrderIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderOrdersOrderIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderOrdersOrderIdGetResponses,
    GetOrderOrdersOrderIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}',
    ...options,
  });
};

/**
 * Update Order
 * Update order fields and/or the JSONB `order_data` payload.
 *
 * This is the single edit endpoint used by both the Order Manager (admin
 * actions: status, scheduling, sent_to_physician_date) and the order forms
 * (form saves: order_text/date/time/summary, order_data). Form saves are
 * distinguished by `order_data` being present in the request and get extra
 * handling: OCC against `order_data_last_updated`, merge into JSONB,
 * auto-advance NOT_STARTED -> SAVED.
 */
export const updateOrderOrdersOrderIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateOrderOrdersOrderIdPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateOrderOrdersOrderIdPatchResponses,
    UpdateOrderOrdersOrderIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/{order_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Order Pdf
 * Return the canonical print/download PDF for a single order.
 *
 * Resolves the right artifact by order type:
 *
 * * A signed CMS-485 returns its stored signed form (streamed from S3); an
 * unsigned CMS-485 renders the live CMS-485 preview PDF.
 * * Every other order renders the generic metadata view (type, dates,
 * physician, case manager, plus order text/summary/notes).
 *
 * This is the single entry point both the episode-manager task table and the
 * order detail panel call, so the same gesture yields the same document
 * everywhere. Returns the PDF inline so the client can open it in a new tab.
 */
export const getOrderPdfOrdersOrderIdPdfGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetOrderPdfOrdersOrderIdPdfGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetOrderPdfOrdersOrderIdPdfGetResponses,
    GetOrderPdfOrdersOrderIdPdfGetErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/orders/{order_id}/pdf',
    ...options,
  });
};

/**
 * Create Order
 * Create a new order.
 *
 * Provide either ``episode_id`` or ``patient_id`` in the request body.
 * When ``patient_id`` is given the order is attached to the patient's most
 * recent episode.
 */
export const createOrderOrdersPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrderOrdersPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateOrderOrdersPostResponses,
    CreateOrderOrdersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/orders/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get My Tasks
 * Get the current user's Hotbox work queue (visits and orders).
 */
export const getMyTasksTasksMyTasksGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyTasksTasksMyTasksGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMyTasksTasksMyTasksGetResponses,
    GetMyTasksTasksMyTasksGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/my-tasks',
    ...options,
  });
};

/**
 * Get Task Documents
 * List all documents attached to a task.
 */
export const getTaskDocumentsTasksTaskIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTaskDocumentsTasksTaskIdDocumentsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTaskDocumentsTasksTaskIdDocumentsGetResponses,
    GetTaskDocumentsTasksTaskIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/documents',
    ...options,
  });
};

/**
 * Upload Task Document
 * Upload a document and attach it to a task.
 */
export const uploadTaskDocumentTasksTaskIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadTaskDocumentTasksTaskIdDocumentsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UploadTaskDocumentTasksTaskIdDocumentsPostResponses,
    UploadTaskDocumentTasksTaskIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/tasks/{task_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Get Task Document Url
 * Get a presigned URL to view/download a task document.
 */
export const getTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetResponses,
    GetTaskDocumentUrlTasksTaskIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/documents/{document_id}/url',
    ...options,
  });
};

/**
 * Delete Task Document
 * Soft-delete a document attached to a task.
 */
export const deleteTaskDocumentTasksTaskIdDocumentsDocumentIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteResponses,
    DeleteTaskDocumentTasksTaskIdDocumentsDocumentIdDeleteErrors,
    ThrowOnError
  >({
    url: '/tasks/{task_id}/documents/{document_id}',
    ...options,
  });
};

/**
 * Get Task Signatures
 * Get all signatures for a task (visit or order).
 */
export const getTaskSignaturesTasksTaskIdSignaturesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetTaskSignaturesTasksTaskIdSignaturesGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetTaskSignaturesTasksTaskIdSignaturesGetResponses,
    GetTaskSignaturesTasksTaskIdSignaturesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/signatures',
    ...options,
  });
};

/**
 * Sign Task Endpoint
 * Sign a task (visit or order) and advance its status.
 */
export const signTaskEndpointTasksTaskIdSignPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SignTaskEndpointTasksTaskIdSignPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SignTaskEndpointTasksTaskIdSignPostResponses,
    SignTaskEndpointTasksTaskIdSignPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/sign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Approve Task Endpoint
 * QA-approve a task (submitted_with_signature → completed).
 */
export const approveTaskEndpointTasksTaskIdApprovePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ApproveTaskEndpointTasksTaskIdApprovePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ApproveTaskEndpointTasksTaskIdApprovePostResponses,
    ApproveTaskEndpointTasksTaskIdApprovePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Submit Task Without Signature Endpoint
 * Advance a draft to SUBMITTED without signing it (ROG-3268).
 *
 * No e-signature password: nothing is being attested to. The signature is
 * still owed and the clinician will supply it later.
 */
export const submitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostResponses,
      SubmitTaskWithoutSignatureEndpointTasksTaskIdSubmitWithoutSignaturePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/submit-without-signature',
      ...options,
    });
  };

/**
 * Return Task To Clinician Endpoint
 * Send a chart back to the clinician without QA-approving it (ROG-3268).
 */
export const returnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostResponses,
    ReturnTaskToClinicianEndpointTasksTaskIdReturnToClinicianPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/return-to-clinician',
    ...options,
  });
};

/**
 * Verify Task Signature Endpoint
 * Verify a task signature's integrity.
 *
 * Recomputes the MAC from the stored snapshot under the stored key and
 * rebuilds the snapshot from live DB state to flag drift.
 */
export const verifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetResponses,
      VerifyTaskSignatureEndpointTasksTaskIdSignaturesSignatureIdVerifyGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/tasks/{task_id}/signatures/{signature_id}/verify',
      ...options,
    });
  };

/**
 * Break Signatures Endpoint
 * Break all signatures on a task to allow editing.
 */
export const breakSignaturesEndpointTasksTaskIdEditPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BreakSignaturesEndpointTasksTaskIdEditPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    BreakSignaturesEndpointTasksTaskIdEditPostResponses,
    BreakSignaturesEndpointTasksTaskIdEditPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/edit',
    ...options,
  });
};

/**
 * Update Task Notes
 * Update the notes (sticky note) for any task (visit or order).
 *
 * Any authenticated agency user who can access the task may update notes —
 * not only the assigned clinician or case manager. Sticky notes are shared
 * chart coordination comments visible to everyone handling the chart.
 */
export const updateTaskNotesTasksTaskIdNotesPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateTaskNotesTasksTaskIdNotesPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateTaskNotesTasksTaskIdNotesPutResponses,
    UpdateTaskNotesTasksTaskIdNotesPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/{task_id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Bulk Append Task Notes
 * Append a notes entry to multiple tasks (orders/visits).
 *
 * Each entry is prefixed with ``[YYYY-MM-DD user@email]`` and appended on a
 * new line. Any authenticated agency user who can access the tasks may use
 * this endpoint (same policy as ``update_task_notes``). The update is
 * transactional: if any task is not found, no notes are written and the
 * request fails.
 */
export const bulkAppendTaskNotesTasksNotesBulkPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BulkAppendTaskNotesTasksNotesBulkPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    BulkAppendTaskNotesTasksNotesBulkPostResponses,
    BulkAppendTaskNotesTasksNotesBulkPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/tasks/notes/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Print View For Goals
 * Get a formatted plain text summary of goals and progress for a visit.
 */
export const getPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetResponses,
    GetPrintViewForGoalsGoalsVisitPrintViewVisitIdPrintViewGetErrors,
    ThrowOnError
  >({
    responseType: 'text',
    url: '/goals/visit/print_view/{visit_id}/print_view',
    ...options,
  });
};

/**
 * Mark Patient Goal Met
 * Mark a patient goal as met for this visit. Creates or updates goal progress.
 */
export const markPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
      MarkPatientGoalMetGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_met',
      ...options,
    });
  };

/**
 * Mark Patient Goal Unattainable
 * Mark a patient goal as unattainable for this visit. Creates or updates goal progress.
 */
export const markPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
      MarkPatientGoalUnattainableGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_unattainable',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Record Goal Progress
 * Record progress on a patient goal for this visit. Creates or updates goal progress.
 */
export const recordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
      RecordGoalProgressGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/record_progress',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Perform Intervention For Visit
 * Record performance of an intervention for this visit. Creates or updates intervention progress.
 */
export const performInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
      PerformInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/perform',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Complete Intervention For Visit
 * Mark the intervention progress for this visit as complete. Same validation as perform except existing progress may already be performed.
 */
export const completeInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
      CompleteInterventionForVisitGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/complete',
      ...options,
    });
  };

/**
 * Get Patient Goals For Visit
 * Get all patient goals for the visit's episode with progress history.
 */
export const getPatientGoalsForVisitGoalsVisitVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalsForVisitGoalsVisitVisitIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientGoalsForVisitGoalsVisitVisitIdGetResponses,
    GetPatientGoalsForVisitGoalsVisitVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}',
    ...options,
  });
};

/**
 * Add Goal To Visit
 * Add a goal to a visit by creating a patient goal for the visit's episode.
 */
export const addGoalToVisitGoalsVisitVisitIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AddGoalToVisitGoalsVisitVisitIdPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AddGoalToVisitGoalsVisitVisitIdPostResponses,
    AddGoalToVisitGoalsVisitVisitIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Goal For Visit
 * Get single patient goal with progress history.
 */
export const getPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetResponses,
    GetPatientGoalForVisitGoalsVisitVisitIdGoalPatientGoalIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/goal/{patient_goal_id}',
    ...options,
  });
};

/**
 * Get Goal Template
 * Get a single goal template by id with its attached intervention templates.
 */
export const getGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetResponses,
    GetGoalTemplateGoalsVisitVisitIdTemplateGoalTemplateIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/template/{goal_template_id}',
    ...options,
  });
};

/**
 * Get Goal Templates
 * Get goal templates by ids with their attached intervention templates.
 */
export const getGoalTemplatesGoalsVisitVisitIdTemplateBatchPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostResponses,
    GetGoalTemplatesGoalsVisitVisitIdTemplateBatchPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/template/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Intervention Template
 * Get a single intervention template by id (id, name, instruction).
 */
export const getInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetResponses,
      GetInterventionTemplateGoalsVisitInterventionInterventionTemplateIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/intervention/{intervention_template_id}',
      ...options,
    });
  };

/**
 * Get Goal Options For Visit
 * Get all possible goal templates for a visit (clinic + discipline match).
 */
export const getGoalOptionsForVisitGoalsVisitVisitIdOptionsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetResponses,
    GetGoalOptionsForVisitGoalsVisitVisitIdOptionsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/options',
    ...options,
  });
};

/**
 * Get Intervention Options For Visit
 * Get all active intervention templates at the same clinic as the visit.
 */
export const getInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetResponses,
      GetInterventionOptionsForVisitGoalsVisitVisitIdInterventionOptionsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/{visit_id}/intervention/options',
      ...options,
    });
  };

/**
 * Get Interventions For Patient Goal
 * Get all interventions for a patient goal.
 */
export const getInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetResponses,
      GetInterventionsForPatientGoalGoalsVisitVisitIdInterventionPatientGoalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/visit/{visit_id}/intervention/{patient_goal_id}',
      ...options,
    });
  };

/**
 * Delete Goal From Visit
 * Delete a patient goal. Goal must belong to the visit's episode.
 */
export const deleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteResponses,
    DeleteGoalFromVisitGoalsVisitVisitIdPatientGoalIdDeleteErrors,
    ThrowOnError
  >({
    url: '/goals/visit/{visit_id}/{patient_goal_id}',
    ...options,
  });
};

/**
 * Update Goal For Visit
 * Update a patient goal for a visit (goal must belong to the visit's episode).
 */
export const updateGoalForVisitGoalsVisitVisitIdPatientGoalIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutResponses,
    UpdateGoalForVisitGoalsVisitVisitIdPatientGoalIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/{patient_goal_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Add Intervention To Visit
 * Add an intervention to a visit by creating a patient intervention for the given patient goal.
 */
export const addInterventionToVisitGoalsVisitVisitIdInterventionPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostResponses,
    AddInterventionToVisitGoalsVisitVisitIdInterventionPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/visit/{visit_id}/intervention',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Intervention From Visit
 * Delete a patient intervention. Intervention must belong to a patient goal in the visit's episode.
 */
export const deleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteResponses,
      DeleteInterventionFromVisitGoalsVisitVisitIdInterventionPatientInterventionIdDeleteErrors,
      ThrowOnError
    >({
      url: '/goals/visit/{visit_id}/intervention/{patient_intervention_id}',
      ...options,
    });
  };

/**
 * Import Goals From Rogerdocs
 * Fetch goal templates from RogerDocs and prepare them for import.
 * Fetches IDs for the target agency/clinic and parses the RogerDocs response.
 * If to_clinic is omitted, writes goals and interventions to all clinics for the agency.
 */
export const importGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostResponses,
    ImportGoalsFromRogerdocsGoalsDashboardImportFromRogerdocsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/import-from-rogerdocs',
    ...options,
  });
};

/**
 * Sync Goals For Agency
 * Sync goal and intervention templates from RogerDocs for every clinic in an agency.
 *
 * For each EMR clinic that has a clinic_key (i.e. a RogerDocs clinic_id), fetches
 * goal and intervention templates from RogerDocs and upserts them into the EMR clinic.
 * Existing records are updated in place without losing their EMR IDs; new records are
 * created. Clinics with no data in RogerDocs are logged and skipped.
 */
export const syncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostResponses,
    SyncGoalsForAgencyGoalsDashboardSyncGoalsForAgencyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/sync-goals-for-agency',
    ...options,
  });
};

/**
 * Copy Goals Between Clinics
 * HTTP wrapper around :func:`copy_goals_between_clinic_keys`.
 */
export const copyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostResponses,
      CopyGoalsBetweenClinicsGoalsDashboardCopyGoalsBetweenClinicsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/goals/dashboard/copy-goals-between-clinics',
      ...options,
    });
  };

/**
 * Bulk Upsert To Rogerdocs
 * Bulk upsert goal and intervention templates from RogerEMR to RogerDocs.
 *
 * Fetches all goal templates and intervention templates for the specified
 * agency/clinic from RogerEMR, transforms them into RogerDocs format, and
 * calls the RogerDocs /v1/worksheet-goals/bulk-upsert endpoint.
 *
 * This endpoint blindly returns or raises whatever is returned or raised
 * by the RogerDocs endpoint.
 */
export const bulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostResponses,
    BulkUpsertToRogerdocsGoalsDashboardBulkUpsertToRogerdocsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/goals/dashboard/bulk-upsert-to-rogerdocs',
    ...options,
  });
};

/**
 * Send Support Email
 * Send a support email from the EMR to the support team.
 */
export const sendSupportEmailApiSupportContactPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SendSupportEmailApiSupportContactPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SendSupportEmailApiSupportContactPostResponses,
    SendSupportEmailApiSupportContactPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/support/contact',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Preview Test Patient Cleanup
 * List ``is_test_patient`` records and related entity counts (no deletes).
 */
export const previewTestPatientCleanupAdminTestPatientsPreviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostResponses,
    PreviewTestPatientCleanupAdminTestPatientsPreviewPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/test-patients/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Test Patients
 * Hard-delete previewed test patients after token + phrase confirmation.
 */
export const deleteTestPatientsAdminTestPatientsDeletePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteTestPatientsAdminTestPatientsDeletePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    DeleteTestPatientsAdminTestPatientsDeletePostResponses,
    DeleteTestPatientsAdminTestPatientsDeletePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/admin/test-patients/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Agencies
 * List all agencies (Internal Tools only).
 */
export const getAgenciesInternalToolsAgenciesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgenciesInternalToolsAgenciesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgenciesInternalToolsAgenciesGetResponses,
    GetAgenciesInternalToolsAgenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/',
    ...options,
  });
};

/**
 * Create Agency
 * Create a new agency.
 *
 * Only allowed when the caller is a Strawhat super-user (router-level).
 */
export const createAgencyInternalToolsAgenciesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyInternalToolsAgenciesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyInternalToolsAgenciesPostResponses,
    CreateAgencyInternalToolsAgenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/agencies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Agencies With Assigned Roles
 * Paginated list of agencies for the Internal Tools admin view.
 */
export const listAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGet =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).get<
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetResponses,
      ListAgenciesWithAssignedRolesInternalToolsAgenciesWithAssignedRolesGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/agencies/with-assigned-roles',
      ...options,
    });
  };

/**
 * Remove User From Agency
 * Remove a user from an agency and delete their roles at that agency.
 */
export const removeUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteResponses,
      RemoveUserFromAgencyInternalToolsAgenciesAgencyIdUsersUserIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/agencies/{agency_id}/users/{user_id}',
      ...options,
    });
  };

/**
 * Get Onboarding Team Config
 * Return the current onboarding-team config.
 */
export const getOnboardingTeamConfigInternalToolsOnboardingTeamConfigGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetResponses,
    GetOnboardingTeamConfigInternalToolsOnboardingTeamConfigGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/',
    ...options,
  });
};

/**
 * Update Onboarding Team Config
 * Replace the onboarding-team roster and per-member role slugs.
 */
export const updateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutResponses,
    UpdateOnboardingTeamConfigInternalToolsOnboardingTeamConfigPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sync Onboarding Team
 * Add the current onboarding-team config to all existing agencies.
 */
export const syncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostResponses,
    SyncOnboardingTeamInternalToolsOnboardingTeamConfigSyncPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/onboarding-team-config/sync',
    ...options,
  });
};

/**
 * Get All Product Updates
 * Return all product updates and global images (Strawhat super-user only).
 */
export const getAllProductUpdatesInternalToolsProductUpdatesAllGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetResponses,
    GetAllProductUpdatesInternalToolsProductUpdatesAllGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal-tools/product-updates/all',
    ...options,
  });
};

/**
 * Update Product Update Entry
 * Create or update a product update (Roger internal / Strawhat super-user only).
 */
export const updateProductUpdateEntryInternalToolsProductUpdatesManagementPatch =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).patch<
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchResponses,
      UpdateProductUpdateEntryInternalToolsProductUpdatesManagementPatchErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal-tools/product-updates/management',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Upload Product Update Image
 * Upload a global product-update image (Strawhat super-user only).
 */
export const uploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostResponses,
      UploadProductUpdateImageInternalToolsProductUpdatesManagementImagesPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/internal-tools/product-updates/management/images',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Delete Product Update Image
 * Delete a global product-update image (Strawhat super-user only).
 * Does not check if anything is referencing the image, will leave it up to the UI to
 * prevent issues to improve speeds
 */
export const deleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteResponses,
      DeleteProductUpdateImageInternalToolsProductUpdatesManagementImagesImageIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/product-updates/management/images/{image_id}',
      ...options,
    });
  };

/**
 * Delete Product Update Entry
 * Delete a product update (Roger internal / Strawhat super-user only).
 */
export const deleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteResponses,
      DeleteProductUpdateEntryInternalToolsProductUpdatesManagementProductUpdateIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal-tools/product-updates/management/{product_update_id}',
      ...options,
    });
  };

/**
 * Internal Health Check
 * Health check endpoint for internal service communication.
 *
 * This endpoint is specifically for Roger Doc to verify RogerEMR API connectivity.
 */
export const internalHealthCheckInternalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InternalHealthCheckInternalHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalHealthCheckInternalHealthGetResponses,
    InternalHealthCheckInternalHealthGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/health',
    ...options,
  });
};

/**
 * Sync Clinics From Clinic Info Internal
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This is the internal version of the sync endpoint that uses internal API key authentication.
 * If agency_system_name is provided, syncs only that agency. Otherwise, syncs all agencies.
 *
 * Args:
 * agency_system_name: Optional system name of the agency to sync. If None, syncs all agencies.
 * ctx: Current context from internal service authentication
 * db: Database session
 *
 * Returns:
 * SyncClinicInfoResponse for single agency, or BulkSyncResponse for all agencies
 *
 * Raises:
 * HTTPException: If agency not found, RogerDoc API is unavailable, or database operations fail
 */
export const syncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).post<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/agency-clinics/sync-from-clinic-info',
      ...options,
    });
  };

/**
 * Ensure Current Episode Internal
 * Get or create the patient's episode that covers today (internal/testing).
 */
export const ensureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostResponses,
      EnsureCurrentEpisodeInternalInternalEpisodesEnsureCurrentPatientIdPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/episodes/ensure-current/{patient_id}',
      ...options,
    });
  };

/**
 * Get Patient Medications
 * Get all medications for a patient.
 *
 * Optionally filter out discontinued medications with include_discontinued=false.
 */
export const getPatientMedicationsInternalPatientsPatientIdMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetResponses,
    GetPatientMedicationsInternalPatientsPatientIdMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/patients/{patient_id}/medications/',
    ...options,
  });
};

/**
 * Create Patient Medication Internal
 * Create a new medication for a patient.
 *
 * For on-market medications, provide exactly one of
 * medication_external_id or fdb_dispensable_drug_id (an FDB drug is
 * materialized into the local catalog on first use).
 * For off-market medications, set is_off_market=true and provide off_market_description.
 */
export const createPatientMedicationInternalInternalPatientsPatientIdMedicationsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostResponses,
      CreatePatientMedicationInternalInternalPatientsPatientIdMedicationsPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Medication Pdf
 * Generate and return a Patient Medication Record PDF.
 *
 * Includes:
 * - Pharmacy information
 * - Medications grouped by: Future, Current, Discontinued
 * - Legend with status indicators (LS, N, C)
 * - Form sections for physician contact and medication interactions
 * - Signature section
 *
 * The PDF is dynamically generated from current medication data.
 *
 * Args:
 * patient_id: Patient UUID
 * db: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * PDF file as application/pdf response
 *
 * Raises:
 * HTTPException: If patient not found or PDF generation fails
 */
export const getMedicationPdfInternalPatientsPatientIdMedicationsPdfPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostResponses,
    GetMedicationPdfInternalPatientsPatientIdMedicationsPdfPostErrors,
    ThrowOnError
  >({
    responseType: 'blob',
    url: '/internal/patients/{patient_id}/medications/pdf',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Medication
 * Delete a medication.
 */
export const deletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteResponses,
      DeletePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });
  };

/**
 * Get Patient Medication
 * Get a specific medication by ID.
 */
export const getPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetResponses,
      GetPatientMedicationInternalPatientsPatientIdMedicationsMedicationIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });
  };

/**
 * Update Patient Medication
 * Update a medication.
 */
export const updatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutResponses,
      UpdatePatientMedicationInternalPatientsPatientIdMedicationsMedicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/medications/{medication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Visits List Internal
 * Get list of visits for the authenticated user within date range (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch scheduled visits
 * for a clinician within a specified date range.
 *
 * Args:
 * start_date: Start date in YYYY-MM-DD format
 * end_date: End date in YYYY-MM-DD format
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visits array for the date range
 *
 * Raises:
 * HTTPException: If dates are invalid or no access to visits
 */
export const getVisitsListInternalInternalVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitsListInternalInternalVisitsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitsListInternalInternalVisitsGetResponses,
    GetVisitsListInternalInternalVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
  });
};

/**
 * Create Visit Internal
 * Create a new visit (internal service authentication).
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitInternalInternalVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateVisitInternalInternalVisitsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitInternalInternalVisitsPostResponses,
    CreateVisitInternalInternalVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Visit Internal
 * Delete a visit (internal/testing). Locked visits cannot be deleted.
 */
export const deleteVisitInternalInternalVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteVisitInternalInternalVisitsVisitIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteVisitInternalInternalVisitsVisitIdDeleteResponses,
    DeleteVisitInternalInternalVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({
    url: '/internal/visits/{visit_id}',
    ...options,
  });
};

/**
 * Get Visit Internal
 * Get a specific visit by ID (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitInternalInternalVisitsVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitInternalInternalVisitsVisitIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitInternalInternalVisitsVisitIdGetResponses,
    GetVisitInternalInternalVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
  });
};

/**
 * Update Visit Internal
 * Update visit basic information (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitInternalInternalVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitInternalInternalVisitsVisitIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitInternalInternalVisitsVisitIdPutResponses,
    UpdateVisitInternalInternalVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Data Internal
 * Get only the visit_data for a specific visit (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch existing form data
 * before processing new voice recordings.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataInternalInternalVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitDataInternalInternalVisitsVisitIdDataGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
    GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
  });
};

/**
 * Update Visit Data Internal
 * Update visit data with optimistic concurrency control (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to submit form responses
 * after AI processing of voice recordings.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataInternalInternalVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Active Diagnoses Data Internal
 * Update active diagnoses comorbidity data (M1028) for a visit (internal).
 */
export const updateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutResponses,
      UpdateActiveDiagnosesDataInternalInternalVisitsVisitIdActiveDiagnosesDataPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/{visit_id}/active-diagnoses-data',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Push Visit Evv Internal
 * Ingest a visit's EVV bundle pushed from Roger Doc (EMR-325).
 *
 * The clinician captures EVV (clock in/out, GPS, patient signature) in the
 * nursing app; Roger Doc pushes the whole bundle here when it fills the visit.
 * We store the clock readings and download each signature image into the EMR's
 * own bucket so the EMR owns its copy of a compliance artifact.
 *
 * Idempotent: clock readings are upserted and signatures are keyed by their
 * Roger Doc S3 key, so re-pushing the same bundle creates no duplicates and
 * re-downloads nothing. A clock event absent from the payload leaves any
 * previously stored value alone — Roger Doc only ever adds clock readings.
 *
 * Per-signature failures land in `errors` and do not fail the request: a
 * signature we could not fetch must not cost us the clock readings.
 */
export const pushVisitEvvInternalInternalVisitsVisitIdEvvPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutResponses,
    PushVisitEvvInternalInternalVisitsVisitIdEvvPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/evv',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Mark Patient Goal Met Internal
 * Mark a patient goal as met (internal service authentication).
 */
export const markPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostResponses,
      MarkPatientGoalMetInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkMetPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_met',
      ...options,
    });
  };

/**
 * Mark Patient Goal Unattainable Internal
 * Mark a patient goal as unattainable (internal service authentication).
 */
export const markPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostResponses,
      MarkPatientGoalUnattainableInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdMarkUnattainablePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/mark_unattainable',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Record Goal Progress Internal
 * Record progress on a patient goal (internal service authentication).
 */
export const recordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostResponses,
      RecordGoalProgressInternalInternalGoalsVisitProgressVisitIdProgressPatientGoalIdRecordProgressPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_goal_id}/record_progress',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Perform Intervention For Visit Internal
 * Record performance of an intervention (internal service authentication).
 */
export const performInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostResponses,
      PerformInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdPerformPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/perform',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Complete Intervention For Visit Internal
 * Mark an intervention as complete (internal service authentication).
 */
export const completeInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostResponses,
      CompleteInterventionForVisitInternalInternalGoalsVisitProgressVisitIdProgressPatientInterventionIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/progress/{visit_id}/progress/{patient_intervention_id}/complete',
      ...options,
    });
  };

/**
 * Get Patient Goals For Visit
 * Get all patient goals for a visit with progress history and interventions.
 */
export const getPatientGoalsForVisitInternalGoalsVisitVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetResponses,
    GetPatientGoalsForVisitInternalGoalsVisitVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/goals/visit/{visit_id}',
    ...options,
  });
};

/**
 * Add Goal To Visit By External Id
 * Add a goal to a visit using goal_external_id. Add interventions separately.
 */
export const addGoalToVisitByExternalIdInternalGoalsVisitVisitIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostResponses,
    AddGoalToVisitByExternalIdInternalGoalsVisitVisitIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/goals/visit/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Goal Template By External Id
 * Get a single goal template by external_id with its attached intervention templates.
 */
export const getGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetResponses,
      GetGoalTemplateByExternalIdInternalGoalsVisitVisitIdTemplateGoalExternalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/template/{goal_external_id}',
      ...options,
    });
  };

/**
 * Get Goal Templates By External Ids
 * Get goal templates by external_ids with their attached intervention templates.
 */
export const getGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostResponses,
      GetGoalTemplatesByExternalIdsInternalGoalsVisitVisitIdTemplateBatchPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/template/batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Intervention Template By External Id
 * Get a single intervention template by external_id.
 */
export const getInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetResponses,
      GetInterventionTemplateByExternalIdInternalGoalsVisitInterventionInterventionExternalIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/intervention/{intervention_external_id}',
      ...options,
    });
  };

/**
 * Add Intervention To Visit By External Id
 * Add an intervention to a visit using intervention_external_id.
 */
export const addInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostResponses,
      AddInterventionToVisitByExternalIdInternalGoalsVisitVisitIdInterventionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/goals/visit/{visit_id}/intervention',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Patient Documents Internal
 */
export const getPatientDocumentsInternalInternalPatientsPatientIdDocumentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetResponses,
      GetPatientDocumentsInternalInternalPatientsPatientIdDocumentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/documents',
      ...options,
    });
  };

/**
 * Get Patient Document Url Internal
 */
export const getPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
      GetPatientDocumentUrlInternalInternalPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/patients/{patient_id}/documents/{document_id}/url',
      ...options,
    });
  };

/**
 * List Visit Diagnoses Internal
 */
export const listVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetResponses,
    ListVisitDiagnosesInternalInternalVisitsVisitIdDiagnosesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/diagnoses',
    ...options,
  });
};

/**
 * Create Visit Diagnosis Internal
 */
export const createVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostResponses,
    CreateVisitDiagnosisInternalInternalVisitsVisitIdDiagnosesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/diagnoses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Visit Diagnosis Internal
 */
export const deleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteResponses,
      DeleteVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdDeleteErrors,
      ThrowOnError
    >({
      url: '/internal/visits/diagnoses/{diagnosis_id}',
      ...options,
    });
  };

/**
 * Update Visit Diagnosis Internal
 */
export const updateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutResponses,
      UpdateVisitDiagnosisInternalInternalVisitsDiagnosesDiagnosisIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/diagnoses/{diagnosis_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Update Diagnosis Positions Internal
 */
export const updateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutResponses,
      UpdateDiagnosisPositionsInternalInternalVisitsVisitIdDiagnosesPositionsPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/visits/{visit_id}/diagnoses/positions',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Generate Test Data
 * Generate test data for a specific agency.
 *
 * Creates patients, admissions, episodes, and visits.
 * Test patients are marked with a special email pattern for later deletion.
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 *
 * Note: Visits and episodes are assigned a deterministic seed clinician (one
 * per clinic, reused from the billing lifecycle seeder) when the agency has
 * clinics; clinic-less agencies skip assignment.
 */
export const generateTestDataDevTestDataGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateTestDataDevTestDataGeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateTestDataDevTestDataGeneratePostResponses,
    GenerateTestDataDevTestDataGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Clear Test Data
 * Clear test data for a specific agency.
 *
 * Identifies test patients by their email pattern (test-*@test.roger-emr.internal)
 * and deletes them along with all associated data (admissions, episodes, visits).
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 */
export const clearTestDataDevTestDataClearDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClearTestDataDevTestDataClearDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ClearTestDataDevTestDataClearDeleteResponses,
    ClearTestDataDevTestDataClearDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/clear',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Hard
 * Hard-delete a single patient and all associated data.
 *
 * Cascades through: visits, orders, patient communications, tasks,
 * episodes, notices of admission, admissions, documents, claims,
 * billing cycles, goals, medications, allergies, wounds, intakes,
 * and the patient record itself.
 *
 * Requires an authenticated session — the caller's agency scopes the
 * lookup, so a patient in a different agency returns 404. The ORM's
 * automatic agency filter (set up by ``get_current_ctx``) constrains
 * every query and bulk-delete in this handler to the caller's agency.
 *
 * SECURITY WARNING: Only available in non-production environments!
 * Intended for e2e test cleanup.
 */
export const deletePatientHardDevTestDataPatientPatientIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientHardDevTestDataPatientPatientIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientHardDevTestDataPatientPatientIdDeleteResponses,
    DeletePatientHardDevTestDataPatientPatientIdDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/patient/{patient_id}',
    ...options,
  });
};

/**
 * Import Kinnser Patient Portfolio
 * Create the NOA-relevant chart for one Kinnser admission.
 *
 * Creates patient, admission, patient insurance, the admission's first
 * episode (with its worksheet condition/occurrence codes), a completed SOC
 * OASIS visit shell, and the Notice of Admission when the target insurance
 * requires one — then reports the NOA's own validation result.
 *
 * Nothing is matched by name and no configuration is created: the clinic,
 * agency insurance, and attending physician must already exist and are named
 * by id in ``target``.
 *
 * SECURITY WARNING: Only available in non-production environments. Guarded by
 * the same strict check as patient hard-delete (never allowlisted for a prod
 * demo agency) because ``options.reset`` can hard-delete a real patient.
 */
export const importKinnserPatientPortfolioDevTestDataKinnserImportPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostResponses,
    ImportKinnserPatientPortfolioDevTestDataKinnserImportPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/kinnser-import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Run Demo Agency Setup Endpoint
 * Run the GTM demo agency setup orchestrator for the named agency.
 */
export const runDemoAgencySetupEndpointDemoAgencySetupPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RunDemoAgencySetupEndpointDemoAgencySetupPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    RunDemoAgencySetupEndpointDemoAgencySetupPostResponses,
    RunDemoAgencySetupEndpointDemoAgencySetupPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/demo-agency-setup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Root
 * Root endpoint
 */
export const rootGet = <ThrowOnError extends boolean = false>(
  options?: Options<RootGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    RootGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/',
    ...options,
  });
};
